"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7058],{

/***/ 2828:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ Agent; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(51438);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(30381);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _components_util_all__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(40488);



var Agent = function Agent() {
    "use strict";
    var model = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(this, Agent);
    this.id = model.id || null;
    this.name = model.name || null;
    this.email = model.email || null;
    this.phone = model.phone || null;
    this.clientId = model.clientId || null;
    this.logo = this.id && model.clientId && model.logo ? "".concat("https://cdn.treedis.com", "/clients/").concat(model.clientId, "/agents/").concat(this.id, "/logo.png").concat((0,_components_util_all__WEBPACK_IMPORTED_MODULE_1__/* .getVersion */ .bo)(this.updatedAt)) : null;
    this.widthLogo = model.widthLogo || false;
    this.agentTours = model.agentTours || [];
    this.updatedAt = model.updatedAt ? moment__WEBPACK_IMPORTED_MODULE_0___default()(model.updatedAt) : moment__WEBPACK_IMPORTED_MODULE_0___default()();
    this.permissionId = model.permissionId || null;
    this.agentPermission = model.agentPermission || null;
};


/***/ }),

/***/ 41292:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ Res; },
/* harmony export */   "u": function() { return /* binding */ PaymentType; }
/* harmony export */ });
var Res;
(function(Res) {
    Res["Percentage"] = "percentage";
    Res["Pixels"] = "pixels";
})(Res || (Res = {}));
var PaymentType;
(function(PaymentType) {
    PaymentType["Paypal"] = "paypal";
    PaymentType["Card"] = "card";
    PaymentType["External"] = "external";
    PaymentType["NoPaid"] = "noPaid";
    PaymentType["Stripe"] = "stripe";
})(PaymentType || (PaymentType = {}));


/***/ }),

/***/ 81766:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ LockLocationType; },
/* harmony export */   "BY": function() { return /* binding */ EMPTY_LOCATION_ITEM; },
/* harmony export */   "CP": function() { return /* binding */ ConditionType; },
/* harmony export */   "FJ": function() { return /* binding */ GameTimerType; },
/* harmony export */   "Gn": function() { return /* binding */ LockType; },
/* harmony export */   "JK": function() { return /* binding */ LocationSrc; },
/* harmony export */   "KO": function() { return /* binding */ GameLockPathTransitionType; },
/* harmony export */   "LV": function() { return /* binding */ Res; },
/* harmony export */   "Tl": function() { return /* binding */ LOCK_SOLUTION_SEPARATOR; },
/* harmony export */   "Xr": function() { return /* binding */ ScoreType; },
/* harmony export */   "lA": function() { return /* binding */ Game; },
/* harmony export */   "py": function() { return /* binding */ EntityType; },
/* harmony export */   "zc": function() { return /* binding */ ContentType; }
/* harmony export */ });
/* unused harmony exports LockLocationTypeLabel, HintContentType, FinishScreenTemplate, GameGeneral, GameCondition, GameLockQuestion, GameLockPath, GameLock, GameHint */
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(51438);
/* harmony import */ var _swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(88029);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(71418);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(30381);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _treedis_tour_loader__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(33050);
/* harmony import */ var _game_GameBook__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(97741);
/* eslint-disable camelcase */ // eslint-disable-next-line max-classes-per-file








var Res;
(function(Res) {
    Res["Percentage"] = "percentage";
    Res["Pixels"] = "pixels";
})(Res || (Res = {}));
var GameTimerType;
(function(GameTimerType) {
    GameTimerType["CountDown"] = "countdown";
    GameTimerType["StopWatch"] = "stopwatch";
})(GameTimerType || (GameTimerType = {}));
var ScoreType;
(function(ScoreType) {
    ScoreType["Progress"] = "progress";
    ScoreType["Points"] = "points";
})(ScoreType || (ScoreType = {}));
var LockType;
(function(LockType) {
    LockType["Code"] = "code";
    LockType["Keyboard"] = "keyboard";
    LockType["Sequence"] = "sequence";
    LockType["PopUpTrivia"] = "popUpTrivia";
    LockType["CollectItems"] = "collectItems";
    LockType["Path"] = "path";
    LockType["Genially"] = "genial_ly";
})(LockType || (LockType = {}));
var LockLocationType;
(function(LockLocationType) {
    LockLocationType["Tag"] = "tag";
    LockLocationType["TransparentBox"] = "transparentBox";
    LockLocationType["vsItem"] = "vsItem";
    LockLocationType["Polygon"] = "Polygon";
    LockLocationType["vsVideo"] = "vsVideo";
    LockLocationType["vsImage"] = "vsImage";
})(LockLocationType || (LockLocationType = {}));
var LockLocationTypeLabel;
(function(LockLocationTypeLabel) {
    LockLocationTypeLabel["tag"] = "tag";
    LockLocationTypeLabel["transparentBox"] = "transparentBox";
    LockLocationTypeLabel["vsItem"] = "VSitem";
})(LockLocationTypeLabel || (LockLocationTypeLabel = {}));
var EntityType;
(function(EntityType) {
    EntityType["Tag"] = "tag";
    EntityType["Sweep"] = "sweep";
    EntityType["Popup"] = "popup";
    EntityType["Polygon"] = "polygon";
    EntityType["VSItem"] = "vsItem";
    EntityType["VSImage"] = "vsImage";
    EntityType["VSVideo"] = "vsVideo";
    EntityType["VSHTML"] = "vsHTML";
})(EntityType || (EntityType = {}));
var ConditionType;
(function(ConditionType) {
    ConditionType["HIDE"] = "hide";
    ConditionType["REVEAL"] = "reveal";
})(ConditionType || (ConditionType = {}));
var HintContentType;
(function(HintContentType) {
    HintContentType["Text"] = "text";
    HintContentType["Picture"] = "picture";
    HintContentType["Video"] = "video";
})(HintContentType || (HintContentType = {}));
var ContentType;
(function(ContentType) {
    ContentType["Sound"] = "sound";
    ContentType["Picture"] = "picture";
    ContentType["Text"] = "text";
    ContentType["Video"] = "video";
    ContentType["ExperiencePopupImage"] = "experiencePopupImage";
    ContentType["ExperiencePopupVideo"] = "experiencePopupVideo";
})(ContentType || (ContentType = {}));
var LOCK_SOLUTION_SEPARATOR = "|";
var EMPTY_LOCATION_ITEM = "-1";
var DEFAULT_RES = Res.Pixels;
var DEFAULT_WIDTH = 80;
var DEFAULT_HEIGHT = 60;
var FinishScreenTemplate;
(function(FinishScreenTemplate) {
    FinishScreenTemplate["DEFAULT"] = "default";
    FinishScreenTemplate["CUSTOM"] = "custom";
})(FinishScreenTemplate || (FinishScreenTemplate = {}));
var GameGeneral = function GameGeneral() {
    "use strict";
    var model = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(this, GameGeneral);
    this.id = model.id || null;
    this.name = model.name || null;
    this.credits = model.credits || null;
    this.greetingRes = model.greetingRes || DEFAULT_RES;
    this.greetingImg = model.greetingImg || null;
    this.greetingImgW = model.greetingImgW || DEFAULT_WIDTH;
    this.greetingImgH = model.greetingImgH || DEFAULT_HEIGHT;
    this.greetingImgMob = model.greetingImgMob || null;
    this.greetingImgMobW = model.greetingImgMobW || DEFAULT_WIDTH;
    this.greetingImgMobH = model.greetingImgMobH || DEFAULT_HEIGHT;
    this.greetingVideo = model.greetingVideo || null;
    this.greetingMobVideo = model.greetingMobVideo || null;
    this.timerType = model.timerType || GameTimerType.CountDown;
    this.limitTime = model.limitTime || 0;
    this.timeUpRes = model.timeUpRes || DEFAULT_RES;
    this.timeUpImg = model.timeUpImg || null;
    this.timeUpImgW = model.timeUpImgW || DEFAULT_WIDTH;
    this.timeUpImgH = model.timeUpImgH || DEFAULT_HEIGHT;
    this.timeUpImgMob = model.timeUpImgMob || null;
    this.timeUpImgMobW = model.timeUpImgMobW || DEFAULT_WIDTH;
    this.timeUpImgMobH = model.timeUpImgMobH || DEFAULT_HEIGHT;
    this.timeUpVideo = model.timeUpVideo || null;
    this.timeUpMobVideo = model.timeUpMobVideo || null;
    this.scoreType = model.scoreType || ScoreType.Progress;
    this.lock_points = model.lock_points || 0;
    this.nextHintTime = model.nextHintTime || 0;
    this.scoreHint1 = model.scoreHint1 || 0;
    this.scoreHint2 = model.scoreHint2 || 0;
    this.scoreSolution = model.scoreSolution || 0;
    this.tutorialRes = model.tutorialRes || DEFAULT_RES;
    this.tutorialImg = model.tutorialImg || null;
    this.tutorialImgW = model.tutorialImgW || DEFAULT_WIDTH;
    this.tutorialImgH = model.tutorialImgH || DEFAULT_HEIGHT;
    this.tutorialImgMob = model.tutorialImgMob || null;
    this.tutorialImgMobW = model.tutorialImgMobW || DEFAULT_WIDTH;
    this.tutorialImgMobH = model.tutorialImgMobH || DEFAULT_HEIGHT;
    this.tutorialVideo = model.tutorialVideo || null;
    this.tutorialMobVideo = model.tutorialMobVideo || null;
    this.autoplayTutorial = model.autoplayTutorial || false;
    this.subscriptionId = model.subscriptionId || null;
    this.paid = model.paid || false;
    this.introClip = model.introClip || false;
    this.introClipUrl = model.introClipUrl || null;
    this.hideSkipBtn = model.hideSkipBtn || null;
    this.uploadedIntroUrl = model.uploadedIntroUrl || "";
    this.outroClip = model.outroClip || false;
    this.outroClipUrl = model.outroClipUrl || null;
    this.uploadedOutroUrl = model.uploadedOutroUrl || "";
    this.answerIndicatorOn = model.answerIndicatorOn || false;
    this.finishScreenOn = model.finishScreenOn || false;
    this.finishScreenType = model.finishScreenType || FinishScreenTemplate.DEFAULT;
    this.finishScreenTitle = model.finishScreenTitle;
    var _finishScreenShareOn;
    this.finishScreenShareOn = (_finishScreenShareOn = model.finishScreenShareOn) !== null && _finishScreenShareOn !== void 0 ? _finishScreenShareOn : false;
    var _finishScreenLeaderboardOn;
    this.finishScreenLeaderboardOn = (_finishScreenLeaderboardOn = model.finishScreenLeaderboardOn) !== null && _finishScreenLeaderboardOn !== void 0 ? _finishScreenLeaderboardOn : false;
    var _finishScreenRateOn;
    this.finishScreenRateOn = (_finishScreenRateOn = model.finishScreenRateOn) !== null && _finishScreenRateOn !== void 0 ? _finishScreenRateOn : false;
    this.timerOn = model.timerOn || false;
    this.progressOn = model.progressOn || false;
    this.hintsOn = model.hintsOn || false;
    this.backpackOn = model.backpackOn || false;
    this.showBackpackByDefault = model.showBackpackByDefault || false;
    this.gameBookOn = model.gameBookOn || false;
    this.buttonSound = model.buttonSound || false;
    this.buttonSoundUrl = model.buttonSoundUrl || null;
    this.registration = model.registration || false;
    this.updatedAt = model.updatedAt ? moment__WEBPACK_IMPORTED_MODULE_0___default()(model.updatedAt) : moment__WEBPACK_IMPORTED_MODULE_0___default()();
    this.finishScreenImage = model.finishScreenImage || "";
};
var GameCondition = function GameCondition() {
    "use strict";
    var model = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(this, GameCondition);
    this.id = model.id || null;
    this.gameId = model.gameId || null;
    this.name = model.name || null;
    this.lock_ids = model.lock_ids || null;
    this.conditionType = model.conditionType || ConditionType.REVEAL;
    this.entity_type = model.entity_type || null;
    this.entity_ids = model.entity_ids || null;
    this.color = model.color || null;
    this.teleportToSweep = model.teleportToSweep || null;
    this.content_type = model.content_type || ContentType.Text;
    this.content_value = model.content_value || null;
    this.gameBackpack = model.gameBackpack || false;
    this.autoPlay = model.autoPlay || false;
    this.fullscreen = model.fullscreen || false;
    this.res = model.res || Res.Percentage;
    this.resMobile = model.resMobile || Res.Percentage;
    this.width = model.width || 60;
    this.height = model.height || 60;
    this.widthMobile = model.widthMobile || 60;
    this.heightMobile = model.heightMobile || 60;
    this.lockPathId = model.lockPathId || null;
    this.experienceTitle = model.experienceTitle || null;
    this.experienceDescription = model.experienceDescription || null;
    this.autoClose = model.autoClose || false;
    this.teleportLocationType = model.teleportLocationType;
    this.teleportLocationTourLink = model.teleportLocationTourLink;
};
var GameLockQuestion = function GameLockQuestion() {
    "use strict";
    var model = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(this, GameLockQuestion);
    this.id = model.id || null;
    this.title = model.title || null;
    this.answer1 = model.answer1 || null;
    this.answer2 = model.answer2 || null;
    this.answer3 = model.answer3 || null;
    this.answer4 = model.answer4 || null;
    this.correctAnswer = model.correctAnswer || null;
};
var GameLockPathTransitionType;
(function(GameLockPathTransitionType) {
    GameLockPathTransitionType["FADEOUT"] = "fadeout";
    GameLockPathTransitionType["FLY"] = "fly";
    GameLockPathTransitionType["INSTANT"] = "instant";
    GameLockPathTransitionType["MANUAL"] = "manual";
})(GameLockPathTransitionType || (GameLockPathTransitionType = {}));
var LocationSrc;
(function(LocationSrc) {
    LocationSrc["chooseSweep"] = "chooseSweep";
    LocationSrc["tourLink"] = "tourLink";
})(LocationSrc || (LocationSrc = {}));
var GameLockPath = function GameLockPath() {
    "use strict";
    var model = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(this, GameLockPath);
    this.id = model.id || null;
    this.title = model.title || null;
    this.sweepUuid = model.sweepUuid || null;
    this.description = model.description || null;
    this.locationType = model.locationType || null;
    this.locationItem = model.locationType && model.locationItem ? model.locationItem : null;
    this.triggerType = model.triggerType || null;
    this.autoOpenDestination = model.autoOpenDestination || false;
    this.hideStep = model.hideStep || false;
    this.disableTeleport = model.disableTeleport || false;
    this.disableNextBeforeCompletingTask = model.disableNextBeforeCompletingTask || false;
    this.appearanceDelay = model.appearanceDelay || 0;
    this.locationSrc = model.locationSrc || LocationSrc.chooseSweep;
    this.locationSmartLink = model.locationSmartLink || "";
    this.triggerItem = model.triggerType && model.triggerItem ? model.triggerItem : null;
    this.transitionType = model.transitionType || GameLockPathTransitionType.INSTANT;
    this.icon = model.icon ? "".concat("https://cdn.treedis.com", "/").concat(model.icon) : null;
};
var GameLockPathSetting = function GameLockPathSetting(model) {
    "use strict";
    (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(this, GameLockPathSetting);
    this.id = (model === null || model === void 0 ? void 0 : model.id) || null;
    this.gameLockId = (model === null || model === void 0 ? void 0 : model.gameLockId) || null;
    this.colorBackground = (model === null || model === void 0 ? void 0 : model.colorBackground) || "#ffffff";
    this.colorText = (model === null || model === void 0 ? void 0 : model.colorText) || "#636363";
    this.colorButton = (model === null || model === void 0 ? void 0 : model.colorButton) || "#ea475c";
    this.colorButtonText = (model === null || model === void 0 ? void 0 : model.colorButtonText) || "#ffffff";
    this.opacityBackground = (model === null || model === void 0 ? void 0 : model.opacityBackground) || 0.75;
    this.titleColorText = (model === null || model === void 0 ? void 0 : model.titleColorText) || "#000000";
    this.titleOpacityText = (model === null || model === void 0 ? void 0 : model.titleOpacityText) || 1;
    this.opacityText = (model === null || model === void 0 ? void 0 : model.opacityText) || 1;
    this.opacityButton = (model === null || model === void 0 ? void 0 : model.opacityButton) || 1;
    this.opacityButtonText = (model === null || model === void 0 ? void 0 : model.opacityButtonText) || 1;
    this.icon = (model === null || model === void 0 ? void 0 : model.icon) || null;
    this.titleEnabled = (model === null || model === void 0 ? void 0 : model.titleEnabled) || false;
    this.stepEnabled = (model === null || model === void 0 ? void 0 : model.stepEnabled) || false;
    this.defaultPath = model.defaultPath || false;
    this.resetPathOnSwitch = model.resetPathOnSwitch || false;
};
var GameLock = function GameLock() {
    "use strict";
    var model = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(this, GameLock);
    this.id = model.id || null;
    this.name = model.name || null;
    this.type = model.type || null;
    this.url = model.url || null;
    this.mobileUrl = model.mobileUrl || null;
    this.locationType = model.locationType || null;
    this.locationItem = model.locationItem || null;
    this.solution = model.solution || null;
    this.correctMusic = model.correctMusic || null;
    this.incorrectMusic = model.incorrectMusic || null;
    this.finishMusic = model.finishMusic || null;
    this.questions = model.questions && model.questions.map(function(question) {
        return new GameLockQuestion(question);
    }) || [];
    this.paths = ((model === null || model === void 0 ? void 0 : model.paths) || []).map(function(path) {
        return new GameLockPath(path);
    });
    var ref;
    this.keepHighlight = (ref = model === null || model === void 0 ? void 0 : model.keepHighlight) !== null && ref !== void 0 ? ref : true;
    this.resetHighlight = model.resetHighlight || 0;
    this.vsRes = model.vsRes || Res.Percentage;
    this.vsImg = model.vsImg || null;
    this.vsImgW = model.vsImgW || DEFAULT_WIDTH;
    this.vsImgH = model.vsImgH || DEFAULT_HEIGHT;
    this.vsMobImg = model.vsMobImg || null;
    this.vsMobImgW = model.vsMobImgW || DEFAULT_WIDTH;
    this.vsMobImgH = model.vsMobImgH || DEFAULT_HEIGHT;
    this.collected = [];
    this.icon = model.icon || null;
    var _hideItems;
    this.hideItems = (_hideItems = model.hideItems) !== null && _hideItems !== void 0 ? _hideItems : false;
    var _allowSkipping;
    this.allowSkipping = (_allowSkipping = model.allowSkipping) !== null && _allowSkipping !== void 0 ? _allowSkipping : false;
    var _last;
    this.last = (_last = model.last) !== null && _last !== void 0 ? _last : false;
    this.point = model.point || 0;
    var _timerEnabled;
    this.timerEnabled = (_timerEnabled = model.timerEnabled) !== null && _timerEnabled !== void 0 ? _timerEnabled : false;
    var _confettiEnabled;
    this.confettiEnabled = (_confettiEnabled = model.confettiEnabled) !== null && _confettiEnabled !== void 0 ? _confettiEnabled : false;
    var _guidCanClose;
    this.guidCanClose = (_guidCanClose = model.guidCanClose) !== null && _guidCanClose !== void 0 ? _guidCanClose : false;
    var _lockTimer;
    this.lockTimer = (_lockTimer = model.lockTimer) !== null && _lockTimer !== void 0 ? _lockTimer : 0;
    var _multipleAttempts;
    this.multipleAttempts = (_multipleAttempts = model.multipleAttempts) !== null && _multipleAttempts !== void 0 ? _multipleAttempts : false;
    var _lockPopUpCanBeClosed;
    this.lockPopUpCanBeClosed = (_lockPopUpCanBeClosed = model.lockPopUpCanBeClosed) !== null && _lockPopUpCanBeClosed !== void 0 ? _lockPopUpCanBeClosed : false;
    var _guidCanBeClosed;
    this.guidCanBeClosed = (_guidCanBeClosed = model.guidCanBeClosed) !== null && _guidCanBeClosed !== void 0 ? _guidCanBeClosed : false;
    var _quantityOfAttempts;
    this.quantityOfAttempts = (_quantityOfAttempts = model.quantityOfAttempts) !== null && _quantityOfAttempts !== void 0 ? _quantityOfAttempts : 0;
    var pS = model.pathSetting || {};
    this.pathSetting = new GameLockPathSetting((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, pS), {
        stepEnabled: model.stepEnabled,
        titleEnabled: model.titleEnabled
    }));
    this.hint = model.hint || null;
    this.description = model.description || "";
    this.previousStep = model.previousStep || false;
    this.buttonOnlyMode = model.buttonOnlyMode || false;
    this.nextButtonVisibility = model.nextButtonVisibility || _treedis_tour_loader__WEBPACK_IMPORTED_MODULE_1__/* .TLocksButtonVisibility.ShowAll */ .XZ.ShowAll;
    this.pathSwitcher = model.pathSwitcher || null;
    this.endPathIcon = model.endPathIcon || false;
};
var GameHint = function GameHint() {
    "use strict";
    var model = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(this, GameHint);
    this.id = model.id || null;
    this.gameId = model.gameId || null;
    this.name = model.name || null;
    this.lockId = model.lockId || null;
    this.hint1_active = model.hint1_active || false;
    this.hint1_type = model.hint1_type || null;
    this.hint1_value = model.hint1_value || null;
    this.hint1_deductPoints = model.hint1_deductPoints || 0;
    this.hint1_unlockTime = model.hint1_unlockTime || 0;
    this.hint2_active = model.hint2_active || false;
    this.hint2_type = model.hint2_type || null;
    this.hint2_value = model.hint2_value || null;
    this.hint2_deductPoints = model.hint2_deductPoints || 0;
    this.hint2_unlockTime = model.hint2_unlockTime || 0;
    this.solution_active = model.solution_active || false;
    this.solution_type = model.solution_type || null;
    this.solution_value = model.solution_value || null;
    this.solution_deductPoints = model.solution_deductPoints || 0;
    this.solution_unlockTime = model.solution_unlockTime || 0;
};
var Game = /*#__PURE__*/ function(GameGeneral) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(Game, GameGeneral);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(Game);
    function Game() {
        var model = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(this, Game);
        var _this;
        var ref;
        _this = _super.call(this, model);
        var paths = ((model === null || model === void 0 ? void 0 : model.locks) || []).filter(function(lock) {
            return lock.type === LockType.Path;
        });
        _this.id = model.id || null;
        _this.locks = ((ref = model.locks) === null || ref === void 0 ? void 0 : ref.length) && model.locks.filter(function(lock) {
            return lock.type !== LockType.Path;
        }).map(function(lock) {
            return new GameLock(lock);
        }) || [];
        _this.paths = paths.length ? paths.map(function(p) {
            return new GameLock(p);
        }) : null;
        _this.hints = model.hints && model.hints.map(function(hint) {
            return new GameHint(hint);
        }) || [];
        _this.conditions = model.conditions && model.conditions.map(function(condition) {
            return new GameCondition(condition);
        }) || [];
        _this.book = model.book ? new _game_GameBook__WEBPACK_IMPORTED_MODULE_2__/* .GameBook */ .Rw(model.book) : null;
        return _this;
    }
    return Game;
}(GameGeneral);


/***/ }),

/***/ 78073:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "o": function() { return /* binding */ MenuType; }
/* harmony export */ });
var MenuType;
(function(MenuType) {
    MenuType["Treedis"] = "treedis";
    MenuType["NavigationPath"] = "navigationPath";
    MenuType["Matterport"] = "matterport";
    MenuType["MatterportInstant"] = "matterport-instant";
    MenuType["MatterportLabel"] = "matterport-label";
    MenuType["MatterportFloor"] = "matterport-floor";
    MenuType["Popup"] = "popup";
    MenuType["Tab"] = "tab";
    MenuType["Tag"] = "tag";
    MenuType["Panorama"] = "panorama";
    MenuType["Product"] = "product";
    MenuType["Iframe"] = "iframe";
    MenuType["Category"] = "category";
})(MenuType || (MenuType = {}));


/***/ }),

/***/ 42725:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "An": function() { return /* binding */ TagRes; },
/* harmony export */   "Qy": function() { return /* binding */ TagType; }
/* harmony export */ });
/* unused harmony export TagNavigationType */
/* eslint-disable no-unused-vars */ var TagType;
(function(TagType) {
    TagType["None"] = "none";
    TagType["Text"] = "text";
    TagType["Image"] = "image";
    TagType["Gallery"] = "gallery";
    TagType["Music"] = "music";
    TagType["Video"] = "video";
    TagType["Iframe"] = "iframe";
    TagType["Tab"] = "tab";
    TagType["Panorama"] = "panorama";
    TagType["Menu"] = "menu";
    TagType["Matterport"] = "matterport";
    TagType["MatterportInstant"] = "matterport-instant";
    TagType["Treedis"] = "treedis";
    TagType["VideoChat"] = "video-chat";
    TagType["Navigation"] = "navigation";
    TagType["ExperiencePopUp"] = "experiencePopUp";
})(TagType || (TagType = {}));
var TagNavigationType;
(function(TagNavigationType) {
    TagNavigationType["Menu"] = "menu";
    TagNavigationType["Polygon"] = "polygon";
    TagNavigationType["Tag"] = "tag";
})(TagNavigationType || (TagNavigationType = {}));
var TagRes;
(function(TagRes) {
    TagRes["Percentage"] = "percentage";
    TagRes["Pixels"] = "pixels";
})(TagRes || (TagRes = {}));


/***/ }),

/***/ 40784:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "lC": function() { return /* binding */ AssetPageType; },
  "Bg": function() { return /* binding */ CustomButtonTypeOpenAsType; },
  "tP": function() { return /* binding */ TagDockSideType; },
  "Oj": function() { return /* binding */ Tour; },
  "zz": function() { return /* binding */ TourMode; },
  "v": function() { return /* binding */ TourType; },
  "YO": function() { return /* binding */ TourTypeURL; }
});

// UNUSED EXPORTS: AdRes, TourAddons, TourStatus, UnitSystem, WeekDays

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__(30381);
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);
// EXTERNAL MODULE: ./node_modules/lodash/isNil.js
var isNil = __webpack_require__(14293);
var isNil_default = /*#__PURE__*/__webpack_require__.n(isNil);
// EXTERNAL MODULE: ./components/util/all.ts
var util_all = __webpack_require__(40488);
;// CONCATENATED MODULE: ./_models/Client.tsx



var Client = function Client() {
    "use strict";
    var model = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    (0,_class_call_check/* default */.Z)(this, Client);
    this.id = model.id || null;
    this.name = model.name || null;
    this.email = model.email || null;
    this.website = model.website || null;
    this.phone = model.phone || null;
    this.linkedin = model.linkedin || null;
    this.facebook = model.facebook || null;
    this.instagram = model.instagram || null;
    this.twitter = model.twitter || null;
    this.fbAppId = model.fbAppId || null;
    this.whitelabelId = model.whitelabelId || null;
    this.whitelabelLogo = model.whitelabelLogo || null;
    this.rtl = model.rtl || false;
    this.googleViewId = model.googleViewId || null;
    this.fbPixel = model.fbPixel || null;
    this.tours = model.tours || [];
    this.updatedAt = model.updatedAt ? moment_default()(model.updatedAt) : moment_default()();
    this.logo = this.id && model.logo ? "".concat("https://cdn.treedis.com", "/clients/").concat(this.id, "/logo.png").concat((0,util_all/* getVersion */.bo)(this.updatedAt)) : null;
    this.watermark = this.id && model.watermark ? "".concat("https://cdn.treedis.com", "/clients/").concat(this.id, "/watermark.png").concat((0,util_all/* getVersion */.bo)(this.updatedAt)) : null;
    this.widthLogo = model.widthLogo || false;
    this.folders = model.folders || [];
    this.videoCredits = model.videoCredits || 0;
    this.monthlyVideoCredits = model.monthlyVideoCredits || 0;
    this.subscriptionId = model.subscriptionId || null;
    this.user = model.user || null;
    this.subscriptionType = model.subscriptionType || null;
    this.clientPermission = model.clientPermission || {};
    this.paypalClientId = model.paypalClientId || null;
    this.primaryColor = model.primaryColor || "#292929";
    this.secondaryColor = model.secondaryColor || "#ea475c";
    this.meetingSlotMinutes = model.meetingSlotMinutes || 10;
    this.meetingSlotPpl = model.meetingSlotPpl || 5;
    this.hubMinutes = model.hubMinutes || 0;
};

// EXTERNAL MODULE: ./_models/Agent.tsx
var Agent = __webpack_require__(2828);
// EXTERNAL MODULE: ./_models/User.tsx
var User = __webpack_require__(43500);
;// CONCATENATED MODULE: ./_models/Tour.tsx
/* eslint-disable camelcase */ 






var TourStatus;
(function(TourStatus) {
    TourStatus["Idle"] = "idle";
    TourStatus["Ready"] = "ready";
    TourStatus["Error"] = "error";
    TourStatus["Pay"] = "pay";
})(TourStatus || (TourStatus = {}));
var TourMode;
(function(TourMode) {
    TourMode["DOLLHOUSE"] = "mode.dollhouse";
    TourMode["FLOORPLAN"] = "mode.floorplan";
    TourMode["INSIDE"] = "mode.inside";
    TourMode["OUTSIDE"] = "mode.outside";
    TourMode["TRANSITIONING"] = "mode.transitioning";
})(TourMode || (TourMode = {}));
var UnitSystem;
(function(UnitSystem) {
    UnitSystem["Metric"] = "metric";
    UnitSystem["Imperial"] = "imperial";
})(UnitSystem || (UnitSystem = {}));
var AssetPageType;
(function(AssetPageType) {
    AssetPageType["Classic"] = "classic";
    AssetPageType["Slick"] = "slick";
    AssetPageType["Modern"] = "modern";
})(AssetPageType || (AssetPageType = {}));
var CustomButtonTypeOpenAsType;
(function(CustomButtonTypeOpenAsType) {
    CustomButtonTypeOpenAsType["Iframe"] = "iframe";
    CustomButtonTypeOpenAsType["Tab"] = "tab";
})(CustomButtonTypeOpenAsType || (CustomButtonTypeOpenAsType = {}));
var WeekDays;
(function(WeekDays) {
    WeekDays["Sunday"] = "sunday";
    WeekDays["Monday"] = "monday";
    WeekDays["Tuesday"] = "tuesday";
    WeekDays["Wednesday"] = "wednesday";
    WeekDays["Thursday"] = "thursday";
    WeekDays["Friday"] = "friday";
    WeekDays["Saturday"] = "saturday";
})(WeekDays || (WeekDays = {}));
var TourType;
(function(TourType) {
    TourType["Regular"] = "regular";
    TourType["Game"] = "game";
    TourType["ECommerce"] = "ecommerce";
    TourType["Ticket"] = "ticket";
    TourType["Kiosk"] = "kiosk";
})(TourType || (TourType = {}));
var TourTypeURL = {
    regular: "tour",
    game: "game",
    ecommerce: "e-commerce-tour",
    ticket: "ticket",
    video: "video"
};
var TagDockSideType;
(function(TagDockSideType) {
    TagDockSideType["Right"] = "right";
    TagDockSideType["Left"] = "left";
})(TagDockSideType || (TagDockSideType = {}));
var TourAddons = {
    title: 0,
    brand: false,
    hl: 0,
    tourcta: 1,
    dh: true,
    mt: true,
    nozoom: true,
    pin: true,
    mls: 0,
    qs: false,
    gt: true,
    portal: true,
    f: true,
    wh: true,
    kb: true,
    lp: false,
    vr: true,
    ts: -1,
    help: -1,
    nt: false,
    search: false,
    hidetags: false,
    lang: ""
};
var AdRes;
(function(AdRes) {
    AdRes["Percentage"] = "percentage";
    AdRes["Pixels"] = "pixels";
})(AdRes || (AdRes = {}));
var Tour = /*#__PURE__*/ function() {
    "use strict";
    function Tour() {
        var model = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        var _this = this;
        (0,_class_call_check/* default */.Z)(this, Tour);
        this.id = model.id || null;
        this.introScreen = model.introScreen || null;
        this.subTitle = model.subTitle || null;
        this.slug = model.slug || null;
        this.useSlug = model.useSlug || false;
        this.panoramaTransition = model.panoramaTransition || false;
        this.ticket = model.ticket || false;
        this.minimapVisible = model.minimapVisible || false;
        this.pay = model.pay;
        this.waitingPayment = model.waitingPayment;
        this.clientId = model.clientId || null;
        this.userId = model.userId || null;
        this.parentId = model.parentId || null;
        this.user = model.user ? new User/* User */.n5(model.user) : null;
        this.users = model.users ? (0,_to_consumable_array/* default */.Z)(model.users.map(function(user) {
            return new User/* User */.n5(user);
        })) : null;
        this.adLeads = model.adLeads || false;
        this.sameMusicForAllFloors = model.sameMusicForAllFloors;
        this.error = model.error || null;
        this.title = model.title || null;
        this.password = model.password || null;
        this.mainImage = model.mainImage || null;
        this.address = model.address || null;
        this.internalAddress = model.internalAddress || null;
        this.size = model.size || null;
        this.beds = model.beds || null;
        this.cars = model.cars || null;
        this.showers = model.showers || null;
        this.accomodation = model.accomodation || null;
        this.vrUrl = model.vrUrl || null;
        this.summary = model.summary || null;
        this.minimap = model.minimap || null;
        this.panorama = model.panorama || null;
        this.autoplayVideo = model.autoplayVideo || false;
        this.disableContext = model.disableContext || false;
        this.bookUrl = model.bookUrl || null;
        this.bookText = model.bookText || null;
        this.bookColor = model.bookColor || "#292929";
        this.exploreText = model.exploreText || null;
        this.ad = model.ad || false;
        this.share = model.share || false;
        this.adTime = model.adTime || null;
        this.adRes = model.adRes || AdRes.Percentage;
        this.adResMobile = model.adResMobile || AdRes.Percentage;
        this.adWidth = model.adWidth || 80;
        this.adHeight = model.adHeight || 60;
        this.adWidthMobile = model.adWidthMobile || 80;
        this.adHeightMobile = model.adHeightMobile || 60;
        this.adUrl = model.adUrl || null;
        this.droneUrl = model.droneUrl || null;
        this.videoUrl = model.videoUrl || null;
        this.videoWidth = model.videoWidth || null;
        this.videoHeight = model.videoHeight || null;
        this.floorPlansEnabled = model.floorPlansEnabled || false;
        this.customMinimap = model.customMinimap || false;
        this.menuEnabled = model.menuEnabled || false;
        this.menuOnStart = model.menuOnStart || false;
        this.menuAlwaysOpenMobile = false;
        this.menuAlwaysOpenDesktop = model.menuAlwaysOpenDesktop || false;
        this.music = model.music || false;
        this.autoplayMusic = model.autoplayMusic;
        this.audioVolume = model.audioVolume;
        this.screenshotEnabled = model.screenshotEnabled || false;
        this.status = model.status || TourStatus.Idle;
        this.matterId = model.matterId || null;
        this.images = model.images || [];
        this.showTitle = model.showTitle || false;
        this.floorPlans = model.floorPlans || [];
        this.tags = model.tags || [];
        this.clientFolderId = model.clientFolderId || null;
        this.updatedAt = model.updatedAt ? moment_default()(model.updatedAt) : moment_default()();
        this.client = model.client ? new Client(model.client) : null;
        this.tokenDuration = model.tokenDuration || -1;
        this.description = model.description || null;
        this.assetDescription = model.assetDescription || null;
        this.price = model.price || null;
        this.appointmentTime = model.appointmentTime || 30;
        this.fee = model.fee || 0;
        this.unitSystem = model.unitSystem || UnitSystem.Metric;
        this.appointmentsOn = model.appointmentsOn || false;
        this.agentSelecting = model.agentSelecting || false;
        this.appointmentTooltipOn = isNil_default()(model.appointmentTooltipOn) || model.appointmentTooltipOn;
        this.enableAvatar = isNil_default()(model.enableAvatar) || model.enableAvatar;
        this.enableIot = isNil_default()(model.enableIot) || model.enableIot;
        this.imageInsteadOfAvatar = isNil_default()(model.imageInsteadOfAvatar) || model.imageInsteadOfAvatar;
        this.getInTouchTooltipOn = isNil_default()(model.getInTouchTooltipOn) || model.getInTouchTooltipOn;
        this.menuTooltipOn = isNil_default()(model.menuTooltipOn) || model.menuTooltipOn;
        this.timezone = model.timezone || 0;
        this.sweepGroups = model.sweepGroups || [];
        this.unbranded = model.unbranded || false;
        this.translation = model.translation || null;
        this.messengerLink = model.messengerLink || null;
        this.messengerGreeting = model.messengerGreeting || null;
        this.assetPageType = model.assetPageType || AssetPageType.Classic;
        this.reel = model.reel || false;
        this.reels = model.reels || [];
        this.reelCategories = model.reelCategories || [];
        this.brightness = model.brightness || 1;
        this.saturation = model.saturation || 1;
        this.contrast = model.contrast || 1;
        this.contactForm = model.contactForm || false;
        this.panoramaStart = model.panoramaStart || false;
        this.panoramaHd = model.panoramaHd || false;
        this.hideMinimapHotspots = model.hideMinimapHotspots || false;
        this.enableVS = model.enableVS || false;
        this.allowGuestBeforeHost = model.allowGuestBeforeHost || false;
        this.collectLeads = model.collectLeads || false;
        this.leadsEmail = model.leadsEmail || false;
        this.leadsPhone = model.leadsPhone || false;
        this.leadsTimedPhone = model.leadsTimedPhone || false;
        this.leadsTimedName = model.leadsTimedName || false;
        this.leadsTimedEmail = model.leadsTimedEmail || false;
        this.leadsComment = model.leadsComment || null;
        this.legalNote = model.legalNote || null;
        this.legalBookingBox = model.legalBookingBox || null;
        this.legalBookingBox2 = model.legalBookingBox2 || null;
        this.termsUrl = model.termsUrl || null;
        this.enableBlackColorMenu = model.enableBlackColorMenu || false;
        this.vsRenderRange = model.vsRenderRange || 25;
        this.vsAnimationDistance = model.vsAnimationDistance && model.vsAnimationDistance > 0 ? model.vsAnimationDistance : 5;
        this.mpReel = model.mpReel || false;
        this.mpPlay = model.mpPlay || false;
        this.hidePucks = model.hidePucks;
        this.menuSearch = model.menuSearch || false;
        this.menuCategoryExpand = model.menuCategoryExpand || false;
        this.hideCookie = model.hideCookie || false;
        this.registrationBackground = model.registrationBackground || null;
        this.oauthAccess = model.oauthAccess;
        this.tourEmail = model.tourEmail || {
            contactName: null,
            contactPhone: null,
            leadSweeps: null,
            leadForms: null,
            videoAppointment: null,
            assertContactIcon: null,
            assertGetInTouch: null,
            menuGetInTouch: null
        };
        this.noAudioMode = model.noAudioMode || false;
        this.mode = model.mode;
        this.gameId = model.gameId || null;
        this.hideClientContact = model.hideClientContact || false;
        this.musics = model.tourMusics || [];
        this.agents = model.agentTours && model.agentTours.map(function(agentTour) {
            return new Agent/* Agent */.P(agentTour.agent);
        });
        this.htmlActive = model.htmlActive || false;
        this.htmlCode = model.htmlCode || "";
        // URL Addons
        Object.keys(TourAddons).forEach(function(addon) {
            _this["addon_".concat(addon)] = model["addon_".concat(addon)] || 0;
        });
        this.amenities = model.amenities || null;
        this.publicId = model.matterId ? encodeURIComponent(btoa(model.matterId)) : null;
        this.scannedAt = model.scannedAt ? moment_default()(model.scannedAt).format("DD/MM/YYYY") : moment_default()().format("DD/MM/YYYY");
        this.showNavTools = model.showNavTools || false;
        this.stopAfterSweep = model.stopAfterSweep || 0;
        this.rotationAngle = model.rotationAngle || 0;
        this.rotationSpeed = model.rotationSpeed || 0;
        this.transitionSpeed = model.transitionSpeed || 0;
        this.showNavPath = model.showNavPath || false;
        this.walkNav = model.walkNav || false;
        this.teleportNav = model.teleportNav || false;
        this.autoNav = model.autoNav || false;
        this.customButton = model.customButton || false;
        this.customButtonIcon = model.customButtonIcon || null;
        this.customButtonUrl = model.customButtonUrl || null;
        this.customButtonOpenAs = model.customButtonOpenAs || CustomButtonTypeOpenAsType.Tab;
        this.ecommercePaidStatus = model.ecommercePaidStatus || false;
        this.ecommerceSubscriptionId = model.ecommerceSubscriptionId || null;
        this.mpPasswordActive = model.mpPasswordActive || false;
        var _musicControl;
        this.musicControl = (_musicControl = model.musicControl) !== null && _musicControl !== void 0 ? _musicControl : true;
        var _languageId;
        this.languageId = (_languageId = model.languageId) !== null && _languageId !== void 0 ? _languageId : null;
        var _initialDuplicates;
        this.initialDuplicates = (_initialDuplicates = model.initialDuplicates) !== null && _initialDuplicates !== void 0 ? _initialDuplicates : [];
        var _storeEnabled;
        this.storeEnabled = (_storeEnabled = model.storeEnabled) !== null && _storeEnabled !== void 0 ? _storeEnabled : true;
        var _callIconEnabled;
        this.callIconEnabled = (_callIconEnabled = model.callIconEnabled) !== null && _callIconEnabled !== void 0 ? _callIconEnabled : false;
        var _addressIconEnabled;
        this.addressIconEnabled = (_addressIconEnabled = model.addressIconEnabled) !== null && _addressIconEnabled !== void 0 ? _addressIconEnabled : false;
        var _hideSidebarConfigs;
        this.hideSidebarConfigs = (_hideSidebarConfigs = model.hideSidebarConfigs) !== null && _hideSidebarConfigs !== void 0 ? _hideSidebarConfigs : false;
        var _hideSoundControls;
        this.hideSoundControls = (_hideSoundControls = model.hideSoundControls) !== null && _hideSoundControls !== void 0 ? _hideSoundControls : false;
        var _hideLanguageSelect;
        this.hideLanguageSelect = (_hideLanguageSelect = model.hideLanguageSelect) !== null && _hideLanguageSelect !== void 0 ? _hideLanguageSelect : false;
        var _hideSubtitlesSelect;
        this.hideSubtitlesSelect = (_hideSubtitlesSelect = model.hideSubtitlesSelect) !== null && _hideSubtitlesSelect !== void 0 ? _hideSubtitlesSelect : false;
        this.ss = model.ss || "";
        this.sr = model.sr || "";
        this.hideMPTagSwitcher = model.hideMPTagSwitcher || false;
        this.hideMPTagDock = model.hideMPTagDock || false;
        this.background = model.background || null;
        this.backgroundImage = model.backgroundImage || null;
        this.cookieIsMandatory = model.cookieIsMandatory;
        this.loadTourAfterCookie = model.loadTourAfterCookie;
        this.mpTagDockSide = model.mpTagDockSide || TagDockSideType.Right;
        this.patchIcon = model.patchIcon || "";
        this.patchIconEnabled = model.patchIconEnabled || false;
        this.isThreadsEnabled = model.isThreadsEnabled || false;
        this.textChatEnabled = model.textChatEnabled || false;
        this.navigationWebEnabled = model.navigationWebEnabled || false;
    }
    var _proto = Tour.prototype;
    _proto.getAddonsUrl = function getAddonsUrl() {
        var _this = this;
        var string = "&play=1&newtags=1&xruntested=1";
        Object.keys(TourAddons).map(function(addon) {
            var value = _this["addon_".concat(addon)] ? "1" : "0";
            if (typeof _this["addon_".concat(addon)] === "number" || typeof _this["addon_".concat(addon)] === "string") value = _this["addon_".concat(addon)];
            if (addon === "help" && _this["addon_".concat(addon)] === -1) value = null;
            if (addon === "lang" && !_this["addon_".concat(addon)]) return null;
            if (addon === "ts") return null; // we do our own ts logic
            string += "&".concat(addon, "=").concat(value);
            return null;
        });
        return string;
    };
    return Tour;
}();


/***/ }),

/***/ 43500:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "MX": function() { return /* binding */ UserSubscription; },
/* harmony export */   "n5": function() { return /* binding */ User; }
/* harmony export */ });
/* unused harmony exports UserType, Mode */
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(51438);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(30381);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _components_util_all__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(40488);



var UserSubscription;
(function(UserSubscription) {
    UserSubscription[//old
    "Trial"] = "trial";
    UserSubscription["Month"] = "month";
    UserSubscription["Year"] = "year";
    UserSubscription["Pay"] = "pay";
    UserSubscription[//new
    "Free"] = "free";
    UserSubscription["Growth"] = "growth";
    UserSubscription["Business"] = "business";
    UserSubscription["Enterprise"] = "enterprise";
})(UserSubscription || (UserSubscription = {}));
var UserType;
(function(UserType) {
    UserType["Admin"] = "admin";
    UserType["User"] = "user";
})(UserType || (UserType = {}));
var Mode;
(function(Mode) {
    Mode["Regular"] = "regular";
    Mode["Conference"] = "conference";
    Mode["Game"] = "game";
    Mode["Ticket"] = "ticket";
})(Mode || (Mode = {}));
var User = function User() {
    "use strict";
    var model = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(this, User);
    this.id = model.id || null;
    this.name = model.name || null;
    this.email = model.email || null;
    this.website = model.website || null;
    this.phone = model.phone || null;
    this.country = model.country || null;
    this.type = model.type || null;
    this.fbAppId = model.fbAppId || null;
    this.videoCredits = model.videoCredits || 0;
    this.updatedAt = model.updatedAt ? moment__WEBPACK_IMPORTED_MODULE_0___default()(model.updatedAt) : moment__WEBPACK_IMPORTED_MODULE_0___default()();
    this.profile = this.id && model.profile ? "".concat("https://cdn.treedis.com", "/users/").concat(this.id, "/profile.jpg").concat((0,_components_util_all__WEBPACK_IMPORTED_MODULE_1__/* .getVersion */ .bo)(this.updatedAt)) : null;
    this.subscription = model.subscription || UserSubscription.Trial;
    this.paypalEmail = model.paypalEmail || null;
    this.whitelabelId = model.whitelabelId || null;
    this.logo = this.id && this.whitelabelId ? "".concat("https://cdn.treedis.com", "/users/").concat(this.id, "/logo.png").concat((0,_components_util_all__WEBPACK_IMPORTED_MODULE_1__/* .getVersion */ .bo)(this.updatedAt)) : null;
    this.domainUrl = model.domainUrl || "";
    this.adminUrl = model.adminUrl || "";
    this.whitelabelEmail = model.whitelabelEmail || "";
    this.mpSDK = model.mpSDK || "295ba0c0f04541318359a8e75af33043";
    this.primaryColor = model.primaryColor || "#292929";
    this.secondaryColor = model.secondaryColor || "#ea475c";
    this.username = model.username || null;
    this.refer = model.refer || null;
    this.company = model.company || null;
    this.admin = model.admin || null;
    this.googleViewId = model.googleViewId || null;
    this.oauth = model.oauth;
    this.oauthToken = model.oauthToken;
};


/***/ }),

/***/ 97741:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Rw": function() { return /* binding */ GameBook; },
/* harmony export */   "_U": function() { return /* binding */ ChapterType; },
/* harmony export */   "u6": function() { return /* binding */ GameBookType; }
/* harmony export */ });
/* unused harmony export GameBookChapter */
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(51438);
/* harmony import */ var _swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(88029);
/* harmony import */ var _swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(71418);
/* harmony import */ var lodash_isNil__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14293);
/* harmony import */ var lodash_isNil__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_isNil__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var lodash_isNaN__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7654);
/* harmony import */ var lodash_isNaN__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash_isNaN__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _Common__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41292);
/* harmony import */ var _components_tour_game_gameBook_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(81389);
// eslint-disable-next-line max-classes-per-file







var ChapterType;
(function(ChapterType) {
    ChapterType["Tag"] = "tag";
    ChapterType["Polygon"] = "polygon";
    ChapterType["VSItem"] = "vsItem";
    ChapterType["VSImage"] = "vsImage";
    ChapterType["VSVideo"] = "vsVideo";
})(ChapterType || (ChapterType = {}));
var GameBookType;
(function(GameBookType) {
    GameBookType["Open"] = "open";
    GameBookType["Close"] = "close";
})(GameBookType || (GameBookType = {}));
var ImageSettings = function ImageSettings(model) {
    "use strict";
    (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(this, ImageSettings);
    this.res = model.res || _Common__WEBPACK_IMPORTED_MODULE_2__/* .Res.Percentage */ .L.Percentage;
    this.resMobile = model.resMobile || _Common__WEBPACK_IMPORTED_MODULE_2__/* .Res.Percentage */ .L.Percentage;
    this.width = model.width || 80;
    this.height = model.height || 60;
    this.widthMobile = model.widthMobile || 80;
    this.heightMobile = model.heightMobile || 60;
    this.img = model.img || null;
    this.imgMobile = model.imgMobile || null;
};
var GameBookChapter = /*#__PURE__*/ function(ImageSettings) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(GameBookChapter, ImageSettings);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(GameBookChapter);
    function GameBookChapter(model) {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(this, GameBookChapter);
        var _this;
        _this = _super.call(this, model);
        _this.id = model.id || null;
        _this.title = model.title || null;
        _this.type = model.type || null;
        _this.value = model.value || null;
        _this.order = model.order || null;
        _this.sweepUuid = model.sweepUuid || null;
        _this.description = model.description || null;
        _this.locationType = model.locationType || _components_tour_game_gameBook_types__WEBPACK_IMPORTED_MODULE_3__/* .GameBookLocationType.sweep */ .d.sweep;
        _this.locationTourLink = model.locationTourLink || "";
        return _this;
    }
    return GameBookChapter;
}(ImageSettings);
var GameBook = /*#__PURE__*/ function(ImageSettings) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(GameBook, ImageSettings);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(GameBook);
    function GameBook() {
        var model = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(this, GameBook);
        var _this;
        var ref;
        _this = _super.call(this, model);
        _this.id = model.id || null;
        _this.description = model.description || null;
        _this.chapters = (model === null || model === void 0 ? void 0 : (ref = model.chapters) === null || ref === void 0 ? void 0 : ref.map(function(chapter) {
            return new GameBookChapter(chapter);
        })) || [];
        _this.gameId = model.gameId || null;
        _this.type = model.type || GameBookType.Close;
        _this.chapterLocked = lodash_isNil__WEBPACK_IMPORTED_MODULE_0___default()(model.chapterLocked) ? true : model.chapterLocked;
        _this.openByDefault = lodash_isNil__WEBPACK_IMPORTED_MODULE_0___default()(model.openByDefault) ? false : model.openByDefault;
        _this.backgroundColor = model.backgroundColor || "#000000";
        _this.backgroundOpacity = lodash_isNaN__WEBPACK_IMPORTED_MODULE_1___default()(model.backgroundOpacity) ? 0.5 : model.backgroundOpacity;
        _this.textColor = model.textColor || "#ffffff";
        _this.buttonColor = model.buttonColor || "#2055FF";
        return _this;
    }
    return GameBook;
}(ImageSettings);


/***/ }),

/***/ 59524:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "IW": function() { return /* binding */ PolygonActionAction; },
/* harmony export */   "fD": function() { return /* binding */ PolygonAction; },
/* harmony export */   "l3": function() { return /* binding */ PolygonActionMode; },
/* harmony export */   "mg": function() { return /* binding */ Polygon; },
/* harmony export */   "zS": function() { return /* binding */ PolygonActionType; }
/* harmony export */ });
/* unused harmony export PolygonActionRes */
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(51438);
/* harmony import */ var _VSObject__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(15864);


var PolygonActionType;
(function(PolygonActionType) {
    PolygonActionType["None"] = "none";
    PolygonActionType["Text"] = "text";
    PolygonActionType["Image"] = "image";
    PolygonActionType["Music"] = "music";
    PolygonActionType["Video"] = "video";
    PolygonActionType["Iframe"] = "iframe";
    PolygonActionType["Tab"] = "tab";
    PolygonActionType["Panorama"] = "panorama";
    PolygonActionType["Menu"] = "menu";
    PolygonActionType["Treedis"] = "treedis";
    PolygonActionType["Matterport"] = "matterport";
    PolygonActionType["MatterportInstant"] = "matterport-instant";
    PolygonActionType["ExperiencePopUp"] = "experiencePopUp";
})(PolygonActionType || (PolygonActionType = {}));
var PolygonActionAction;
(function(PolygonActionAction) {
    PolygonActionAction["Click"] = "click";
    PolygonActionAction["Hover"] = "hover";
})(PolygonActionAction || (PolygonActionAction = {}));
var PolygonActionRes;
(function(PolygonActionRes) {
    PolygonActionRes["Percentage"] = "percentage";
    PolygonActionRes["Pixels"] = "pixels";
})(PolygonActionRes || (PolygonActionRes = {}));
var PolygonActionMode;
(function(PolygonActionMode) {
    PolygonActionMode["Ecommerce"] = "ecommerce";
    PolygonActionMode["Game"] = "game";
    PolygonActionMode["VS"] = "vs";
})(PolygonActionMode || (PolygonActionMode = {}));
var PolygonAction = function PolygonAction() {
    "use strict";
    var model = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(this, PolygonAction);
    this.id = model.id;
    this.polygonId = model.polygonId || "";
    this.mode = model.mode || PolygonActionMode.VS;
    this.type = model.type || PolygonActionType.None;
    this.action = model.action || PolygonActionAction.Click;
    this.url = model.url || "";
    this.text = model.text || "";
    this.resolution = model.resolution || PolygonActionRes.Percentage;
    this.width = model.width || 80;
    this.height = model.height || 80;
    this.resolutionMobile = model.resolutionMobile || PolygonActionRes.Percentage;
    this.widthMobile = model.widthMobile || 80;
    this.heightMobile = model.heightMobile || 80;
    this.panoramaId = model.panoramaId || null;
    this.menuId = model.menuId || null;
    this.subMenuId = model.subMenuId || null;
    this.subSubMenuId = model.subSubMenuId || null;
    this.gameBackpack = model.gameBackpack || false;
    this.fullscreen = model.fullscreen || false;
    this.autoPlay = model.autoPlay || false;
    this.rotation = (model === null || model === void 0 ? void 0 : model.rotation) || _VSObject__WEBPACK_IMPORTED_MODULE_0__/* .TourVSImageRotation.Vertical */ .GF.Vertical;
    this.actionURL = (model === null || model === void 0 ? void 0 : model.actionURL) || "";
    this.dontInterruptBgAudio = (model === null || model === void 0 ? void 0 : model.dontInterruptBgAudio) || false;
    this.popupTitle = (model === null || model === void 0 ? void 0 : model.popupTitle) || "";
    this.textColor = (model === null || model === void 0 ? void 0 : model.textColor) || "#ffffff";
    this.backgroundColor = (model === null || model === void 0 ? void 0 : model.backgroundColor) || "#000000";
    this.backgroundOpacity = (model === null || model === void 0 ? void 0 : model.backgroundOpacity) || 0.7;
    this.buttonColor = (model === null || model === void 0 ? void 0 : model.buttonColor) || "#ffffff";
};
var Polygon = function Polygon() {
    "use strict";
    var model = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(this, Polygon);
    var ref;
    this.id = model.id;
    this.title = model.title || "";
    this.tourId = model.tourId;
    this.scaleX = model.scaleX || 1;
    this.scaleY = model.scaleY || 1;
    this.scaleZ = model.scaleZ || 1;
    this.positionX = model.positionX || 0;
    this.positionY = model.positionY || 0;
    this.positionZ = model.positionZ || 0;
    this.rotationX = model.rotationX || 0;
    this.rotationY = model.rotationY || 0;
    this.rotationZ = model.rotationZ || 0;
    this.active = typeof model.active === "boolean" ? model.active : true;
    this.uuid = model.uuid || null;
    this.colorDefault = model.colorDefault || "#ea475c";
    this.colorHover = model.colorHover || "#FFFFFF";
    this.colorClick = model.colorClick || "#ea475c";
    this.opacityDefault = model.opacityDefault >= 0 ? model.opacityDefault : 0.2;
    this.opacityHover = model.opacityHover >= 0 ? model.opacityHover : 0.4;
    this.opacityClick = model.opacityClick >= 0 ? model.opacityClick : 0.5;
    this.edgesOpacityDefault = model.edgesOpacityDefault >= 0 ? model.edgesOpacityDefault : 0.5;
    this.edgesOpacityHover = model.edgesOpacityHover >= 0 ? model.edgesOpacityHover : 0.7;
    this.edgesOpacityClick = model.edgesOpacityClick >= 0 ? model.edgesOpacityClick : 0.8;
    this.sweep_uuid = model.sweep_uuid || null;
    this.sweepUuid = model.sweep_uuid || null;
    this.srX = model.srX || 0;
    this.srY = model.srY || 0;
    this.srZ = model.srZ || 0;
    this.products = ((ref = model.products) === null || ref === void 0 ? void 0 : ref.length) > 0 ? model.products.map(function(item) {
        return item.id;
    }) : [];
    this.polygonsActions = model.polygonsActions || [];
    this.hideAfterClick = model.hideAfterClick || false;
    this.isHiddenAfterClick = false;
};


/***/ }),

/***/ 98472:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ad": function() { return /* binding */ SceneComponent; },
/* harmony export */   "td": function() { return /* binding */ ComponentInteractionType; }
/* harmony export */ });
/* unused harmony exports PointerButton, PointerButtonMask, PointerDevice, KeyState, Keys */
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(51438);
/* harmony import */ var _swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(88029);
/* harmony import */ var _swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(71418);
/* eslint-disable */ // @ts-nocheck file
// noinspection JSDuplicatedDeclaration



/**
 * The base of all `SceneComponent` created with the sdk.
 * All properties of this class are always available to all components generated through the sdk.
 * These properties should all be considered reserved and should not be overwritten by the subclass.
 */ var SceneComponentPrivate = function SceneComponentPrivate() {
    "use strict";
    (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(this, SceneComponentPrivate);
};
var SceneComponent = /*#__PURE__*/ function(SceneComponentPrivate) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(SceneComponent, SceneComponentPrivate);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(SceneComponent);
    function SceneComponent() {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(this, SceneComponent);
        return _super.apply(this, arguments);
    }
    return SceneComponent;
}(SceneComponentPrivate);
var ComponentInteractionType;
(function(ComponentInteractionType) {
    ComponentInteractionType[/** CLICK events */ "CLICK"] = "INTERACTION.CLICK";
    ComponentInteractionType[/** HOVER events */ "HOVER"] = "INTERACTION.HOVER";
    ComponentInteractionType[/** DRAG events (mousedown then move) */ "DRAG"] = "INTERACTION.DRAG";
    ComponentInteractionType["DRAG_BEGIN"] = "INTERACTION.DRAG_BEGIN";
    ComponentInteractionType["DRAG_END"] = "INTERACTION.DRAG_END";
    ComponentInteractionType["POINTER_MOVE"] = "INTERACTION.POINTER_MOVE";
    ComponentInteractionType["POINTER_BUTTON"] = "INTERACTION.POINTER_BUTTON";
    ComponentInteractionType["SCROLL"] = "INTERACTION.SCROLL";
    ComponentInteractionType["KEY"] = "INTERACTION.KEY";
    ComponentInteractionType["LONG_PRESS_START"] = "INTERACTION.LONG_PRESS_START";
    ComponentInteractionType["LONG_PRESS_END"] = "INTERACTION.LONG_PRESS_END";
    ComponentInteractionType["MULTI_SWIPE"] = "INTERACTION.MULTI_SWIPE";
    ComponentInteractionType["MULTI_SWIPE_END"] = "INTERACTION.MULTI_SWIPE_END";
    ComponentInteractionType["PINCH"] = "INTERACTION.PINCH";
    ComponentInteractionType["PINCH_END"] = "INTERACTION.PINCH_END";
    ComponentInteractionType["ROTATE"] = "INTERACTION.ROTATE";
    ComponentInteractionType["ROTATE_END"] = "INTERACTION.ROTATE_END";
})(ComponentInteractionType || (ComponentInteractionType = {}));
var ComponentOutputReserved = function ComponentOutputReserved() {
    "use strict";
    _class_call_check(this, ComponentOutputReserved);
};
var ComponentOut = /*#__PURE__*/ (/* unused pure expression or super */ null && (function(ComponentOutputReserved) {
    "use strict";
    _inherits(ComponentOut, ComponentOutputReserved);
    var _super = _create_super(ComponentOut);
    function ComponentOut() {
        _class_call_check(this, ComponentOut);
        return _super.apply(this, arguments);
    }
    return ComponentOut;
}(ComponentOutputReserved)));
var PointerButton;
(function(PointerButton) {
    PointerButton[PointerButton["PRIMARY"] = 0] = "PRIMARY";
    PointerButton[PointerButton["MIDDLE"] = 1] = "MIDDLE";
    PointerButton[PointerButton["SECONDARY"] = 2] = "SECONDARY";
    PointerButton[PointerButton["BACK"] = 3] = "BACK";
    PointerButton[PointerButton["FORWARD"] = 4] = "FORWARD";
    PointerButton[PointerButton["COUNT"] = 5] = "COUNT";
})(PointerButton || (PointerButton = {}));
var PointerButtonMask;
(function(PointerButtonMask) {
    PointerButtonMask[PointerButtonMask["NONE"] = 0] = "NONE";
    PointerButtonMask[PointerButtonMask["PRIMARY"] = 1 << PointerButton.PRIMARY] = "PRIMARY";
    PointerButtonMask[PointerButtonMask["SECONDARY"] = 1 << PointerButton.SECONDARY] = "SECONDARY";
    PointerButtonMask[PointerButtonMask["MIDDLE"] = 1 << PointerButton.MIDDLE] = "MIDDLE";
    PointerButtonMask[PointerButtonMask["BACK"] = 1 << PointerButton.BACK] = "BACK";
    PointerButtonMask[PointerButtonMask["FORWARD"] = 1 << PointerButton.FORWARD] = "FORWARD";
    PointerButtonMask[PointerButtonMask["ALL"] = (1 << PointerButton.COUNT) - 1] = "ALL";
})(PointerButtonMask || (PointerButtonMask = {}));
var PointerDevice;
(function(PointerDevice) {
    PointerDevice["MOUSE"] = "mouse";
    PointerDevice["TOUCH"] = "touch";
    PointerDevice["PEN"] = "pen";
    PointerDevice["GAMEPAD"] = "gamepad";
})(PointerDevice || (PointerDevice = {}));
var KeyState;
(function(KeyState) {
    KeyState[KeyState["DOWN"] = 0] = "DOWN";
    KeyState[KeyState["PRESSED"] = 1] = "PRESSED";
    KeyState[KeyState["UP"] = 2] = "UP";
})(KeyState || (KeyState = {}));
var Keys;
(function(Keys) {
    Keys[Keys["ESCAPE"] = 27] = "ESCAPE";
    Keys[Keys["ZERO"] = 48] = "ZERO";
    Keys[Keys["ONE"] = 49] = "ONE";
    Keys[Keys["TWO"] = 50] = "TWO";
    Keys[Keys["THREE"] = 51] = "THREE";
    Keys[Keys["FOUR"] = 52] = "FOUR";
    Keys[Keys["FIVE"] = 53] = "FIVE";
    Keys[Keys["SIX"] = 54] = "SIX";
    Keys[Keys["SEVEN"] = 55] = "SEVEN";
    Keys[Keys["EIGHT"] = 56] = "EIGHT";
    Keys[Keys["NINE"] = 57] = "NINE";
    Keys[Keys["LEFTARROW"] = 37] = "LEFTARROW";
    Keys[Keys["UPARROW"] = 38] = "UPARROW";
    Keys[Keys["RIGHTARROW"] = 39] = "RIGHTARROW";
    Keys[Keys["DOWNARROW"] = 40] = "DOWNARROW";
    Keys[Keys["TAB"] = 9] = "TAB";
    Keys[Keys["A"] = 65] = "A";
    Keys[Keys["B"] = 66] = "B";
    Keys[Keys["C"] = 67] = "C";
    Keys[Keys["D"] = 68] = "D";
    Keys[Keys["E"] = 69] = "E";
    Keys[Keys["F"] = 70] = "F";
    Keys[Keys["G"] = 71] = "G";
    Keys[Keys["H"] = 72] = "H";
    Keys[Keys["I"] = 73] = "I";
    Keys[Keys["J"] = 74] = "J";
    Keys[Keys["K"] = 75] = "K";
    Keys[Keys["L"] = 76] = "L";
    Keys[Keys["M"] = 77] = "M";
    Keys[Keys["N"] = 78] = "N";
    Keys[Keys["O"] = 79] = "O";
    Keys[Keys["P"] = 80] = "P";
    Keys[Keys["Q"] = 81] = "Q";
    Keys[Keys["R"] = 82] = "R";
    Keys[Keys["S"] = 83] = "S";
    Keys[Keys["T"] = 84] = "T";
    Keys[Keys["U"] = 85] = "U";
    Keys[Keys["V"] = 86] = "V";
    Keys[Keys["W"] = 87] = "W";
    Keys[Keys["X"] = 88] = "X";
    Keys[Keys["Y"] = 89] = "Y";
    Keys[Keys["Z"] = 90] = "Z";
    Keys[Keys["SPACE"] = 32] = "SPACE";
    Keys[Keys["RETURN"] = 13] = "RETURN";
    Keys[Keys["DELETE"] = 46] = "DELETE";
    Keys[Keys["BACKSPACE"] = 8] = "BACKSPACE";
    Keys[Keys["SEMICOLON"] = 186] = "SEMICOLON";
    Keys[Keys["PLUSEQUALS"] = 187] = "PLUSEQUALS";
    Keys[Keys["DASHUNDERSCORE"] = 189] = "DASHUNDERSCORE";
    Keys[Keys["OPENBRACKET"] = 219] = "OPENBRACKET";
    Keys[Keys["SHIFT"] = 16] = "SHIFT";
    Keys[Keys["ALT"] = 18] = "ALT";
    Keys[Keys["CONTROL"] = 17] = "CONTROL";
})(Keys || (Keys = {}));


/***/ }),

/***/ 15864:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "GF": function() { return /* binding */ TourVSImageRotation; },
/* harmony export */   "Gu": function() { return /* binding */ LoadingState; },
/* harmony export */   "IG": function() { return /* binding */ VSInteractionType; },
/* harmony export */   "OV": function() { return /* binding */ VSVideoType; },
/* harmony export */   "TU": function() { return /* binding */ TourActionRes; },
/* harmony export */   "Up": function() { return /* binding */ TourVideo; },
/* harmony export */   "b2": function() { return /* binding */ TourAction; },
/* harmony export */   "mI": function() { return /* binding */ TourActionType; },
/* harmony export */   "oP": function() { return /* binding */ TourImage; },
/* harmony export */   "q8": function() { return /* binding */ TourVSHtml; },
/* harmony export */   "zB": function() { return /* binding */ TourObject; }
/* harmony export */ });
/* unused harmony exports VSObject, VSImage, VSHtml, VSVideo */
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(51438);
/* harmony import */ var _components_util_all__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(40488);
// eslint-disable-next-line max-classes-per-file


var TourActionType;
(function(TourActionType) {
    TourActionType["None"] = "none";
    TourActionType["Text"] = "text";
    TourActionType["Image"] = "image";
    TourActionType["Music"] = "music";
    TourActionType["Video"] = "video";
    TourActionType["Iframe"] = "iframe";
    TourActionType["Tab"] = "tab";
    TourActionType["Panorama"] = "panorama";
    TourActionType["Menu"] = "menu";
    TourActionType["Treedis"] = "treedis";
    TourActionType["NavigationPath"] = "navigationPath";
    TourActionType["ExperiencePopUp"] = "experiencePopUp";
    TourActionType["Matterport"] = "matterport";
    TourActionType["MatterportInstant"] = "matterport-instant";
    TourActionType["IoT"] = "iot";
})(TourActionType || (TourActionType = {}));
var TourVSImageRotation;
(function(TourVSImageRotation) {
    TourVSImageRotation["Vertical"] = "vertical";
    TourVSImageRotation["Horizontal"] = "horizontal";
})(TourVSImageRotation || (TourVSImageRotation = {}));
var TourAction;
(function(TourAction) {
    TourAction["Click"] = "click";
    TourAction["Hover"] = "hover";
})(TourAction || (TourAction = {}));
var LoadingState;
(function(LoadingState) {
    LoadingState["Idle"] = "Idle";
    LoadingState["Loaded"] = "Loaded";
    LoadingState["Loading"] = "Loading";
    LoadingState["Error"] = "Error";
})(LoadingState || (LoadingState = {}));
var TourActionRes;
(function(TourActionRes) {
    TourActionRes["Percentage"] = "percentage";
    TourActionRes["Pixels"] = "pixels";
})(TourActionRes || (TourActionRes = {}));
var VSInteractionType;
(function(VSInteractionType) {
    VSInteractionType[/** CLICK events */ "CLICK"] = "INTERACTION.CLICK";
    VSInteractionType[/** HOVER events */ "HOVER"] = "INTERACTION.HOVER";
    VSInteractionType[/** DRAG events (mousedown then move) */ "DRAG"] = "INTERACTION.DRAG";
    VSInteractionType["DRAG_BEGIN"] = "INTERACTION.DRAG_BEGIN";
    VSInteractionType["DRAG_END"] = "INTERACTION.DRAG_END";
    VSInteractionType["POINTER_MOVE"] = "INTERACTION.POINTER_MOVE";
    VSInteractionType["POINTER_BUTTON"] = "INTERACTION.POINTER_BUTTON";
    VSInteractionType["SCROLL"] = "INTERACTION.SCROLL";
    VSInteractionType["KEY"] = "INTERACTION.KEY";
    VSInteractionType["LONG_PRESS_START"] = "INTERACTION.LONG_PRESS_START";
    VSInteractionType["LONG_PRESS_END"] = "INTERACTION.LONG_PRESS_END";
    VSInteractionType["MULTI_SWIPE"] = "INTERACTION.MULTI_SWIPE";
    VSInteractionType["MULTI_SWIPE_END"] = "INTERACTION.MULTI_SWIPE_END";
    VSInteractionType["PINCH"] = "INTERACTION.PINCH";
    VSInteractionType["PINCH_END"] = "INTERACTION.PINCH_END";
    VSInteractionType["ROTATE"] = "INTERACTION.ROTATE";
    VSInteractionType["ROTATE_END"] = "INTERACTION.ROTATE_END";
})(VSInteractionType || (VSInteractionType = {}));
var VSObject = function VSObject() {
    "use strict";
    var model = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    _class_call_check(this, VSObject);
    this.id = model.id || null;
    this.title = model.title || null;
    this.url = model.url || null;
    this.materialUrl = model.materialUrl || null;
    this.fileName = model.fileName || null;
    this.scaleX = model.scaleX || 0.01;
    this.scaleY = model.scaleY || 0.01;
    this.scaleZ = model.scaleZ || 0.01;
    this.rotationX = model.rotationX || 0;
    this.rotationY = model.rotationY || 0;
    this.rotationZ = model.rotationZ || 0;
    this.tourId = model.tourId || null;
    this.image = model.image || null;
    this.category = model.category || null;
    this.copyright = model.copyright || null;
    this.isDefault = model.isDefault || false;
    this.updatedAt = model.updatedAt || null;
    this.isGLTF = model.isGLTF || false;
    this.audioSrc = model.audioSrc || null;
};
var TourObject = function TourObject() {
    "use strict";
    var model = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(this, TourObject);
    this.id = model.id || null;
    this.vsObjectId = model.vsObjectId || null;
    this.uuid = model.uuid || null;
    this.scaleX = model.scaleX || 0.01;
    this.scaleY = model.scaleY || 0.01;
    this.scaleZ = model.scaleZ || 0.01;
    this.positionX = model.positionX || 0;
    this.positionY = model.positionY || 0;
    this.positionZ = model.positionZ || 0;
    this.rotationX = model.rotationX || 0;
    this.rotationY = model.rotationY || 0;
    this.rotationZ = model.rotationZ || 0;
    this.details = Object.assign(model.vsObject || {});
    this.updatedAt = model.updatedAt || null;
    this.active = typeof model.active === "boolean" ? model.active : true;
    // If the user has enabled the hoverAnimation toggle in Admin or if the object has an actionType, enable hover animation (which will add a collider to the object and make it hoverable/clickable)
    this.enableHoverAnimation = !!model.enableHoverAnimation || model.actionType && model.actionType !== TourActionType.None;
    this.hideOnAnimationFinished = typeof model.hideOnAnimationFinished === "boolean" ? model.hideOnAnimationFinished : false;
    this.enableIdleAnimation = typeof model.enableIdleAnimation === "boolean" ? model.enableIdleAnimation : false;
    this.audioEnabled = typeof model.audioEnabled === "boolean" ? model.audioEnabled : false;
    if (this.details.audioSrc) {
        this.audioSrc = this.details.audioSrc.startsWith("http") ? this.details.audioSrc : "".concat("https://cdn.treedis.com", "/").concat(this.details.audioSrc).concat((0,_components_util_all__WEBPACK_IMPORTED_MODULE_0__/* .getVersion */ .bo)(new Date()));
    } else this.audioSrc = null;
    this.floor = typeof model.floor === "number" ? model.floor : null;
    this.srX = model.srX || 0;
    this.srY = model.srY || 0;
    this.srZ = model.srZ || 0;
    this.sweepUuid = model.sweep_uuid || null;
    this.animated = model.animated;
    this.loop = model.loop || false;
    this.toursVSImages = model.toursVSImages;
    var _renderRange;
    this.renderRange = (_renderRange = model.renderRange) !== null && _renderRange !== void 0 ? _renderRange : null;
    var _startAnimationDistance;
    this.startAnimationDistance = (_startAnimationDistance = model.startAnimationDistance) !== null && _startAnimationDistance !== void 0 ? _startAnimationDistance : null;
    this.panoramaId = model.panoramaId || null;
    // actions
    this.actionType = model.actionType || TourActionType.None;
    this.action = model.action || TourAction.Click;
    this.actionURL = model.actionURL || null;
    this.actionRes = model.actionRes || TourActionRes.Percentage;
    this.actionWidth = model.actionWidth || 80;
    this.actionHeight = model.actionHeight || 60;
    this.actionResMobile = model.actionResMobile || TourActionRes.Percentage;
    this.actionWidthMobile = model.actionWidthMobile || 82;
    this.actionHeightMobile = model.actionHeightMobile || 47;
};
var VSImage = /*#__PURE__*/ (/* unused pure expression or super */ null && (function() {
    "use strict";
    function VSImage() {
        var model = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        _class_call_check(this, VSImage);
        this.id = model.id || null;
        this.title = model.title || null;
        this.url = model.url || null;
        this.scaleX = model.scaleX || 0.1;
        this.scaleY = model.scaleY || 0.1;
        this.scaleZ = 0;
        this.rotationX = model.rotationX || 0;
        this.rotationY = model.rotationY || 0;
        this.rotationZ = model.rotationZ || 0;
        this.tourId = model.tourId || null;
        this.image = model.image || null;
        this.updatedAt = model.updatedAt || null;
        this.isDefault = false;
        this.isVSImage = true;
    }
    var _proto = VSImage.prototype;
    _proto.getURL = function getURL() {
        var url = "".concat("https://cdn.treedis.com").concat(this.url).concat(getVersion(new Date()));
        if (this.url.includes("http")) {
            url = this.url;
        }
        return url;
    };
    return VSImage;
}()));
var TourImage = /*#__PURE__*/ function() {
    "use strict";
    function TourImage() {
        var model = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(this, TourImage);
        this.id = model.id || null;
        this.vsImageId = model.vsImageId || null;
        this.toursVSObjectId = model.toursVSObjectId || null;
        this.toursVSVideoId = model.toursVSVideoId || null;
        this.toursVSObjectIdAfterAnimation = model.toursVSObjectIdAfterAnimation || null;
        this.toursVSVideoIdAfterAnimation = model.toursVSVideoIdAfterAnimation || null;
        this.uuid = model.uuid || null;
        this.width = model.width;
        this.height = model.height;
        this.scaleX = model.scaleX || 0.1;
        this.scaleY = model.scaleY || 0.1;
        this.scaleZ = 0;
        this.positionX = model.positionX || 0;
        this.positionY = model.positionY || 0;
        this.positionZ = model.positionZ || 0;
        this.rotationX = model.rotationX || 0;
        this.rotationY = model.rotationY || 0;
        this.rotationZ = model.rotationZ || 0;
        this.autoRotate = model.autoRotate || false;
        this.details = Object.assign(model.vsImage || {});
        this.updatedAt = model.updatedAt || null;
        this.isVSImage = true;
        this.active = typeof model.active === "boolean" ? model.active : true;
        this.enableAnimation = typeof model.enableAnimation === "boolean" ? model.enableAnimation : false;
        this.enableHoverAnimation = typeof model.enableHoverAnimation === "boolean" ? model.enableHoverAnimation : false;
        this.animationPulse = typeof model.animationPulse === "boolean" ? model.animationPulse : false;
        this.animationUpDown = typeof model.animationUpDown === "boolean" ? model.animationUpDown : false;
        this.animationFlip = typeof model.animationFlip === "boolean" ? model.animationFlip : false;
        this.effectOpacity = typeof model.effectOpacity === "boolean" ? model.effectOpacity : false;
        this.effectStopAnimation = typeof model.effectStopAnimation === "boolean" ? model.effectStopAnimation : false;
        this.effectHide = typeof model.effectHide === "boolean" ? model.effectHide : false;
        var _renderRange;
        this.renderRange = (_renderRange = model.renderRange) !== null && _renderRange !== void 0 ? _renderRange : null;
        var _startAnimationDistance;
        this.startAnimationDistance = (_startAnimationDistance = model.startAnimationDistance) !== null && _startAnimationDistance !== void 0 ? _startAnimationDistance : null;
        var _delay;
        this.delay = (_delay = model.delay) !== null && _delay !== void 0 ? _delay : 0;
        // actions
        this.actionType = model.actionType || TourActionType.None;
        this.action = model.action || TourAction.Click;
        this.actionURL = model.actionURL || null;
        this.dontInterruptBgAudio = model.dontInterruptBgAudio || false;
        this.text = model.text || null;
        this.popupTitle = model.popupTitle || null;
        this.actionRes = model.actionRes || TourActionRes.Percentage;
        this.actionWidth = model.actionWidth || 80;
        this.actionHeight = model.actionHeight || 60;
        this.actionResMobile = model.actionResMobile || TourActionRes.Percentage;
        this.actionWidthMobile = model.actionWidthMobile || 82;
        this.actionHeightMobile = model.actionHeightMobile || 47;
        this.panoramaId = model.panoramaId || null;
        this.menuId = model.menuId || null;
        this.subMenuId = model.subMenuId || null;
        this.subSubMenuId = model.subSubMenuId || null;
        this.floor = typeof model.floor === "number" ? model.floor : null;
        this.sweepUuid = model.sweep_uuid || null;
        this.srX = model.srX || 0;
        this.srY = model.srY || 0;
        this.srZ = model.srZ || 0;
        this.rotation = model.rotation || TourVSImageRotation.Vertical;
        this.backgroundColor = model.backgroundColor || "#000000";
        this.backgroundOpacity = model.backgroundOpacity || 0.7;
        this.textColor = model.textColor || "#ffffff";
        this.buttonColor = model.buttonColor || "#ffffff";
    }
    var _proto = TourImage.prototype;
    _proto.getURL = function getURL() {
        var url = "".concat("https://cdn.treedis.com").concat(this.details.url).concat((0,_components_util_all__WEBPACK_IMPORTED_MODULE_0__/* .getVersion */ .bo)(new Date()));
        // if (this.isVSImage && this.actionType === TourImageActionType.ExperiencePopUp) {
        //   return '/play_experience.svg';
        // }
        if (this.details.url.includes("http")) {
            url = this.details.url;
        }
        return url;
    };
    return TourImage;
}();
var VSHtml = function VSHtml() {
    "use strict";
    var model = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    _class_call_check(this, VSHtml);
    this.id = model.id || null;
    this.title = model.title || null;
    this.url = model.url || null;
    this.scaleX = model.scaleX || 0.1;
    this.scaleY = model.scaleY || 0.1;
    this.scaleZ = model.scaleZ || 0.1;
    this.rotationX = model.rotationX || 0;
    this.rotationY = model.rotationY || 0;
    this.rotationZ = model.rotationZ || 0;
    this.tourId = model.tourId || null;
    this.image = model.image || null;
    this.updatedAt = model.updatedAt || null;
    this.isVSHtml = true;
};
var TourVSHtml = function TourVSHtml() {
    "use strict";
    var model = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(this, TourVSHtml);
    this.id = model.id || null;
    this.vsHtmlId = model.vsHtmlId || null;
    this.uuid = model.uuid || null;
    this.scaleX = model.scaleX || 0.1;
    this.scaleY = model.scaleY || 0.1;
    this.scaleZ = model.scaleZ || 0.1;
    this.positionX = model.positionX || 0;
    this.positionY = model.positionY || 0;
    this.positionZ = model.positionZ || 0;
    this.rotationX = model.rotationX || 0;
    this.rotationY = model.rotationY || 0;
    this.rotationZ = model.rotationZ || 0;
    this.details = Object.assign(model.vsHtml || {});
    this.updatedAt = model.updatedAt || null;
    this.isVSHtml = true;
    this.active = model.active;
    this.floor = typeof model.floor === "number" ? model.floor : null;
    this.sweepUuid = model.sweep_uuid || null;
    this.srX = model.srX || 0;
    this.srY = model.srY || 0;
    this.srZ = model.srZ || 0;
    this.node = model.node;
    this.renderRange = model.renderRange || null;
    var _delay;
    this.delay = (_delay = model.delay) !== null && _delay !== void 0 ? _delay : 0;
};
var VSVideoType;
(function(VSVideoType) {
    VSVideoType["Local"] = "local";
    VSVideoType["Vimeo"] = "vimeo";
})(VSVideoType || (VSVideoType = {}));
var VSVideo = /*#__PURE__*/ function() {
    "use strict";
    function VSVideo() {
        var model = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(this, VSVideo);
        this.id = model.id || null;
        this.title = model.title || "";
        this.url = model.url || "";
        this.type = model.type || VSVideoType.Local;
        this.width = model.width || 2;
        this.height = model.height || 2;
        this.scaleX = model.scaleX || 1;
        this.scaleY = model.scaleY || 1;
        this.scaleZ = model.scaleZ || 1;
        this.rotationX = model.rotationX || 0;
        this.rotationY = model.rotationY || 0;
        this.rotationZ = model.rotationZ || 0;
        this.tourId = model.tourId || null;
        this.image = model.image || null;
        this.greenScreenEnabled = typeof model.greenScreenEnabled === "boolean" ? model.greenScreenEnabled : false;
        this.greenScreenColor = model.greenScreenColor;
        this.updatedAt = model.updatedAt || null;
        this.isDefault = false;
        this.isVSImage = false;
        this.isVSVideo = true;
    }
    var _proto = VSVideo.prototype;
    _proto.getVideoURL = function getVideoURL() {
        if (!this.url) return "";
        var url = "".concat("https://cdn.treedis.com").concat(this.url).concat((0,_components_util_all__WEBPACK_IMPORTED_MODULE_0__/* .getVersion */ .bo)(new Date()));
        if (this.url.includes("http")) {
            url = this.url;
        }
        return url;
    };
    _proto.getURL = function getURL() {
        if (!this.image) return "";
        var image = "".concat("https://cdn.treedis.com").concat(this.image).concat((0,_components_util_all__WEBPACK_IMPORTED_MODULE_0__/* .getVersion */ .bo)(new Date()));
        if (this.image.includes("http")) {
            image = this.image;
        }
        return image;
    };
    return VSVideo;
}();
var TourVideo = /*#__PURE__*/ function() {
    "use strict";
    function TourVideo() {
        var model = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(this, TourVideo);
        this.id = model.id || null;
        this.vsVideoId = model.vsVideoId || null;
        this.uuid = model.uuid || null;
        this.tourId = model.tourId || null;
        this.scaleX = model.scaleX || 1;
        this.scaleY = model.scaleY || 1;
        this.scaleZ = model.scaleZ || 1;
        this.positionX = model.positionX || 0;
        this.positionY = model.positionY || 0;
        this.positionZ = model.positionZ || 0;
        this.rotationX = model.rotationX || 0;
        this.rotationY = model.rotationY || 0;
        this.rotationZ = model.rotationZ || 0;
        this.details = Object.assign(model.vsVideo || model.details || new VSVideo());
        this.updatedAt = model.updatedAt || null;
        this.isVSImage = false;
        this.isVSVideo = true;
        this.hideMuteButton = model.hideMuteButton || false;
        this.isDefaultMuted = model.isDefaultMuted || false;
        this.autoRotate = model.autoRotate || false;
        this.enableHoverAnimation = typeof model.enableHoverAnimation === "boolean" ? model.enableHoverAnimation : false;
        this.animationPulse = typeof model.animationPulse === "boolean" ? model.animationPulse : false;
        this.animationUpDown = typeof model.animationUpDown === "boolean" ? model.animationUpDown : false;
        this.animationFlip = typeof model.animationFlip === "boolean" ? model.animationFlip : false;
        this.effectOpacity = typeof model.effectOpacity === "boolean" ? model.effectOpacity : false;
        this.effectStopAnimation = typeof model.effectStopAnimation === "boolean" ? model.effectStopAnimation : false;
        this.effectHide = typeof model.effectHide === "boolean" ? model.effectHide : false;
        this.active = typeof model.active === "boolean" ? model.active : true;
        this.sweep_uuid = model.sweep_uuid || null;
        this.sweepUuid = model.sweep_uuid || null;
        this.srX = model.srX || 0;
        this.srY = model.srY || 0;
        this.srZ = model.srZ || 0;
        this.floor = typeof model.floor === "number" ? model.floor : null;
        this.autoplay = typeof model.autoplay === "boolean" ? model.autoplay : true;
        this.loop = typeof model.loop === "boolean" ? model.loop : true;
        var _renderRange;
        this.renderRange = (_renderRange = model.renderRange) !== null && _renderRange !== void 0 ? _renderRange : null;
        var _startAnimationDistance;
        this.startAnimationDistance = (_startAnimationDistance = model.startAnimationDistance) !== null && _startAnimationDistance !== void 0 ? _startAnimationDistance : null;
        var _delay;
        this.delay = (_delay = model.delay) !== null && _delay !== void 0 ? _delay : 0;
        this.hideOnAnimationFinished = typeof model.hideOnAnimationFinished === "boolean" ? model.hideOnAnimationFinished : false;
        this.isShowPreLoader = model.isShowPreLoader;
        this.greenScreenStrength = model.greenScreenStrength;
        this.greenScreenSmoothness = model.greenScreenSmoothness;
        this.greenScreenSpill = model.greenScreenSpill;
        this.videoPlayedOnce = false;
    }
    var _proto = TourVideo.prototype;
    _proto.getVideoURL = function getVideoURL() {
        if (!this.details || !this.details.url) return "";
        var url = "".concat("https://cdn.treedis.com").concat(this.details.url).concat((0,_components_util_all__WEBPACK_IMPORTED_MODULE_0__/* .getVersion */ .bo)(new Date()));
        if (this.details.url.includes("http")) {
            url = this.details.url;
        }
        return url;
    };
    _proto.getURL = function getURL() {
        if (!this.details || !this.details.image) return "";
        var image = "".concat("https://cdn.treedis.com").concat(this.details.image).concat((0,_components_util_all__WEBPACK_IMPORTED_MODULE_0__/* .getVersion */ .bo)(new Date()));
        if (this.details.image.includes("http")) {
            image = this.details.image;
        }
        return image;
    };
    return TourVideo;
}();


/***/ }),

/***/ 23276:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Im": function() { return /* binding */ videoRendererType; }
/* harmony export */ });
/* unused harmony exports VideoRenderer, makeVideoRenderer */
/* harmony import */ var _Scene_component__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(98472);
/* harmony import */ var _components_util_deviceManager__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(99080);









var LoadingState;
(function(LoadingState) {
    LoadingState["Idle"] = "Idle";
    LoadingState["Loaded"] = "Loaded";
    LoadingState["Loading"] = "Loading";
    LoadingState["Error"] = "Error";
})(LoadingState || (LoadingState = {}));
var DEFAULT_WIDTH = 1;
// const DEFAULT_RADIUS = 0.1;
var VideoRenderer = /*#__PURE__*/ (/* unused pure expression or super */ null && (function(SceneComponent) {
    "use strict";
    _inherits(VideoRenderer, SceneComponent);
    var _super = _create_super(VideoRenderer);
    function VideoRenderer() {
        _class_call_check(this, VideoRenderer);
        var _this;
        _this = _super.apply(this, arguments);
        _this.root = null;
        _this.pivot = null;
        _this.plane = null;
        _this.backSidePlane = null;
        _this.playBtn = null;
        _this.muteBtn = null;
        _this.aspect = 1.77;
        _this.aspectHeight = DEFAULT_WIDTH / _this.aspect;
        _this.hasPlayPermission = false;
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        _this.destroyButton = function() {};
        _this.inputs = {
            src: null,
            muted: true,
            loop: true,
            autoplay: true,
            visible: true,
            playsInline: true,
            localRotation: {
                x: 0,
                y: 0,
                z: 0
            },
            skipRender: false,
            width: DEFAULT_WIDTH
        };
        _this.outputs = {
            texture: null,
            loadingState: LoadingState.Idle
        };
        var _obj;
        // setting which events are compatible with the component
        _this.events = (_obj = {}, _define_property(_obj, ComponentInteractionType.CLICK, true), _define_property(_obj, ComponentInteractionType.HOVER, true), _define_property(_obj, ComponentInteractionType.DRAG, false), _obj);
        _this.getSize = function() {
            return [
                _this.inputs.width,
                _this.aspectHeight
            ];
        };
        return _this;
    }
    var _proto = VideoRenderer.prototype;
    _proto.onInit = function onInit() {
        var THREE = this.context.three;
        this.root = new THREE.Object3D();
        this.pivot = new THREE.Object3D();
        this.outputs.objectRoot = this.root;
        if (this.inputs.visible) {
            // setting the collider to add the click event
            this.outputs.collider = this.root;
        }
        this.root.add(this.pivot);
    };
    _proto.onInputsUpdated = function onInputsUpdated() {
        var _this = this;
        try {
            if (this.inputs.skipRender) {
                var localRotation = this.inputs.localRotation;
                this.root.rotation.set(localRotation.x, localRotation.y, localRotation.z);
                return;
            }
            this.releaseTexture();
            var THREE = this.context.three;
            if (!this.inputs.src) {
                this.video.src = "";
                this.outputs.loadingState = LoadingState.Idle;
                return;
            }
            this.outputs.loadingState = LoadingState.Loading;
            if (_instanceof(this.inputs.src, HTMLVideoElement)) {
                this.video = this.inputs.src;
            } else {
                this.video = this.createVideoElement();
                if (typeof this.inputs.src === "string") {
                    this.video.src = this.inputs.src;
                } else {
                    this.video.srcObject = this.inputs.src;
                }
                this.video.load();
            }
            var onCanPlay = function() {
                var ref, ref1, ref2;
                var videoElement = _this.video;
                var audioDataNotPresented = (videoElement === null || videoElement === void 0 ? void 0 : videoElement.webkitAudioDecodedByteCount) === 0 || (videoElement === null || videoElement === void 0 ? void 0 : videoElement.mozHasAudio) === false || (videoElement === null || videoElement === void 0 ? void 0 : (ref = videoElement.audioTracks) === null || ref === void 0 ? void 0 : ref.length) === 0;
                if (audioDataNotPresented) {
                    if (_this.destroyButton && typeof _this.destroyButton === "function") {
                        _this.destroyButton();
                    }
                }
                _this.video.removeEventListener("canplaythrough", onCanPlay);
                var _video = _this.video, videoWidth = _video.videoWidth, videoHeight = _video.videoHeight;
                if (!videoWidth || !videoHeight) {
                    // return console.debug('Unable to get video resolution.');
                    throw new Error("Unable to get video resolution.");
                }
                _this.aspect = videoWidth / videoHeight;
                _this.aspectHeight = _this.inputs.width / _this.aspect;
                var geometry = new THREE.PlaneGeometry(_this.inputs.width, _this.aspectHeight);
                // TODO: finish with rounded rectangle
                // https://threejs.org/examples/#webgl_geometry_shapes - rounded rect shape
                // const geometry = this.makeRoundedRect(
                //   0,
                //   0,
                //   this.inputs.width,
                //   this.aspectHeight,
                //   this.inputs.useRadius ? DEFAULT_RADIUS : 0,
                // );
                _this.texture = new THREE.VideoTexture(_this.video);
                _this.texture.encoding = THREE.sRGBEncoding;
                _this.texture.minFilter = THREE.LinearFilter;
                _this.texture.magFilter = THREE.LinearFilter;
                _this.texture.format = THREE.RGBAFormat;
                _this.texture.wrapS = THREE.ClampToEdgeWrapping; // THREE.RepeatWrapping
                _this.texture.wrapT = THREE.ClampToEdgeWrapping; // THREE.RepeatWrapping
                _this.texture.repeat.set(1, 1);
                var material = new THREE.MeshBasicMaterial({
                    map: _this.texture,
                    blending: THREE.NormalBlending,
                    transparent: true,
                    visible: _this.inputs.visible
                });
                var backSideMaterial = new THREE.MeshBasicMaterial({
                    side: THREE.DoubleSide,
                    color: 0x000000,
                    transparent: false,
                    visible: _this.inputs.visible,
                    polygonOffset: true,
                    polygonOffsetUnits: -4
                });
                _this.plane = new THREE.Mesh(geometry, material);
                (ref1 = _this.pivot) === null || ref1 === void 0 ? void 0 : ref1.add(_this.plane);
                // fixing plane the position
                // this.plane.position.set(
                //   -((this.inputs.width * this.aspect) / 2),
                //   -(this.aspectHeight / 2),
                //   0,
                // );
                // this.plane.scale.set(
                //   this.aspect,
                //   1,
                //   1,
                // );
                _this.backSidePlane = new THREE.Mesh(geometry, backSideMaterial);
                _this.backSidePlane.position.set(0, 0, -0.01);
                (ref2 = _this.pivot) === null || ref2 === void 0 ? void 0 : ref2.add(_this.backSidePlane);
                // fixing plane the position
                // this.backSidePlane.position.set(
                //   -((this.inputs.width * this.aspect) / 2),
                //   -(this.aspectHeight / 2),
                //   -0.01,
                // );
                var localRotation = _this.inputs.localRotation;
                _this.root.rotation.set(localRotation.x, localRotation.y, localRotation.z);
                _this.outputs.texture = _this.texture;
                _this.outputs.loadingState = LoadingState.Loaded;
                if (_this.inputs.autoplay) {
                    var _this1 = _this;
                    var interval = setInterval(/*#__PURE__*/ _async_to_generator(function() {
                        var err;
                        return _ts_generator(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    _state.trys.push([
                                        0,
                                        2,
                                        ,
                                        3
                                    ]);
                                    return [
                                        4,
                                        _this1.video.play()
                                    ];
                                case 1:
                                    _state.sent();
                                    clearInterval(interval);
                                    return [
                                        3,
                                        3
                                    ];
                                case 2:
                                    err = _state.sent();
                                    console.error(err);
                                    return [
                                        3,
                                        3
                                    ];
                                case 3:
                                    return [
                                        2
                                    ];
                            }
                        });
                    }), 1000);
                }
            };
            var onError = function() {
                _this.video.removeEventListener("error", onError);
                _this.outputs.loadingState = LoadingState.Error;
            };
            this.video.addEventListener("canplaythrough", onCanPlay);
            this.video.addEventListener("error", onError);
            if (DeviceManager.isIOS()) {
                this.video.addEventListener("pause", function() {
                    // mute and play the video in case the browser stopped it
                    // i.e. Safari stops the video if the other one was unmuted
                    if (_this.video.paused && _this.hasPlayPermission) {
                        _this.toggleMute();
                    }
                }, false);
            }
        } catch (e) {
            console.error("[VideoRenderer]:", e);
            this.outputs.loadingState = LoadingState.Error;
        }
    };
    _proto.onDestroy = function onDestroy() {
        this.releaseTexture();
        if (this.playBtn) {
            var ref;
            (ref = this.playBtn.parent) === null || ref === void 0 ? void 0 : ref.remove(this.playBtn);
            this.playBtn.material.dispose();
            this.playBtn.geometry.dispose();
            this.playBtn = null;
        }
        if (this.muteBtn) {
            var ref1;
            (ref1 = this.muteBtn.parent) === null || ref1 === void 0 ? void 0 : ref1.remove(this.muteBtn);
            this.muteBtn.material.dispose();
            this.muteBtn.geometry.dispose();
            this.muteBtn = null;
        }
    };
    _proto.isMuted = function isMuted() {
        return this.video.muted;
    };
    _proto.toggleMute = function toggleMute(muted) {
        var value = typeof muted === "boolean" ? muted : !this.video.muted;
        if (!this.video) return;
        this.video.muted = value;
        if (DeviceManager.isIOS() && !value && !this.hasPlayPermission) {
            // Safari support the autoplay unmute only after user interacts with Treedis website (not iframe)
            // https://developer.apple.com/documentation/webkit/delivering_video_content_for_safari#3030259
            var overlay = document.createElement("div");
            overlay.setAttribute("id", "video-overlay");
            overlay.style.width = "100vw";
            overlay.style.height = "100vh";
            overlay.style.zIndex = "9999";
            overlay.style.position = "fixed";
            overlay.style.top = "0";
            overlay.style.left = "0";
            var _this = this;
            var handler = function() {
                var _ref = _async_to_generator(function() {
                    var hasOverlay;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                hasOverlay = document.getElementById("video-overlay");
                                if (!hasOverlay) return [
                                    2
                                ];
                                document.body.removeChild(overlay);
                                overlay.removeEventListener("click", handler);
                                overlay.removeEventListener("mouseup", handler);
                                overlay.removeEventListener("mousemove", handler);
                                overlay.removeEventListener("touchstart", handler);
                                overlay.removeEventListener("touchmove", handler);
                                _this.hasPlayPermission = true;
                                return [
                                    4,
                                    _this.video.play()
                                ];
                            case 1:
                                _state.sent();
                                // in case with iOS Safari browser, the video is muted at the moment (read the link below)
                                // https://developer.apple.com/documentation/webkit/delivering_video_content_for_safari#3030259
                                //
                                // so, we need to unmute it and display the current state
                                _this.video.muted = false;
                                return [
                                    2
                                ];
                        }
                    });
                });
                return function handler() {
                    return _ref.apply(this, arguments);
                };
            }();
            overlay.addEventListener("click", handler);
            overlay.addEventListener("mousedown", handler);
            overlay.addEventListener("mousemove", handler);
            overlay.addEventListener("touchstart", handler);
            overlay.addEventListener("touchmove", handler);
            document.body.append(overlay);
        } else {
            this.video.play().catch(function(e) {
                console.error(e);
            });
        }
    };
    _proto.releaseTexture = function releaseTexture() {
        if (this.texture) {
            this.outputs.texture = null;
            this.outputs.loadingState = LoadingState.Idle;
            this.texture.dispose();
        }
        if (this.video) {
            this.video.pause();
            this.video.src = "";
        }
        if (this.plane) {
            var ref;
            (ref = this.plane.parent) === null || ref === void 0 ? void 0 : ref.remove(this.plane);
            this.plane.material.dispose();
            this.plane.geometry.dispose();
            this.plane = null;
        }
        if (this.backSidePlane) {
            var ref1;
            (ref1 = this.backSidePlane.parent) === null || ref1 === void 0 ? void 0 : ref1.remove(this.backSidePlane);
            this.backSidePlane.material.dispose();
            this.backSidePlane.geometry.dispose();
            this.backSidePlane = null;
        }
    };
    _proto.createVideoElement = function createVideoElement() {
        var _inputs = this.inputs, muted = _inputs.muted, loop = _inputs.loop, autoplay = _inputs.autoplay, playsInline = _inputs.playsInline;
        var video = document.createElement("video");
        video.crossOrigin = "anonymous";
        video.autoplay = Boolean(autoplay);
        video.muted = Boolean(muted);
        video.loop = Boolean(loop);
        video.playsInline = Boolean(playsInline);
        return video;
    };
    return VideoRenderer;
}(SceneComponent)));
var videoRendererType = "treedis.videoRenderer";
function makeVideoRenderer() {
    return new VideoRenderer();
}


/***/ }),

/***/ 29519:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "w0": function() { return /* binding */ AudioModule; },
  "nR": function() { return /* reexport */ MusicObj; },
  "NO": function() { return /* reexport */ MusicObjectKey; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(20414);
// EXTERNAL MODULE: ./node_modules/howler/dist/howler.js
var howler = __webpack_require__(41766);
// EXTERNAL MODULE: ./_models/Tag.tsx
var Tag = __webpack_require__(42725);
// EXTERNAL MODULE: ./_models/virtualStaging/Polygon.tsx
var Polygon = __webpack_require__(59524);
// EXTERNAL MODULE: ./_models/virtualStaging/VSObject.tsx
var VSObject = __webpack_require__(15864);
// EXTERNAL MODULE: ./components/util/all.ts
var util_all = __webpack_require__(40488);
;// CONCATENATED MODULE: ./utils/isValidUrl.ts
/**
 * Checks if a URL is valid by sending a HEAD request to it.
 * @param {string} url - The URL to validate.
 * @returns {Promise<boolean>} A promise that resolves to true if the URL is valid, false otherwise.
 */ 

function isValidUrl(url) {
    return _isValidUrl.apply(this, arguments);
}
function _isValidUrl() {
    _isValidUrl = (0,_async_to_generator/* default */.Z)(function(url) {
        var error;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    if (!url) return [
                        2,
                        false
                    ];
                    return [
                        4,
                        fetch(url, {
                            method: "HEAD"
                        })
                    ];
                case 1:
                    _state.sent();
                    return [
                        2,
                        true
                    ];
                case 2:
                    error = _state.sent();
                    return [
                        2,
                        false
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return _isValidUrl.apply(this, arguments);
}
/* harmony default export */ var utils_isValidUrl = (isValidUrl);

;// CONCATENATED MODULE: ./components-new/common/types.ts

var MusicObjectKey;
(function(MusicObjectKey) {
    MusicObjectKey["GAME_SELECTED_AUDIO"] = "GAME_SELECTED_AUDIO";
    MusicObjectKey["BUTTON"] = "BUTTON";
    MusicObjectKey["TAGS"] = "TAGS";
    MusicObjectKey["POLYGONS"] = "POLYGONS";
    MusicObjectKey["VSIMAGES"] = "VSIMAGES";
    MusicObjectKey["PANORAMAS"] = "PANORAMAS";
    MusicObjectKey["SWEEPGROUPS"] = "SWEEPGROUPS";
    MusicObjectKey["FLOORS"] = "FLOORS";
    MusicObjectKey["TOUR"] = "TOUR";
})(MusicObjectKey || (MusicObjectKey = {}));
var _obj;
var MusicObj = (_obj = {}, (0,_define_property/* default */.Z)(_obj, MusicObjectKey.GAME_SELECTED_AUDIO, {
    name: MusicObjectKey.GAME_SELECTED_AUDIO,
    priority: 1
}), (0,_define_property/* default */.Z)(_obj, MusicObjectKey.BUTTON, {
    name: MusicObjectKey.BUTTON,
    priority: 2
}), (0,_define_property/* default */.Z)(_obj, MusicObjectKey.TAGS, {
    name: MusicObjectKey.TAGS,
    priority: 2
}), (0,_define_property/* default */.Z)(_obj, MusicObjectKey.POLYGONS, {
    name: MusicObjectKey.POLYGONS,
    priority: 2
}), (0,_define_property/* default */.Z)(_obj, MusicObjectKey.VSIMAGES, {
    name: MusicObjectKey.VSIMAGES,
    priority: 2
}), (0,_define_property/* default */.Z)(_obj, MusicObjectKey.PANORAMAS, {
    name: MusicObjectKey.PANORAMAS,
    priority: 2
}), (0,_define_property/* default */.Z)(_obj, MusicObjectKey.SWEEPGROUPS, {
    name: MusicObjectKey.SWEEPGROUPS,
    priority: 3
}), (0,_define_property/* default */.Z)(_obj, MusicObjectKey.FLOORS, {
    name: MusicObjectKey.FLOORS,
    priority: 4
}), (0,_define_property/* default */.Z)(_obj, MusicObjectKey.TOUR, {
    name: MusicObjectKey.TOUR,
    priority: 5
}), _obj);

// EXTERNAL MODULE: ./utils/emiter.ts
var emiter = __webpack_require__(40897);
// EXTERNAL MODULE: ./components/types.ts
var types = __webpack_require__(31828);
;// CONCATENATED MODULE: ./components-new/common/AudioModule.ts
















howler.Howler.autoSuspend = false;
var AudioModule = /*#__PURE__*/ function() {
    "use strict";
    function AudioModule() {
        var _this = this;
        (0,_class_call_check/* default */.Z)(this, AudioModule);
        // @ts-ignore
        this.musicData = {};
        this.videosForSoundControl = [];
        this.volumeValue = 1;
        this.isAllMusicMute = false;
        this.lowestPriotiryLevel = 10;
        this.playList = [];
        this.isGreenScreenPlaying = false;
        this.repeatCount = 3;
        this.isTourAudioPaused = true;
        this.removeAudioFromPlayList = function(type, id) {
            _this.playList = _this.playList.filter(function(el) {
                return el.id !== "".concat(id);
            });
        };
        this.removeDuplicatedAudio = function(id, type) {
            _this.playList.filter(function(audio) {
                return type === audio.type.name || id === audio.id;
            }).forEach(function(param) {
                var audio = param.audio;
                return audio.pause();
            });
            _this.playList = _this.playList.filter(function(audio) {
                return audio.id !== id && (!type || type !== audio.type.name);
            });
        };
        this.sleep = function(ms) {
            return new Promise(function(resolve) {
                return setTimeout(resolve, ms);
            });
        };
        var _this1 = this;
        this.repeatMusicCall = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(type, objectId) {
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                _this1.startPlay(_this1.getAudio(type, objectId), 0)
                            ];
                        case 1:
                            _state.sent();
                            return [
                                2
                            ];
                    }
                });
            });
            return function(type, objectId) {
                return _ref.apply(this, arguments);
            };
        }();
        var _this2 = this;
        this.repeatNextMusicCall = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(nextAudio) {
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                _this2.startPlay(nextAudio, 0)
                            ];
                        case 1:
                            _state.sent();
                            return [
                                2
                            ];
                    }
                });
            });
            return function(nextAudio) {
                return _ref.apply(this, arguments);
            };
        }();
        this.setVSAudiosVolume = function(value) {
            var ref;
            (ref = _this.videosForSoundControl) === null || ref === void 0 ? void 0 : ref.forEach(function(videoNode) {
                var video = videoNode.video;
                if (value === 0) {
                    video.muted = true;
                } else {
                    var ref;
                    video.volume = value;
                    // Unmuting only videos that were unmuted before
                    if (!(videoNode === null || videoNode === void 0 ? void 0 : (ref = videoNode.muteBtn) === null || ref === void 0 ? void 0 : ref.active)) {
                        video.muted = false;
                    }
                }
            });
        };
        var _this3 = this;
        this.startPlay = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(audio, index) {
                var e;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            if (index >= _this3.repeatCount) return [
                                2
                            ];
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                2,
                                ,
                                5
                            ]);
                            // Pause currently playing audio before playing new one
                            _this3.pauseAllMusic();
                            // Mute VS Audios if any are playing
                            _this3.setVSAudiosVolume(0);
                            audio === null || audio === void 0 ? void 0 : audio.mute(_this3.isAllMusicMute || _this3.volumeValue === 0);
                            audio === null || audio === void 0 ? void 0 : audio.play();
                            return [
                                3,
                                5
                            ];
                        case 2:
                            e = _state.sent();
                            return [
                                4,
                                _this3.sleep(500)
                            ];
                        case 3:
                            _state.sent();
                            return [
                                4,
                                _this3.startPlay(audio, index + 1)
                            ];
                        case 4:
                            _state.sent();
                            return [
                                3,
                                5
                            ];
                        case 5:
                            return [
                                2
                            ];
                    }
                });
            });
            return function(audio, index) {
                return _ref.apply(this, arguments);
            };
        }();
        this.setTourMusic = function(value) {
            _this.isTourAudioPaused = value;
        };
        this.isPlaying = function(id) {
            return _this.playList.some(function(i) {
                return i.id === "".concat(id) && i.audio.playing();
            });
        };
        this.getVolume = function() {
            return _this.volumeValue;
        };
        this.getAllMusicData = function() {
            return _this.musicData;
        };
        this.isTourMusicPaused = function() {
            return _this.isTourAudioPaused;
        };
        this.getAudioByType = function(type) {
            var ref;
            return (ref = _this.musicData) === null || ref === void 0 ? void 0 : ref[type];
        };
        this.getAudio = function(type, id) {
            var ref, ref1;
            return (ref = _this.musicData) === null || ref === void 0 ? void 0 : (ref1 = ref[type]) === null || ref1 === void 0 ? void 0 : ref1["".concat(id)];
        };
        this.getTourMusic = function() {
            return _this.playList.find(function(el) {
                return el.type.name === MusicObjectKey.TOUR;
            });
        };
        this.setGreenScreenPlaying = function(value) {
            _this.isGreenScreenPlaying = value;
        };
        var _this4 = this;
        this.stopTourMusic = /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        // Passing false to prevent removing tour audio from playlist
                        // This will ensure that the tour/floor music resumes after the current audio ends
                        // This is a fix for TB-3423
                        // In case there's a bug in the future where the tour/floor music plays when it shouldn't, this is the first place to check
                        return [
                            4,
                            _this4.stopAudioByType(MusicObjectKey.TOUR, false)
                        ];
                    case 1:
                        _state.sent();
                        return [
                            4,
                            _this4.stopAudioByType(MusicObjectKey.FLOORS, false)
                        ];
                    case 2:
                        _state.sent();
                        _this4.setTourMusic(true);
                        return [
                            2
                        ];
                }
            });
        });
        this.changeSelectedAudioLoop = function(type, id, value) {
            var ref;
            (ref = _this.getAudio(type, id)) === null || ref === void 0 ? void 0 : ref.loop(value);
        };
        this.changeSelectedAudioVolume = function(type, id, value) {
            var ref;
            (ref = _this.getAudio(type, id)) === null || ref === void 0 ? void 0 : ref.volume(value);
        };
        this.getFirstMusic = function() {
            return _this.playList[0];
        };
        var _this5 = this;
        this.resumeMusic = /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            _this5.nextMusic()
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        var _this6 = this;
        this.pauseAudio = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
                var ref, audio;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            audio = (ref = _this6.playList.find(function(a) {
                                return a.id === "".concat(id);
                            })) === null || ref === void 0 ? void 0 : ref.audio;
                            audio === null || audio === void 0 ? void 0 : audio.pause();
                            if (!(_this6.playList.length > 1)) return [
                                3,
                                2
                            ];
                            _this6.playList.push(_this6.playList.shift());
                            return [
                                4,
                                _this6.nextMusic()
                            ];
                        case 1:
                            _state.sent();
                            _state.label = 2;
                        case 2:
                            return [
                                2
                            ];
                    }
                });
            });
            return function(id) {
                return _ref.apply(this, arguments);
            };
        }();
        var _this7 = this;
        this.resumeAudio = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
                var // Pausing currently playing audio before resuming
                ref, ref1, ref2;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    (ref = _this7.getFirstMusic().audio) === null || ref === void 0 ? void 0 : ref.pause();
                    (ref1 = _this7.playList.find(function(audio) {
                        return audio.id === "".concat(id);
                    })) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.audio) === null || ref2 === void 0 ? void 0 : ref2.play();
                    return [
                        2
                    ];
                });
            });
            return function(id) {
                return _ref.apply(this, arguments);
            };
        }();
        var _this8 = this;
        this.stopAudioByType = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(type) {
                var removeFromPlaylist;
                var _arguments = arguments;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            removeFromPlaylist = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : true;
                            // Unmute any VS Videos playing
                            _this8.setVSAudiosVolume(_this8.volumeValue);
                            _this8.playList.filter(function(el) {
                                return el.type.name === type;
                            }).forEach(function(param) {
                                var audio = param.audio;
                                return audio.pause();
                            });
                            if (removeFromPlaylist) {
                                _this8.playList = _this8.playList.filter(function(el) {
                                    return el.type.name !== type;
                                });
                            }
                            // To avoid tour music playing again after pausing, we pass 'true' (TB-3478)
                            return [
                                4,
                                _this8.nextMusic(true)
                            ];
                        case 1:
                            _state.sent();
                            return [
                                2
                            ];
                    }
                });
            });
            return function(type) {
                return _ref.apply(this, arguments);
            };
        }();
        this.pauseAllMusic = function() {
            var overridePriority = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true;
            _this.playList.forEach(function(i) {
                i.audio.pause();
                // to change play btn icon
                if (i.type.name === MusicObjectKey.TOUR || i.type.name === MusicObjectKey.FLOORS) {
                    emiter/* emitter.emit */.u.emit(types/* MittEvents.TOUR_AUDIO_PLAY */.sp.TOUR_AUDIO_PLAY, false);
                }
            });
            if (overridePriority) {
                _this.nowPlayingPriorityLevel = _this.lowestPriotiryLevel;
            }
        };
        this.addMusicToVolumeControl = function(el) {
            _this.videosForSoundControl.push(el);
        };
        this.allPlayingVideosAreMuted = function() {
            return !_this.videosForSoundControl.some(function(el) {
                return !el.video.paused && el.video.volume > 0 && !el.video.muted;
            });
        };
        this.muteHandler = function(state) {
            _this.isAllMusicMute = state;
            Object.values(_this.musicData).forEach(function(data) {
                Object.values(data).forEach(function(el) {
                    el.mute(state);
                });
            });
        };
        this.volumeHandler = function(value) {
            if (!value && value !== 0) return;
            _this.volumeValue = value;
            _this.setVSAudiosVolume(value);
            Object.values(_this.musicData).forEach(function(data) {
                Object.values(data).forEach(function(el) {
                    if (value === 0) {
                        el.mute(true);
                    } else {
                        el.volume(value);
                        el.mute(false);
                    }
                });
            });
            // Clear existing timeout to cancel previous delayed operation
            clearTimeout(_this.eventDebounceId);
            // Delay execution of the emitter.emit until 500ms after this function is last executed
            _this.eventDebounceId = setTimeout(function() {
                emiter/* emitter.emit */.u.emit(types/* MittEvents.AUDIO_VOLUME */.sp.AUDIO_VOLUME, _this.volumeValue);
            }, 500);
        };
        this.tourHasAudio = function() {
            return Object.keys(_this.musicData).length > 0 || _this.videosForSoundControl.length > 0;
        };
        // Removing all audios from playlist except tour audio
        // By the new request from Ely, now we don't resume songs if they got interrupted (exept tour audio)
        this.clearPlayListQueue = function() {
            _this.playList.forEach(function(el) {
                if (el.type.name !== MusicObjectKey.TOUR && el.type.name !== MusicObjectKey.FLOORS) {
                    var ref;
                    // reseting audio for when it's played again
                    var audio = _this.getAudio(el.type.name, el.id);
                    if (!audio) return;
                    audio.stop();
                    // removing from playlist
                    _this.removeAudioFromPlayList(el === null || el === void 0 ? void 0 : (ref = el.type) === null || ref === void 0 ? void 0 : ref.name, el === null || el === void 0 ? void 0 : el.id);
                }
            });
        };
        var _this9 = this;
        this.playAudio = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
                var _type, type, priority, id, playListAudio, isTourMusic, err, index;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _type = data.type, type = _type.name, priority = _type.priority, id = data.id;
                            if (!_this9.getAudio(type, id) || _this9.isPlaying(id)) {
                                return [
                                    2
                                ];
                            }
                            playListAudio = {
                                id: "".concat(id),
                                audio: _this9.getAudio(type, id),
                                priority: priority,
                                type: data.type
                            };
                            if (!(_this9.nowPlayingPriorityLevel >= priority || !_this9.nowPlayingPriorityLevel)) return [
                                3,
                                5
                            ];
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                2,
                                ,
                                4
                            ]);
                            isTourMusic = type === MusicObjectKey.TOUR || type === MusicObjectKey.FLOORS;
                            emiter/* emitter.emit */.u.emit(types/* MittEvents.TOUR_AUDIO_PLAY */.sp.TOUR_AUDIO_PLAY, isTourMusic);
                            if (isTourMusic) {
                                _this9.isTourAudioPaused = false;
                            }
                            _this9.nowPlayingPriorityLevel = priority;
                            if (type === MusicObjectKey.SWEEPGROUPS) {
                                // remove all existing sweep audio to prevent play it after new sweep audio ends
                                _this9.removeDuplicatedAudio(playListAudio.id, MusicObjectKey.SWEEPGROUPS);
                            } else {
                                _this9.removeDuplicatedAudio(playListAudio.id);
                            }
                            _this9.startPlay(_this9.getAudio(type, id), 0);
                            _this9.clearPlayListQueue();
                            _this9.playList.unshift(playListAudio);
                            return [
                                3,
                                4
                            ];
                        case 2:
                            err = _state.sent();
                            return [
                                4,
                                _this9.repeatMusicCall(type, "".concat(id))
                            ];
                        case 3:
                            _state.sent();
                            if (!_this9.getAudio(type, id).playing()) {
                                console.error("Can't play ".concat(type, " audio. Message: ").concat(err));
                            } else {
                                _this9.pauseAllMusic();
                            }
                            return [
                                3,
                                4
                            ];
                        case 4:
                            return [
                                2
                            ];
                        case 5:
                            index = _this9.playList.findIndex(function(el) {
                                return el.priority > priority;
                            });
                            _this9.removeDuplicatedAudio(playListAudio.id);
                            if (index) {
                                _this9.playList.splice(index - 1, 0, playListAudio);
                            } else {
                                _this9.playList.push(playListAudio);
                            }
                            return [
                                2
                            ];
                    }
                });
            });
            return function(data) {
                return _ref.apply(this, arguments);
            };
        }();
        // Import music from requests to musicData
        this.urlHandling = function(type, data) {
            var src;
            var awsUrl = "https://cdn.treedis.com";
            switch(type){
                case MusicObjectKey.POLYGONS:
                    if (data.url && data.actionType === Polygon/* PolygonActionType.Music */.zS.Music) {
                        src = "".concat(awsUrl, "/tours/").concat(data.tourId, "/polygons/").concat(data.url);
                    }
                    break;
                case MusicObjectKey.PANORAMAS:
                    if (data.url) {
                        src = "".concat(awsUrl, "/tours/").concat(data.tourId, "/panoramas/").concat(data.panoramaUrl, "/").concat(data.url);
                    }
                    break;
                case MusicObjectKey.TAGS:
                    if (data.url && data.type === Tag/* TagType.Music */.Qy.Music) {
                        src = "".concat(awsUrl, "/tours/").concat(data.tourId, "/tags/").concat(data.url);
                    }
                    break;
                case MusicObjectKey.TOUR:
                    src = "".concat(awsUrl, "/tours/").concat(data.id, "/music.mp3").concat(util_all/* getVersion */.bo(data.updatedAt));
                    break;
                case MusicObjectKey.FLOORS:
                    if (data.url) {
                        src = "".concat(data.url);
                    }
                    break;
                case MusicObjectKey.SWEEPGROUPS:
                    if (data.music) {
                        src = "".concat(awsUrl, "/tours/").concat(data.tourId, "/sweeps/").concat(data.music);
                    }
                    break;
                case MusicObjectKey.VSIMAGES:
                    if (data.actionURL && data.actionType === VSObject/* TourActionType.Music */.mI.Music) {
                        if (data.actionURL.toString().includes("http")) {
                            src = data.actionURL.toString();
                        } else {
                            src = "".concat(awsUrl, "/tours/").concat(data.tourId, "/vsimages/").concat(data.actionURL);
                        }
                    }
                    break;
                case MusicObjectKey.BUTTON:
                    if (data.buttonSoundUrl) {
                        src = "".concat(awsUrl, "/tours/").concat(data.tourId, "/game/").concat(data.id, "/").concat(data.buttonSoundUrl);
                    }
                    break;
                case MusicObjectKey.GAME_SELECTED_AUDIO:
                    if (data.sound) {
                        src = "".concat("https://cdn.treedis.com", "/games/").concat(data.gameId, "/locks/").concat(data.id, "/").concat(data.sound);
                    }
                    break;
                default:
                    break;
            }
            return src;
        };
        var _this10 = this;
        this.createAudioStream = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(type, data) {
                var src, objectId, isValid, audioObject;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            // If a tour audio already exists - don't add a new one
                            if (type === MusicObjectKey.TOUR && _this10.getAudioByType(type)) return [
                                2
                            ];
                            src = _this10.urlHandling(type, data);
                            objectId = data.id.toString();
                            return [
                                4,
                                utils_isValidUrl(src)
                            ];
                        case 1:
                            isValid = _state.sent();
                            if (isValid) {
                                audioObject = new howler.Howl({
                                    src: src,
                                    autoplay: false,
                                    mute: _this10.isAllMusicMute,
                                    volume: _this10.volumeValue
                                });
                                audioObject.once("end", /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
                                    return (0,tslib_es6.__generator)(this, function(_state) {
                                        switch(_state.label){
                                            case 0:
                                                audioObject.unload();
                                                _this10.removeAudioFromPlayList(type, objectId);
                                                return [
                                                    4,
                                                    _this10.nextMusic()
                                                ];
                                            case 1:
                                                _state.sent();
                                                return [
                                                    2
                                                ];
                                        }
                                    });
                                }));
                                // @ts-ignore
                                audioObject.id = objectId;
                                _this10.musicData[type] = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, _this10.getAudioByType(type)), (0,_define_property/* default */.Z)({}, objectId, audioObject));
                            }
                            return [
                                2
                            ];
                    }
                });
            });
            return function(type, data) {
                return _ref.apply(this, arguments);
            };
        }();
        var _this11 = this;
        this.importAudioData = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(type, data) {
                var promises;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    promises = data === null || data === void 0 ? void 0 : data.map(function(element) {
                        return _this11.createAudioStream(type, element);
                    }).filter(Boolean);
                    if (promises) return [
                        2,
                        Promise.all(promises)
                    ];
                    return [
                        2,
                        Promise.resolve()
                    ];
                });
            });
            return function(type, data) {
                return _ref.apply(this, arguments);
            };
        }();
    }
    var _proto = AudioModule.prototype;
    _proto.nextMusic = function nextMusic() {
        var skipTourMusic = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
        var _this = this;
        return (0,_async_to_generator/* default */.Z)(function() {
            var ref, firstMusicIsTour, music, err;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (_this.isGreenScreenPlaying || !_this.playList.length) return [
                            2
                        ];
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            5
                        ]);
                        firstMusicIsTour = ((ref = _this.playList[0]) === null || ref === void 0 ? void 0 : ref.type.name) === MusicObjectKey.TOUR;
                        music = skipTourMusic && firstMusicIsTour ? _this.playList[1] : _this.playList[0];
                        if (!music) return [
                            2
                        ];
                        return [
                            4,
                            _this.repeatNextMusicCall(music.audio)
                        ];
                    case 2:
                        _state.sent();
                        if (music.type.name === MusicObjectKey.TOUR) _this.isTourAudioPaused = false;
                        _this.nowPlayingPriorityLevel = music.priority;
                        return [
                            3,
                            5
                        ];
                    case 3:
                        err = _state.sent();
                        console.error("Can't play next music. Message: ".concat(err));
                        _this.playList.shift();
                        return [
                            4,
                            _this.nextMusic()
                        ];
                    case 4:
                        _state.sent();
                        return [
                            3,
                            5
                        ];
                    case 5:
                        return [
                            2
                        ];
                }
            });
        })();
    };
    AudioModule.getInstance = function getInstance() {
        if (!AudioModule.instance) {
            AudioModule.instance = new AudioModule();
        }
        return AudioModule.instance;
    };
    return AudioModule;
}();


/***/ }),

/***/ 81389:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d": function() { return /* binding */ GameBookLocationType; }
/* harmony export */ });
var GameBookLocationType;
(function(GameBookLocationType) {
    GameBookLocationType["sweep"] = "sweep";
    GameBookLocationType["tourLink"] = "tourLink";
})(GameBookLocationType || (GameBookLocationType = {}));


/***/ }),

/***/ 31828:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AR": function() { return /* binding */ Mode; },
/* harmony export */   "FX": function() { return /* binding */ ExternalProvider; },
/* harmony export */   "MP": function() { return /* binding */ ConditionLocationType; },
/* harmony export */   "QB": function() { return /* binding */ vsTriggerType; },
/* harmony export */   "XI": function() { return /* binding */ GameStatus; },
/* harmony export */   "_B": function() { return /* binding */ PAGE_PATH; },
/* harmony export */   "o2": function() { return /* binding */ ShowcaseElement; },
/* harmony export */   "sp": function() { return /* binding */ MittEvents; }
/* harmony export */ });
/* unused harmony export TItemsFilter */
var TItemsFilter;
(function(TItemsFilter) {
    TItemsFilter[TItemsFilter["Tags"] = 0] = "Tags";
    TItemsFilter[TItemsFilter["Sweeps"] = 1] = "Sweeps";
})(TItemsFilter || (TItemsFilter = {}));
var Mode;
(function(Mode) {
    Mode[Mode["day"] = 3] = "day";
    Mode[Mode["week"] = 21] = "week";
    Mode[Mode["month"] = 90] = "month";
})(Mode || (Mode = {}));
var PAGE_PATH;
(function(PAGE_PATH) {
    PAGE_PATH["ALL"] = "all";
    PAGE_PATH["TOUR"] = "tour";
    PAGE_PATH["EXPERIENCE"] = "experience";
    PAGE_PATH["ECOMMERCE"] = "e-commerce-tour";
})(PAGE_PATH || (PAGE_PATH = {}));
var ConditionLocationType;
(function(ConditionLocationType) {
    ConditionLocationType["sweep"] = "sweep";
    ConditionLocationType["tourLink"] = "tourLink";
})(ConditionLocationType || (ConditionLocationType = {}));
var GameStatus;
(function(GameStatus) {
    GameStatus["NotStarted"] = "not_started";
    GameStatus["Started"] = "started";
    GameStatus["OutroClip"] = "outro_clip";
    GameStatus["SuccessfullyEnded"] = "successfully_ended";
    GameStatus["SuccessfullyEndedWithoutFinalScreen"] = "successfully_ended_without_final_screen";
    GameStatus["SuccessfullyEndedWithSimpleFinalScreen"] = "successfully_ended_with_simple_final_screen";
    GameStatus["TimeIsUpEnded"] = "timup_ended";
})(GameStatus || (GameStatus = {}));
var ExternalProvider;
(function(ExternalProvider) {
    ExternalProvider["SHOPIFY"] = "shopify";
    ExternalProvider["OPTICAL_CENTER"] = "opticalCenter";
    ExternalProvider["HAVELLS"] = "havells";
})(ExternalProvider || (ExternalProvider = {}));
var vsTriggerType;
(function(vsTriggerType) {
    vsTriggerType["default"] = "default";
    vsTriggerType["revealCondition"] = "revealCondition";
})(vsTriggerType || (vsTriggerType = {}));
var ShowcaseElement;
(function(ShowcaseElement) {
    ShowcaseElement["TagPanel"] = "TAG_PANEL";
    ShowcaseElement["TagPanelHeader"] = "TAG_PANEL_HEADER";
    ShowcaseElement["LoaderPowerBy"] = "LOADER_POWER_BY";
    ShowcaseElement["LoaderPresentedBy"] = "LOADER_PRESENTED_BY";
    ShowcaseElement["TagEmbedMedia"] = "TAG_EMBED_MEDIA";
    ShowcaseElement["ErrorContainer"] = "ERROR_CONTAINER";
    ShowcaseElement["VRLayer"] = "VR_LAYER";
})(ShowcaseElement || (ShowcaseElement = {}));
var MittEvents;
(function(MittEvents) {
    MittEvents["AUDIO_VOLUME"] = "audio_volume";
    MittEvents["AUDIO_MUTE"] = "audio_mute";
    MittEvents["TOUR_AUDIO_PLAY"] = "tour_audio_play";
})(MittEvents || (MittEvents = {}));


/***/ }),

/***/ 40488:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BS": function() { return /* binding */ getBaseURL; },
/* harmony export */   "DF": function() { return /* binding */ buildLink; },
/* harmony export */   "Dv": function() { return /* binding */ getQueryVariable; },
/* harmony export */   "Jw": function() { return /* binding */ setWhiteLabel; },
/* harmony export */   "NM": function() { return /* binding */ round; },
/* harmony export */   "QD": function() { return /* binding */ isVimeoUrl; },
/* harmony export */   "R6": function() { return /* binding */ getTicketTypeCount; },
/* harmony export */   "bo": function() { return /* binding */ getVersion; },
/* harmony export */   "fg": function() { return /* binding */ downloadFloorPlan; },
/* harmony export */   "gb": function() { return /* binding */ getBucketLink; },
/* harmony export */   "i1": function() { return /* binding */ getAllQueryVariables; },
/* harmony export */   "k": function() { return /* binding */ updatePanoRotation; },
/* harmony export */   "oH": function() { return /* binding */ validateEmail; },
/* harmony export */   "oo": function() { return /* binding */ hexToRgb; },
/* harmony export */   "pb": function() { return /* binding */ ticketingTypes; },
/* harmony export */   "rQ": function() { return /* binding */ fetchData; },
/* harmony export */   "rp": function() { return /* binding */ getVideoLink; },
/* harmony export */   "tG": function() { return /* binding */ openLinkInNewTab; },
/* harmony export */   "vQ": function() { return /* binding */ copyToClipboard; }
/* harmony export */ });
/* unused harmony exports getICEServers, getPanoramaIndex, getYoutubeVideoQueryVariable */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(20414);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(30381);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_toastify__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(72132);
/* harmony import */ var _utils_index__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(31344);
/* harmony import */ var _axios__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(54453);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(46021);
/* provided dependency */ var process = __webpack_require__(34155);







function getVersion(date) {
    return moment__WEBPACK_IMPORTED_MODULE_0___default()().diff(date, "days") === 0 ? "?v=".concat(moment__WEBPACK_IMPORTED_MODULE_0___default()(date).format("HHmmss")) : "";
}
function setWhiteLabel(tour) {
    var ref;
    if (!tour || !tour.user) return;
    var client = tour.client;
    var u = tour.user;
    // eslint-disable-next-line no-nested-ternary
    var user = ((ref = u.admin) === null || ref === void 0 ? void 0 : ref.id) === 1 ? u : u.admin && !(u.domainUrl && u.whitelabelId) ? u.admin : u;
    var whitelabelActive = user.whitelabelId;
    var clientLogoActive = client && client.whitelabelId && client.whitelabelLogo;
    var w = client && client.whitelabelId && clientLogoActive ? client : user;
    var c = client && client.whitelabelId ? client : user;
    var website = whitelabelActive && w.website ? w.website : "https://treedis.com";
    var logoUrl = "".concat("https://cdn.treedis.com", "/").concat(clientLogoActive ? "clients" : "users", "/").concat(clientLogoActive ? client.id : user.id, "/logo.png").concat(getVersion(clientLogoActive ? client.updatedAt : user.updatedAt));
    var whiteLabelData = {
        primaryColor: whitelabelActive ? c.primaryColor || "#292929" : "#292929",
        secondaryColor: whitelabelActive ? c.secondaryColor || "#2055ff" : "#2055ff",
        logo: whitelabelActive ? logoUrl : (0,_utils_index__WEBPACK_IMPORTED_MODULE_2__/* .getAsset */ .Nh)("logo-white.svg"),
        website: website.includes("https://") ? website : "https://".concat(website.replace("http://", "")),
        domainUrl: whitelabelActive ? user.domainUrl || "my.treedis.com" : "my.treedis.com",
        active: whitelabelActive
    };
    document.documentElement.style.setProperty("--color-primary", "".concat(whiteLabelData.primaryColor));
    document.documentElement.style.setProperty("--color-secondary", "".concat(whiteLabelData.secondaryColor));
    this.setState({
        whiteLabelData: whiteLabelData
    });
}
function getICEServers() {
    return _getICEServers.apply(this, arguments);
}
function _getICEServers() {
    _getICEServers = _async_to_generator(function() {
        var username, secret, res, response, servers;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    username = process.env.NEXT_PUBLIC_XIRSYS_USERNAME;
                    secret = process.env.NEXT_PUBLIC_XIRSYS_SECRET;
                    return [
                        4,
                        axios.put("https://global.xirsys.net/_turn/crm", {
                            format: "urls",
                            expire: 40
                        }, {
                            headers: {
                                Authorization: "Basic ".concat(btoa("".concat(username, ":").concat(secret)))
                            }
                        })
                    ];
                case 1:
                    res = _state.sent();
                    response = res.data;
                    if (!response) throw new Error("ICE failed to respond, please retry");
                    servers = response.v;
                    if (response.s === "ok" && servers.iceServers) {
                        return [
                            2,
                            [
                                servers.iceServers
                            ]
                        ];
                    }
                    throw new Error("ICE failed to respond, please retry: ".concat(response.v));
            }
        });
    });
    return _getICEServers.apply(this, arguments);
}
function fetchData() {
    return _fetchData.apply(this, arguments);
}
function _fetchData() {
    _fetchData = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function() {
        var _url, method, body, config, url, response;
        var _arguments = arguments;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _url = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : "", method = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : "get", body = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : null, config = _arguments.length > 3 && _arguments[3] !== void 0 ? _arguments[3] : {};
                    url = "v1/".concat(_url);
                    if (_url.includes("https://")) url = _url;
                    return [
                        4,
                        _axios__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z[method.toLowerCase()](url, body, config)
                    ];
                case 1:
                    response = _state.sent();
                    if (response.status === 200) {
                        return [
                            2,
                            response.data
                        ];
                    }
                    if (response.data) react_toastify__WEBPACK_IMPORTED_MODULE_1__/* .toast.error */ .Am.error(response.data.message);
                    return [
                        2,
                        null
                    ];
            }
        });
    });
    return _fetchData.apply(this, arguments);
}
function getPanoramaIndex(panoramas, id) {
    return panoramas.findIndex(function(p) {
        return p.id === id;
    });
}
function getQueryVariable(query, variable) {
    if (!query || !variable) return false;
    query = decodeURIComponent(query.split("?")[1]);
    var vars = query.split("&");
    for(var i = 0; i < vars.length; i += 1){
        var pair = vars[i].split("=");
        if (pair[0] === variable) {
            return pair[1];
        }
    }
    return false;
}
function getAllQueryVariables(query) {
    var prefix = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "&";
    if (!query) return "";
    return "".concat(prefix).concat(query.split("?").pop());
}
function getYoutubeVideoQueryVariable(query, variable) {
    if (!query || !variable) return "";
    if (getQueryVariable(query, variable)) {
        return getQueryVariable(query, variable);
    }
    return query.split("/").pop();
}
function getVideoLink(url, settings) {
    if (!url) return "";
    var autoplay;
    if (settings && typeof settings.autoplay === "boolean") {
        autoplay = settings.autoplay ? 1 : 0;
    } else {
        autoplay = (settings === null || settings === void 0 ? void 0 : settings.autoplay) === undefined ? 1 : settings === null || settings === void 0 ? void 0 : settings.autoplay;
    }
    var mute = (settings === null || settings === void 0 ? void 0 : settings.mute) === undefined ? false : settings === null || settings === void 0 ? void 0 : settings.mute;
    var muteQueryParam = mute ? "&mute=1" : "";
    var urlC = [];
    if (url.includes("https://vimeo.com/")) {
        urlC = url.split("https://vimeo.com/");
    } else if (url.includes("https://player.vimeo.com/video/")) {
        urlC = url.split("https://player.vimeo.com/video/");
    }
    if (urlC.length > 1) {
        muteQueryParam = mute ? "&&muted=1" : "";
        var subtitlesParam = (settings === null || settings === void 0 ? void 0 : settings.subtitles) ? "&&texttrack=".concat(settings === null || settings === void 0 ? void 0 : settings.subtitles) : "";
        var link = "https://player.vimeo.com/video/".concat(urlC[1], "?autoplay=").concat(autoplay, "&title=0&byline=0&portrait=0").concat(muteQueryParam).concat(subtitlesParam, "&dnt=").concat((settings === null || settings === void 0 ? void 0 : settings.dnt) ? 1 : 0, "&fullscreen=").concat((settings === null || settings === void 0 ? void 0 : settings.fullscreen) ? 1 : 0);
        if (urlC[1].includes("/")) {
            var videoId = urlC[1].split("/")[0];
            var videoKey = urlC[1].split("/")[1].split("?")[0];
            link = "https://player.vimeo.com/video/".concat(videoId, "?h=").concat(videoKey, "&autoplay=").concat(autoplay, "&title=0&byline=0&portrait=0").concat(muteQueryParam).concat(subtitlesParam, "&dnt=").concat((settings === null || settings === void 0 ? void 0 : settings.dnt) ? 1 : 0);
        }
        return link;
    }
    var subtitlesParam1 = (settings === null || settings === void 0 ? void 0 : settings.subtitles) ? "&&hl=".concat(settings === null || settings === void 0 ? void 0 : settings.subtitles) : "";
    return "https://www.youtube.com/embed/".concat(getYoutubeVideoQueryVariable(url, "v"), "?autoplay=").concat(autoplay).concat(muteQueryParam).concat(subtitlesParam1, "&dnt=").concat((settings === null || settings === void 0 ? void 0 : settings.dnt) ? 1 : 0);
}
function isVimeoUrl(url) {
    return /^(https?:)?\/\/((player|www)\.)?vimeo\.com(?=$|\/)/.test(url);
}
function getBaseURL() {
    return window.location.href.split("?")[0];
}
function buildLink(s, rotation) {
    var m = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null, target = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null;
    var link = "".concat(getBaseURL(), "?s=").concat(s, "&x=").concat(rotation.x, "&y=").concat(rotation.y);
    if (m) link += "&m=".concat(m);
    if (target) link += "&target=".concat(target);
    var ticket = new URLSearchParams(window.location.search).get("ticket");
    if (ticket && ticket.length > 0) link += "&ticket=".concat(ticket);
    return link;
}
function hexToRgb() {
    var hex = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : _constants__WEBPACK_IMPORTED_MODULE_4__/* .DEFAULT_TAG_COLOR.hex */ .K.hex;
    var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16)
    } : _constants__WEBPACK_IMPORTED_MODULE_4__/* .DEFAULT_TAG_COLOR.rgb */ .K.rgb;
}
function copyToClipboard(text) {
    var textarea = document.createElement("textarea");
    textarea.textContent = text;
    textarea.style.position = "fixed"; // Prevent scrolling to bottom of page in Microsoft Edge.
    document.body.appendChild(textarea);
    textarea.select();
    try {
        return document.execCommand("copy"); // Security exception may be thrown by some browsers.
    } catch (ex) {
        console.warn("Copy to clipboard failed.", ex);
        return false;
    } finally{
        document.body.removeChild(textarea);
    }
}
function updatePanoRotation(north, pos) {
    var _state = this.state, minimaps = _state.minimaps, selectedMinimap = _state.selectedMinimap;
    this.panoPose = pos;
    if (!minimaps || minimaps.length === 0 || selectedMinimap === null) return;
    var mapNorth = minimaps[selectedMinimap].north || 0;
    var y = pos.yaw > 0 ? 360 - pos.yaw : -1 * pos.yaw;
    var diff = north - y;
    var mapWalkerRotation = mapNorth + diff;
    this.setState({
        mapWalkerRotation: mapWalkerRotation
    });
}
var downloadFloorPlan = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function(url, plan) {
        var pdfName, pdfType, response, blob, urlTwo, link, err;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    pdfName = (plan === null || plan === void 0 ? void 0 : plan.name) || "";
                    pdfType = (plan === null || plan === void 0 ? void 0 : plan.type) || "pdf";
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        4,
                        ,
                        5
                    ]);
                    return [
                        4,
                        fetch("v1/public/downloadPdf", {
                            method: "POST",
                            body: JSON.stringify({
                                url: url,
                                pdfName: pdfName
                            })
                        })
                    ];
                case 2:
                    response = _state.sent();
                    return [
                        4,
                        response.blob()
                    ];
                case 3:
                    blob = _state.sent();
                    urlTwo = window.URL.createObjectURL(new Blob([
                        blob
                    ]));
                    link = document.createElement("a");
                    link.href = urlTwo;
                    link.setAttribute("download", "".concat(pdfName, ".").concat(pdfType));
                    document.body.appendChild(link);
                    link.click();
                    link.remove();
                    return [
                        3,
                        5
                    ];
                case 4:
                    err = _state.sent();
                    console.error(err.message);
                    return [
                        3,
                        5
                    ];
                case 5:
                    return [
                        2
                    ];
            }
        });
    });
    return function downloadFloorPlan(url, plan) {
        return _ref.apply(this, arguments);
    };
}();
var validateEmail = function(email) {
    var regex = /^([\w-.]+@([\w-]+\.)+[\w-]{2,})+?$/;
    return regex.test(email);
};
var round = function(value, decimals) {
    return Number("".concat(Math.round(Number("".concat(value, "e").concat(decimals))), "e-").concat(decimals));
};
var openLinkInNewTab = function(linkText) {
    var link = document.createElement("a");
    link.href = linkText;
    link.target = "_blanc";
    document.body.appendChild(link);
    link.click();
    link.remove();
};
var getBucketLink = function(append) {
    return "".concat("https://cdn.treedis.com", "/ticketing/").concat(append);
};
var ticketingTypes = [
    {
        key: "ticketingToursByYourself",
        tourType: "tourByYourself",
        title: "Tour by yourself",
        genDeskKey: "tourByYourselfDescription"
    },
    {
        key: "ticketingGameTour",
        tourType: "experienceTour",
        title: "Experience tour",
        genDeskKey: "experienceTourDescription"
    },
    {
        key: "ticketingGuidedTour",
        tourType: "guidedTour",
        title: "Guided tour",
        genDeskKey: "guidedTourDescription"
    }, 
];
var getTicketTypeCount = function(ticketing) {
    return ticketingTypes.reduce(function(acc, ticketTypeObject) {
        var ref;
        if ((ref = ticketing[ticketTypeObject.key]) === null || ref === void 0 ? void 0 : ref.length) {
            acc.num += 1;
            acc.types.push(ticketTypeObject.tourType);
        }
        return acc;
    }, {
        num: 0,
        types: []
    });
};


/***/ }),

/***/ 54453:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50196);

var baseURL = "https://api.treedis.com" || 0;
var instance = axios__WEBPACK_IMPORTED_MODULE_0__/* ["default"].create */ .ZP.create({
    baseURL: baseURL
});
// Add a request interceptor
instance.interceptors.request.use(function(config) {
    // Do something before request is sent
    if (!(config === null || config === void 0 ? void 0 : config.headers) || !(config === null || config === void 0 ? void 0 : config.headers["Content-Type"])) {
        config.headers.Accept = "application/json";
        config.headers["Content-Type"] = "application/json";
    }
    if ((config === null || config === void 0 ? void 0 : config.url.indexOf("http")) >= 0) {
        config.baseURL = null;
    }
    return config;
}, // Do something with request error
function(error) {
    return Promise.reject(error);
});
// Add a response interceptor
instance.interceptors.response.use(// Any status code that lie within the range of 2xx cause this function to trigger
// Do something with response data
function(response) {
    return response;
}, // Any status codes that falls outside the range of 2xx cause this function to trigger
// Do something with response error
function(error) {
    return Promise.reject(error);
});
/* harmony default export */ __webpack_exports__["Z"] = (instance);


/***/ }),

/***/ 46021:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "K": function() { return /* binding */ DEFAULT_TAG_COLOR; }
/* harmony export */ });
/* unused harmony export TAG_DEFAULT */
/* harmony import */ var _models_Tag__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(42725);

var DEFAULT_TAG_COLOR = {
    hex: "#EA475C",
    rgb: {
        r: 234,
        g: 71,
        b: 92
    }
};
var TAG_DEFAULT = {
    custom: true,
    title: null,
    description: null,
    positionX: null,
    positionY: null,
    positionZ: null,
    iconColor: DEFAULT_TAG_COLOR.hex,
    icon: null,
    opacity: 100,
    sid: null,
    enabled: true,
    type: _models_Tag__WEBPACK_IMPORTED_MODULE_0__/* .TagType.Text */ .Qy.Text,
    text: null,
    res: "pixels",
    whiteCircle: false,
    transparentBackground: false,
    mpTooltip: true
};


/***/ }),

/***/ 97666:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "hH": function() { return /* reexport */ closeTagEmbedTagObserver; },
  "zx": function() { return /* reexport */ closeTagPanelObserver; },
  "vQ": function() { return /* reexport */ util_all/* copyToClipboard */.vQ; },
  "fg": function() { return /* reexport */ util_all/* downloadFloorPlan */.fg; },
  "rQ": function() { return /* reexport */ util_all/* fetchData */.rQ; },
  "BS": function() { return /* reexport */ util_all/* getBaseURL */.BS; },
  "Dv": function() { return /* reexport */ util_all/* getQueryVariable */.Dv; },
  "u6": function() { return /* reexport */ getSweepsPath; },
  "R6": function() { return /* reexport */ util_all/* getTicketTypeCount */.R6; },
  "bo": function() { return /* reexport */ util_all/* getVersion */.bo; },
  "rp": function() { return /* reexport */ util_all/* getVideoLink */.rp; },
  "oo": function() { return /* reexport */ util_all/* hexToRgb */.oo; },
  "y9": function() { return /* reexport */ analytic/* sendGameAnalytics */.y9; },
  "o$": function() { return /* reexport */ analytic/* sendToGA */.o$; },
  "D2": function() { return /* reexport */ errorObserver; },
  "v2": function() { return /* reexport */ mpPasswordFormObserver; },
  "p$": function() { return /* reexport */ setTagPanelObserver; },
  "pb": function() { return /* reexport */ util_all/* ticketingTypes */.pb; }
});

// UNUSED EXPORTS: DEFAULT_TAG_COLOR, TAG_DEFAULT, buildLink, calculateMobileHeight, createGA, customSelectStyles, ecommerceDefaultColorBlackSelect, getAllQueryVariables, getBucketLink, getCurrency, getICEServers, getLocation, getPanoramaIndex, getSymbolFromCurrency, getYoutubeVideoQueryVariable, isVimeoUrl, loadModel, moveToMPLabels, moveToStartingPoint, navigateToTag, newEcommerceStyles, openLinkInNewTab, openTagIframe, openVsImageIframe, openVsObjectIframe, openVsVideoIframe, openedPanoHotspot, preventTagAction, round, setNavigationDestination, setWhiteLabel, startGA, takePano, takeScreenshot, toggleContactPopup, toggleExternalPopup, updatePanoRotation, validateEmail

// EXTERNAL MODULE: ./components/util/all.ts
var util_all = __webpack_require__(40488);
// EXTERNAL MODULE: ./components/util/analytic.ts + 2 modules
var analytic = __webpack_require__(44000);
// EXTERNAL MODULE: ./components/util/axios.ts
var axios = __webpack_require__(54453);
// EXTERNAL MODULE: ./components/util/constants.ts
var constants = __webpack_require__(46021);
;// CONCATENATED MODULE: ./components/util/currency.ts
var currency = {
    DE: {
        ISO: "EUR",
        SYM: "€"
    },
    FR: {
        ISO: "EUR",
        SYM: "€"
    },
    AT: {
        ISO: "EUR",
        SYM: "€"
    },
    BE: {
        ISO: "EUR",
        SYM: "€"
    },
    CY: {
        ISO: "EUR",
        SYM: "€"
    },
    EE: {
        ISO: "EUR",
        SYM: "€"
    },
    FI: {
        ISO: "EUR",
        SYM: "€"
    },
    GR: {
        ISO: "EUR",
        SYM: "€"
    },
    IE: {
        ISO: "EUR",
        SYM: "€"
    },
    IT: {
        ISO: "EUR",
        SYM: "€"
    },
    LV: {
        ISO: "EUR",
        SYM: "€"
    },
    LT: {
        ISO: "EUR",
        SYM: "€"
    },
    LU: {
        ISO: "EUR",
        SYM: "€"
    },
    MT: {
        ISO: "EUR",
        SYM: "€"
    },
    NL: {
        ISO: "EUR",
        SYM: "€"
    },
    PT: {
        ISO: "EUR",
        SYM: "€"
    },
    SK: {
        ISO: "EUR",
        SYM: "€"
    },
    SI: {
        ISO: "EUR",
        SYM: "€"
    },
    ES: {
        ISO: "EUR",
        SYM: "€"
    },
    EZ: {
        ISO: "EUR",
        SYM: "€"
    },
    GB: {
        ISO: "GBP",
        SYM: "\xa3"
    },
    US: {
        ISO: "USD",
        SYM: "$"
    }
};
var defaultCur = {
    ISO: "USD",
    SYM: "$"
};
function getCurrency(country) {
    var cur = defaultCur;
    if (currency[country]) cur = currency[country];
    return cur;
}
function getSymbolFromCurrency(cur) {
    var ex = Object.values(currency).find(function(x) {
        return x.ISO === cur;
    });
    ex = ex || defaultCur;
    return ex.SYM;
}

// EXTERNAL MODULE: ./components/util/deviceManager.ts
var deviceManager = __webpack_require__(99080);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_type_of.mjs
var _type_of = __webpack_require__(82222);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(20414);
// EXTERNAL MODULE: ./node_modules/@treedis/tour-loader/dist/index.js + 153 modules
var dist = __webpack_require__(33050);
// EXTERNAL MODULE: ./node_modules/lodash/sortBy.js
var sortBy = __webpack_require__(89734);
var sortBy_default = /*#__PURE__*/__webpack_require__.n(sortBy);
;// CONCATENATED MODULE: ./components/util/pathFinder.ts






var PathNode = /*#__PURE__*/ function() {
    "use strict";
    function PathNode(sweep, pathLengthFromStart, cameFrom, estimatePathLength) {
        (0,_class_call_check/* default */.Z)(this, PathNode);
        this.sweep = sweep;
        this.pathLengthFromStart = pathLengthFromStart;
        this.cameFrom = cameFrom;
        this.estimatePathLength = estimatePathLength;
    }
    var _proto = PathNode.prototype;
    _proto.estimateFullPathLength = function estimateFullPathLength() {
        return this.pathLengthFromStart + this.estimatePathLength;
    };
    return PathNode;
}();
var getPathLength = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(from, to) {
        var THREE, vector1, vector2;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        (0,dist/* iTHREE */.Sc)()
                    ];
                case 1:
                    THREE = _state.sent();
                    vector1 = new THREE.Vector3(from.x, from.y, from.z);
                    vector2 = new THREE.Vector3(to.x, to.y, to.z);
                    return [
                        2,
                        vector1.distanceTo(vector2)
                    ];
            }
        });
    });
    return function getPathLength(from, to) {
        return _ref.apply(this, arguments);
    };
}();
var getNeighbours = function(neighbours, currentNode, endSweep, sweeps) {
    return neighbours.reduce(function(acc, neighborIndex) {
        var sweep = sweeps.find(function(s) {
            return s.index === neighborIndex;
        });
        if (sweep) {
            acc.push(new PathNode(sweep, getPathLength(currentNode.sweep.position, sweep.position), currentNode, getPathLength(sweep.position, endSweep.position)));
        }
        return acc;
    }, []);
};
var getSweepsPath = function(allSweeps, start, end) {
    var _loop = function() {
        var currentNode = sortBy_default()(openSet, [
            function(o) {
                return o.estimateFullPathLength();
            }
        ])[0];
        if (currentNode.sweep.uuid === end) {
            closedSet.push(currentNode);
            var path = [];
            for(var i = 0; i < closedSet.length; i += 1){
                var node = closedSet[i];
                var nextNode = closedSet[i + 1];
                path.push({
                    id: node.sweep.uuid,
                    position: node.sweep.position,
                    rotation: node.sweep.rotation,
                    next: nextNode ? {
                        id: nextNode.sweep.uuid,
                        position: nextNode.sweep.position,
                        rotation: nextNode.sweep.rotation
                    } : null
                });
            }
            return {
                v: path
            };
        }
        openSet = openSet.filter(function(set) {
            return set.sweep.uuid !== currentNode.sweep.uuid;
        });
        closedSet.push(currentNode);
        var neighbors = getNeighbours(currentNode.sweep.neighbors, currentNode, endSweep, sweeps);
        // eslint-disable-next-line no-loop-func
        neighbors.forEach(function(neighbor) {
            if (closedSet.some(function(set) {
                return set.sweep.index === neighbor.sweep.index;
            })) {
                return;
            }
            var openNode = openSet.find(function(set) {
                return set.sweep.index === neighbor.sweep.index;
            });
            if (!openNode) {
                openSet.push(neighbor);
            } else if (openNode.pathLengthFromStart > neighbor.pathLengthFromStart) {
                openNode.cameFrom = currentNode;
                openNode.pathLengthFromStart = neighbor.pathLengthFromStart;
            }
        });
    };
    var sweeps = allSweeps.filter(function(s) {
        return s.tags.indexOf("showcase") || s.uuid === start || s.uuid === end;
    });
    var startSweep = sweeps.find(function(s) {
        return s.uuid === start;
    });
    var endSweep = sweeps.find(function(s) {
        return s.uuid === end;
    });
    var closedSet = [];
    var openSet = [];
    var startNode = new PathNode(startSweep, 0, null, getPathLength(startSweep.position, endSweep.position));
    openSet.push(startNode);
    while(openSet.length > 0){
        var _ret = _loop();
        if ((0,_type_of/* default */.Z)(_ret) === "object") return _ret.v;
    }
    return null;
};

// EXTERNAL MODULE: ./components/util/popups.ts
var popups = __webpack_require__(62818);
// EXTERNAL MODULE: ./components/util/sdk.ts + 2 modules
var sdk = __webpack_require__(68687);
// EXTERNAL MODULE: ./components/util/socket.ts
var socket = __webpack_require__(13607);
// EXTERNAL MODULE: ./components/util/styles.ts
var styles = __webpack_require__(24069);
;// CONCATENATED MODULE: ./components/util/observers/errorObserver.ts
function setErrorObserver(element, callback) {
    if (!element) return;
    // @ts-ignore
    var MutationObserver = window.MutationObserver || window.WebKitMutationObserver;
    var observer = new MutationObserver(function(mutations) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            // eslint-disable-next-line no-restricted-syntax
            for(var _iterator = mutations[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var mutation = _step.value;
                if (mutation.type === "attributes") {
                    var pageCrashed = !mutation.target.classList.contains("hidden");
                    callback(pageCrashed, observer);
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    });
    observer.observe(element, {
        attributes: true
    });
}
/* harmony default export */ var errorObserver = (setErrorObserver);

;// CONCATENATED MODULE: ./components/util/observers/mpPasswordFormObserver.ts
function setMPPasswordFormObserver(element, onShow, onHide) {
    if (!element) return null;
    // @ts-ignore
    var MutationObserver = window.MutationObserver || window.WebKitMutationObserver;
    var observer = new MutationObserver(function(mutations) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            // eslint-disable-next-line no-restricted-syntax
            for(var _iterator = mutations[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var mutation = _step.value;
                if (mutation.type === "childList") {
                    if (mutation.target.id === "showcase-password-container") {
                        var showForm = !!mutation.target.querySelector(".sc-password-ui");
                        if (showForm) {
                            onShow();
                        } else {
                            onHide();
                            observer.disconnect();
                        }
                    }
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    });
    observer.observe(element, {
        childList: true,
        subtree: true
    });
    return observer;
}
/* harmony default export */ var mpPasswordFormObserver = (setMPPasswordFormObserver);

;// CONCATENATED MODULE: ./components/util/observers/mpTagPanelObserver.ts
function closeTagPanelObserver(element) {
    if (!element) return;
    // @ts-ignore
    var MutationObserver = window.MutationObserver || window.WebKitMutationObserver;
    var observer = new MutationObserver(function(mutations) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            var _loop = function() {
                var mutation = _step.value;
                if (mutation.type === "attributes") {
                    var panelOpens = mutation.target.classList.contains("panel-collapsed") || mutation.target.classList.contains("panel-open");
                    if (panelOpens) {
                        setTimeout(function() {
                            var closeButton = mutation.target.querySelector("button");
                            closeButton.click();
                        }, 100);
                        observer.disconnect();
                    }
                }
            };
            // eslint-disable-next-line no-restricted-syntax
            for(var _iterator = mutations[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    });
    observer.observe(element, {
        attributes: true
    });
}
function setTagPanelObserver(element, callback) {
    if (!element) return;
    // @ts-ignore
    var MutationObserver = window.MutationObserver || window.WebKitMutationObserver;
    var observer = new MutationObserver(function(mutations) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            // eslint-disable-next-line no-restricted-syntax
            for(var _iterator = mutations[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var mutation = _step.value;
                if (mutation.type === "attributes") {
                    var panelOpens = mutation.target.classList.contains("panel-collapsed") || mutation.target.classList.contains("panel-open");
                    callback(panelOpens, observer);
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    });
    observer.observe(element, {
        attributes: true
    });
}


;// CONCATENATED MODULE: ./components/util/observers/mpTagEmbedContentObserver.ts
function closeTagEmbedTagObserver(element, callback) {
    if (!element) return;
    // @ts-ignore
    var MutationObserver = window.MutationObserver || window.WebKitMutationObserver;
    var observer = new MutationObserver(function(mutations) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            var _loop = function() {
                var mutation = _step.value;
                if (mutation.type === "childList") {
                    var tagPreviewRemoved = false;
                    mutation.removedNodes.forEach(function(node) {
                        var hasTagPreview = node.classList.contains("tag-preview");
                        if (hasTagPreview) {
                            tagPreviewRemoved = hasTagPreview;
                            return false;
                        }
                    });
                    if (tagPreviewRemoved) {
                        callback();
                        observer.disconnect();
                        return "break";
                    }
                }
            };
            // eslint-disable-next-line no-restricted-syntax
            for(var _iterator = mutations[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var _ret = _loop();
                if (_ret === "break") break;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    });
    observer.observe(element, {
        childList: true,
        subtree: true
    });
}


;// CONCATENATED MODULE: ./components/util/observers/index.ts





;// CONCATENATED MODULE: ./components/util/index.ts















/***/ }),

/***/ 62818:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* binding */ toggleExternalPopup; },
/* harmony export */   "O": function() { return /* binding */ toggleContactPopup; }
/* harmony export */ });
/* harmony import */ var _all__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(40488);
/* harmony import */ var _analytic__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(44000);


function toggleExternalPopup(url, iframeSettings) {
    var externalPopupUrl = url;
    if (url && (url.includes("youtu.be") || url.includes("youtube.com") || url.includes("vimeo.com"))) {
        externalPopupUrl = (0,_all__WEBPACK_IMPORTED_MODULE_0__/* .getVideoLink */ .rp)(url);
    }
    this.setState({
        overlayOn: !this.state.externalPopupOn,
        externalPopupOn: !this.state.externalPopupOn,
        externalPopupUrl: externalPopupUrl,
        markerPopupOn: false,
        iframeSettings: iframeSettings
    });
}
function toggleContactPopup() {
    if (!this.state.contactPopupOn) {
        (0,_analytic__WEBPACK_IMPORTED_MODULE_1__/* .sendToGA */ .o$)("event", {
            eventCategory: "Contact",
            eventAction: "click",
            eventLabel: "open"
        });
        (0,_analytic__WEBPACK_IMPORTED_MODULE_1__/* .sendToGA */ .o$)("event", {
            eventCategory: "Lead",
            eventAction: "open",
            eventLabel: "contact"
        });
    }
    this.setState({
        contactPopupOn: !this.state.contactPopupOn,
        overlayOn: !this.state.contactPopupOn
    });
}


/***/ }),

/***/ 68687:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "k$": function() { return /* binding */ getLocation; },
  "u7": function() { return /* binding */ loadModel; },
  "QO": function() { return /* binding */ moveToMPLabels; },
  "h_": function() { return /* binding */ navigateToTag; },
  "$O": function() { return /* binding */ openTagIframe; },
  "IW": function() { return /* binding */ openVsImageIframe; },
  "BY": function() { return /* binding */ openVsObjectIframe; },
  "O7": function() { return /* binding */ openVsVideoIframe; },
  "Z4": function() { return /* binding */ openedPanoHotspot; },
  "$v": function() { return /* binding */ preventTagAction; },
  "Zy": function() { return /* binding */ takePano; },
  "ss": function() { return /* binding */ takeScreenshot; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(20414);
// EXTERNAL MODULE: ./node_modules/downloadjs/download.js
var download = __webpack_require__(33729);
var download_default = /*#__PURE__*/__webpack_require__.n(download);
// EXTERNAL MODULE: ./node_modules/react-toastify/dist/react-toastify.esm.js
var react_toastify_esm = __webpack_require__(72132);
// EXTERNAL MODULE: ./node_modules/watermarkjs/dist/watermark.js
var watermark = __webpack_require__(60832);
var watermark_default = /*#__PURE__*/__webpack_require__.n(watermark);
// EXTERNAL MODULE: ./node_modules/@treedis/tour-loader/dist/index.js + 153 modules
var dist = __webpack_require__(33050);
// EXTERNAL MODULE: ./_models/Tag.tsx
var Tag = __webpack_require__(42725);
// EXTERNAL MODULE: ./_models/Menu.tsx
var Menu = __webpack_require__(78073);
// EXTERNAL MODULE: ./_models/Tour.tsx + 1 modules
var Tour = __webpack_require__(40784);
// EXTERNAL MODULE: ./_models/game/GameBook.ts
var GameBook = __webpack_require__(97741);
// EXTERNAL MODULE: ./components/util/all.ts
var util_all = __webpack_require__(40488);
// EXTERNAL MODULE: ./components/util/socket.ts
var socket = __webpack_require__(13607);
// EXTERNAL MODULE: ./components/util/index.ts + 7 modules
var util = __webpack_require__(97666);
;// CONCATENATED MODULE: ./components/tour/processNavigationPath.ts





var processNavigationPath = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
        var url, sweeps, startSweep, cb, THREE, sr, ss, linkDataShort, x, y, z, euler, rotation, endSweep, sweepsPath;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    url = param.tagNavigationLink, sweeps = param.sweeps, startSweep = param.startSweep, cb = param.cb;
                    return [
                        4,
                        (0,dist/* iTHREE */.Sc)()
                    ];
                case 1:
                    THREE = _state.sent();
                    sr = (0,util/* getQueryVariable */.Dv)(url, "sr");
                    ss = (0,util/* getQueryVariable */.Dv)(url, "ss");
                    linkDataShort = sr && ss ? {
                        sr: sr.split(","),
                        ss: parseInt(String(ss), 10)
                    } : false;
                    if (linkDataShort) {
                        x = parseFloat(linkDataShort.sr[0] || "0");
                        y = parseFloat(linkDataShort.sr[1] || "0");
                        z = parseFloat(linkDataShort.sr[2] || "0");
                        euler = new THREE.Euler().set(x, y, z, "XYZ").reorder("YXZ");
                        rotation = new THREE.Vector3(euler.x, euler.y, euler.z).multiplyScalar(180 / Math.PI); // @ts-ignore
                        rotation.z = 0;
                        endSweep = sweeps[linkDataShort.ss - 1].uuid;
                        sweepsPath = (0,util/* getSweepsPath */.u6)(sweeps, startSweep, endSweep);
                        cb({
                            sweepsPath: sweepsPath,
                            rotation: rotation
                        });
                    } else {
                        react_toastify_esm/* toast.error */.Am.error("Wrong matterport deep link");
                    }
                    return [
                        2
                    ];
            }
        });
    });
    return function processNavigationPath(_) {
        return _ref.apply(this, arguments);
    };
}();

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_iterator.mjs
var _async_iterator = __webpack_require__(2236);
;// CONCATENATED MODULE: ./components/tour/moveToSweeps.ts
/* eslint-disable no-restricted-syntax */ 




var moveToSweeps = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
        var sweepsPath, targetRotation, poseRotation, rotationAngle, rotationSpeed, transitionSpeed, stopAfterSweep, showcaseSweep, iteration, currentRotation, maxSpeed, minSpeed, delay, THREE, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, id, rotation, next, currentSpeed, curQuaternion, nextQuaternion, angle, err;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    sweepsPath = param.sweepsPath, targetRotation = param.targetRotation, poseRotation = param.poseRotation, rotationAngle = param.rotationAngle, rotationSpeed = param.rotationSpeed, transitionSpeed = param.transitionSpeed, stopAfterSweep = param.stopAfterSweep, showcaseSweep = param.showcaseSweep;
                    iteration = 0;
                    currentRotation = poseRotation;
                    maxSpeed = 5000;
                    minSpeed = 500;
                    delay = 5000;
                    return [
                        4,
                        (0,dist/* iTHREE */.Sc)()
                    ];
                case 1:
                    THREE = _state.sent();
                    if (!showcaseSweep) return [
                        3,
                        17
                    ];
                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                    _state.label = 2;
                case 2:
                    _state.trys.push([
                        2,
                        10,
                        11,
                        16
                    ]);
                    _iterator = (0,_async_iterator/* default */.Z)(sweepsPath);
                    _state.label = 3;
                case 3:
                    return [
                        4,
                        _iterator.next()
                    ];
                case 4:
                    if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                        3,
                        9
                    ];
                    _value = _step.value;
                    id = _value.id, rotation = _value.rotation, next = _value.next;
                    currentSpeed = transitionSpeed;
                    if (next) {
                        curQuaternion = new THREE.Quaternion(rotation.x, rotation.y, rotation.z, rotation.w);
                        nextQuaternion = new THREE.Quaternion(next.rotation.x, next.rotation.y, next.rotation.z, next.rotation.w);
                        angle = curQuaternion.angleTo(nextQuaternion) * 180 / Math.PI;
                        if (angle > rotationAngle) {
                            currentRotation.y += angle;
                            currentSpeed = rotationSpeed;
                        }
                    } else {
                        currentRotation = targetRotation;
                    }
                    return [
                        4,
                        showcaseSweep.moveTo(id, {
                            rotation: currentRotation,
                            transition: showcaseSweep.Transition.FLY,
                            transitionTime: maxSpeed + minSpeed - maxSpeed * currentSpeed / 100
                        })
                    ];
                case 5:
                    _state.sent();
                    if (!(iteration > 0 && iteration !== sweepsPath.length - 1 && !(iteration % stopAfterSweep))) return [
                        3,
                        7
                    ];
                    return [
                        4,
                        new Promise(function(resolve) {
                            return setTimeout(resolve, delay);
                        })
                    ];
                case 6:
                    _state.sent();
                    _state.label = 7;
                case 7:
                    iteration += 1;
                    _state.label = 8;
                case 8:
                    _iteratorAbruptCompletion = false;
                    return [
                        3,
                        3
                    ];
                case 9:
                    return [
                        3,
                        16
                    ];
                case 10:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        16
                    ];
                case 11:
                    _state.trys.push([
                        11,
                        ,
                        14,
                        15
                    ]);
                    if (!(_iteratorAbruptCompletion && _iterator.return != null)) return [
                        3,
                        13
                    ];
                    return [
                        4,
                        _iterator.return()
                    ];
                case 12:
                    _state.sent();
                    _state.label = 13;
                case 13:
                    return [
                        3,
                        15
                    ];
                case 14:
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                    return [
                        7
                    ];
                case 15:
                    return [
                        7
                    ];
                case 16:
                    return [
                        2,
                        Promise.resolve()
                    ];
                case 17:
                    react_toastify_esm/* toast.error */.Am.error("Wait for the model to load");
                    return [
                        2,
                        Promise.reject()
                    ];
            }
        });
    });
    return function moveToSweeps(_) {
        return _ref.apply(this, arguments);
    };
}();

// EXTERNAL MODULE: ./_models/Game.tsx
var Game = __webpack_require__(81766);
// EXTERNAL MODULE: ./components-new/common/AudioModule.ts + 2 modules
var AudioModule = __webpack_require__(29519);
// EXTERNAL MODULE: ./_models/virtualStaging/VideoRenderer.component.tsx
var VideoRenderer_component = __webpack_require__(23276);
// EXTERNAL MODULE: ./utils/extractSweepIdFromURL.ts
var extractSweepIdFromURL = __webpack_require__(33797);
// EXTERNAL MODULE: ./utils/getDistance.ts
var getDistance = __webpack_require__(7926);
;// CONCATENATED MODULE: ./components/util/sdk.ts















// import { sendToGA } from './analytic';







function downloadDirect(url, title) {
    var element = document.createElement("a");
    element.setAttribute("href", url);
    element.setAttribute("download", "".concat(title, ".jpg"));
    element.style.display = "none";
    document.body.appendChild(element);
    element.click();
    document.body.removeChild(element);
}
function takePano() {
    var _this = this;
    if (this.showcase) {
        this.setState({
            loading: true
        });
        this.showcase.Renderer.takeEquirectangular().then(function(url) {
            downloadDirect(url, _this.state.tour.title);
            _this.setState({
                loading: false
            });
        });
    }
}
function getLocation() {
    var m = (0,util_all/* getQueryVariable */.Dv)(this.state.iframeUrl, "m");
    if (m) {
        return (0,util_all/* buildLink */.DF)(this.pose.sweep, this.pose.rotation, m);
    }
    return null;
}
var audioHandler = AudioModule/* AudioModule.getInstance */.w0.getInstance();
function downloadImage(title, url, clientId, width) {
    var options = {
        init: function init(img) {
            // eslint-disable-next-line no-param-reassign
            img.crossOrigin = "anonymous";
        }
    };
    watermark_default()([
        url,
        "".concat("https://cdn.treedis.com", "/clients/").concat(clientId, "/logo.png").concat((0,util_all/* getVersion */.bo)(new Date()))
    ], options).blob(function(target, _watermark) {
        var context = target.getContext("2d");
        context.save();
        var widthRatio = _watermark.width / width;
        var height = _watermark.height / widthRatio;
        context.drawImage(_watermark, 10, 10, width, height);
        context.restore();
        return target;
    }).then(function(img) {
        return download_default()(img, "".concat(title, ".jpg"), "image/jpg");
    });
}
function takeScreenshot(resolution) {
    var _this = this;
    if (this.showcase) {
        var ref;
        var tour = this.state.tour;
        var width = tour.client && tour.client.widthLogo ? 250 : 150;
        this.setState({
            loading: true
        });
        var sweep = (ref = this.state.deprecatedSweeps) === null || ref === void 0 ? void 0 : ref.find(function(sweep) {
            return sweep.id === _this.state.currentSweep.sid || sweep.sweep_uuid === _this.state.currentSweep.sid;
        });
        var title = tour.title;
        if (sweep) {
            title = "".concat(sweep.id, "_").concat(sweep.sweep_uuid);
        }
        this.showcase.Renderer.takeScreenShot(resolution, {
            mattertags: false,
            sweeps: false
        }).then(function(url) {
            if (tour.client && tour.client.logo) {
                downloadImage(title, url, tour.clientId, width);
            } else {
                downloadDirect(url, title);
            }
            _this.setState({
                loading: false
            });
        });
    }
}
function preventTagAction(sid, actions) {
    var ref;
    if ((ref = this) === null || ref === void 0 ? void 0 : ref.showcase) {
        // eslint-disable-next-line no-console
        return this.showcase.Mattertag.preventAction(sid, actions).catch(console.error);
    }
    return null;
}
function navigateToTag(sid) {
    return _navigateToTag.apply(this, arguments);
}
function _navigateToTag() {
    _navigateToTag = (0,_async_to_generator/* default */.Z)(function(sid) {
        var ref, preventAction;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!((ref = this) === null || ref === void 0 ? void 0 : ref.showcase)) return [
                        3,
                        4
                    ];
                    preventAction = preventTagAction.bind(this);
                    return [
                        4,
                        preventAction(sid, {
                            navigation: false
                        })
                    ];
                case 1:
                    _state.sent();
                    // eslint-disable-next-line no-console
                    return [
                        4,
                        this.showcase.Mattertag.navigateToTag(sid, this.showcase.Mattertag.Transition.FLY).catch(console.error)
                    ];
                case 2:
                    _state.sent();
                    return [
                        4,
                        preventAction(sid, {
                            navigation: true
                        })
                    ];
                case 3:
                    _state.sent();
                    _state.label = 4;
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return _navigateToTag.apply(this, arguments);
}
function loadModel(name, url, type, tag, panoramaId) {
    return _loadModel.apply(this, arguments);
}
function _loadModel() {
    _loadModel = (0,_async_to_generator/* default */.Z)(function(name, url, type, tag, panoramaId) {
        var changeMinimap, changePanorama, iframeSettings, changeReel, _this, products, tour, segments, lastSeg, _lastSeg, slug, sameTour, _this1, ref, ref1, ref2, target, currentSID, targetPosition, closestSweep, targetSID, ref3, distance, inDistance, ref4, intervalID, ref5, currentSID1, targetSID1;
        var _arguments = arguments;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    changeMinimap = _arguments.length > 5 && _arguments[5] !== void 0 ? _arguments[5] : true, changePanorama = _arguments.length > 6 && _arguments[6] !== void 0 ? _arguments[6] : false, iframeSettings = _arguments.length > 7 && _arguments[7] !== void 0 ? _arguments[7] : {}, changeReel = _arguments.length > 8 && _arguments[8] !== void 0 ? _arguments[8] : false;
                    _this = this;
                    console.log("URL", url);
                    if (!(type === Menu/* MenuType.Tab */.o.Tab)) return [
                        3,
                        1
                    ];
                    window.open(url);
                    return [
                        3,
                        9
                    ];
                case 1:
                    if (!(type === Menu/* MenuType.Popup */.o.Popup)) return [
                        3,
                        2
                    ];
                    this.toggleExternalPopup(url);
                    return [
                        3,
                        9
                    ];
                case 2:
                    if (!(type === Menu/* MenuType.Iframe */.o.Iframe)) return [
                        3,
                        3
                    ];
                    this.toggleExternalPopup(url, iframeSettings);
                    return [
                        3,
                        9
                    ];
                case 3:
                    if (!(type === Menu/* MenuType.Product */.o.Product && tag !== null)) return [
                        3,
                        4
                    ];
                    products = this.state.products.filter(function(item) {
                        return ((item === null || item === void 0 ? void 0 : item.tags) || []).some(function(productTag) {
                            return productTag.sid === tag;
                        });
                    });
                    if (products && products.length > 0) {
                        this.setState({
                            currentProducts: products.length > 1 ? products : [],
                            currentProduct: products.length === 1 ? products[0] : null
                        });
                    }
                    navigateToTag(tag);
                    window.location.hash = tag;
                    return [
                        3,
                        9
                    ];
                case 4:
                    if (!(type === Menu/* MenuType.Panorama */.o.Panorama)) return [
                        3,
                        5
                    ];
                    this.setState({
                        panoramaOn: true,
                        activePano: panoramaId
                    });
                    return [
                        3,
                        9
                    ];
                case 5:
                    if (!(type === Menu/* MenuType.Treedis */.o.Treedis)) return [
                        3,
                        8
                    ];
                    if (!(window.top !== window.self)) return [
                        3,
                        7
                    ];
                    window.top.postMessage({
                        type: "tourLink",
                        url: url
                    }, "*");
                    // so the parent window can handle the link
                    return [
                        4,
                        new Promise(function(resolve) {
                            return setTimeout(resolve, 100);
                        })
                    ];
                case 6:
                    _state.sent();
                    _state.label = 7;
                case 7:
                    if (url.includes("/experience/")) {
                        window.location.href = url;
                        return [
                            2
                        ];
                    }
                    tour = this.state.tour;
                    segments = url.split("/");
                    lastSeg = segments[segments.length - 1].split("?");
                    _lastSeg = (0,_sliced_to_array/* default */.Z)(lastSeg, 1), slug = _lastSeg[0];
                    sameTour = tour.slug === slug;
                    if (sameTour && lastSeg.length === 1) return [
                        2
                    ]; // same tour, no query params, we shouldn't get it again
                    if (url.includes("matterport.com")) {
                        react_toastify_esm/* toast.error */.Am.error("Cannot use this link. To copy location in the tour, please use 'CTRL+Y'");
                        return [
                            2
                        ];
                    }
                    _this1 = this;
                    // if isVSReady is true, then VS is configured (VS components, lights etc.) - can't init VS without it
                    // don't need to configure that if it's the same tour
                    this.setState({
                        panoramaOn: false,
                        activePano: null,
                        isVSReady: sameTour
                    }, /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
                        return (0,tslib_es6.__generator)(this, function(_state) {
                            _this1.getTour({
                                slug: slug,
                                changeMenu: false,
                                changeMinimap: changeMinimap,
                                changePanorama: changePanorama,
                                changeReel: changeReel,
                                url: url,
                                hideIntroScreen: true
                            }); // false = dont change the menu/panorama
                            // change url to detect tour analytic from menu
                            window.history.pushState({}, "", url);
                            return [
                                2
                            ];
                        });
                    }));
                    return [
                        3,
                        9
                    ];
                case 8:
                    if (type === Menu/* MenuType.MatterportInstant */.o.MatterportInstant) {
                        this.setState({
                            isChangeIframe: this.state.iframeUrl.matterId !== (0,util_all/* getQueryVariable */.Dv)(url, "m")
                        }, function() {
                            var ref, ref1;
                            _this.moveModel("/mp-sdk/".concat("24.2.1", "/showcase.html?applicationKey=").concat((ref = _this.state.tour) === null || ref === void 0 ? void 0 : (ref1 = ref.user) === null || ref1 === void 0 ? void 0 : ref1.mpSDK).concat((0,util_all/* getAllQueryVariables */.i1)(url)), false, true);
                        });
                    } else if (type === Menu/* MenuType.Tag */.o.Tag && tag !== null) {
                        ;
                        target = Array.from(this.state.allTags, function(param) {
                            var _param = (0,_sliced_to_array/* default */.Z)(param, 2), value = _param[1];
                            return value;
                        })// searching by temporary sid from Matterport
                        .find(function(item) {
                            return item.sid === tag || item.defaultSid === tag;
                        });
                        if ((target === null || target === void 0 ? void 0 : (ref = target.media) === null || ref === void 0 ? void 0 : ref.type) === "video" || (target === null || target === void 0 ? void 0 : target.type) === "video") {
                            audioHandler.pauseAllMusic();
                            this.setState({
                                tourAudioPlaying: false
                            });
                        }
                        if (!target) {
                            react_toastify_esm/* toast.error */.Am.error("Cannot find the tag on the tour");
                            return [
                                2
                            ];
                        }
                        currentSID = this.state.currentSweep.sid || this.state.currentSweep.sweep || ((ref1 = this.defaultSweep) === null || ref1 === void 0 ? void 0 : ref1.sid);
                        targetPosition = {
                            x: target.positionX,
                            y: target.positionY,
                            z: target.positionZ
                        };
                        closestSweep = this.state.sweeps.reduce(function(closest, sweep) {
                            if (sweep.floor_index === target.floor) {
                                var distance = (0,getDistance/* getDistance */.S)(sweep.position, targetPosition);
                                if (closest.distance === null || distance < closest.distance) {
                                    return {
                                        sweep: sweep,
                                        distance: distance
                                    };
                                }
                            }
                            return closest;
                        }, {
                            sweep: null,
                            distance: Infinity
                        }).sweep;
                        if (!closestSweep) {
                            console.warn("No sweep found on the same floor. Defaulting to closest sweep on any floor.");
                            closestSweep = this.state.sweeps.reduce(function(closest, sweep) {
                                var distance = (0,getDistance/* getDistance */.S)(sweep.position, targetPosition);
                                if (closest.distance === null || distance < closest.distance) {
                                    return {
                                        sweep: sweep,
                                        distance: distance
                                    };
                                }
                                return closest;
                            }, {
                                sweep: null,
                                distance: Infinity
                            }).sweep;
                        }
                        targetSID = closestSweep ? closestSweep.sid : null;
                        if (!currentSID || !targetSID) {
                            console.error("Current or Target sweep not found");
                            return [
                                2
                            ];
                        }
                        if (!this.pathFinderLine) {
                            console.error("PathFinder Line is not defined");
                            return [
                                2
                            ];
                        }
                        if (!target.navigationEnabled || target.AROnly) {
                            ;
                            if (((ref3 = this.pathFinderLine.targetObjectData) === null || ref3 === void 0 ? void 0 : ref3.id) === target.id) {
                                this.pathFinderLine.reset();
                                this.pathFinderLine.setActionPathNavbarVisible(false);
                            }
                            this.setState({
                                panoramaOn: false
                            }, function() {
                                _this.moveToTagIO(target, false);
                            });
                            return [
                                2
                            ];
                        }
                        distance = (0,getDistance/* getDistance */.S)(this.pose.position, targetPosition);
                        inDistance = distance < 3 && (this.state.currentFloor === target.floor || this.state.currentFloor === null) && this.currentSweep.id !== "";
                        if (inDistance) {
                            this.pathFinderLine.reset();
                            this.pathFinderLine.setActionPathNavbarVisible(false);
                            this.setState({
                                panoramaOn: false
                            }, function() {
                                _this.moveToTagIO(target, false);
                            });
                            return [
                                2
                            ];
                        }
                        this.setState({
                            actionPathNavbarData: {
                                enableNavBar: target.enableNavBar,
                                destinationTitle: target.title,
                                icon: target.iconFile ? "".concat("https://cdn.treedis.com", "/tours/").concat(target.tourId, "/tags/icons/").concat(target.iconFile) : null,
                                autoNavigation: target.autoNavigation,
                                enableTeleportBtn: target.enableTeleportBtn
                            }
                        });
                        if (this.state.tourMode === this.showCaseTemp.showcase.Mode.Mode.DOLLHOUSE || this.state.tourMode === this.showCaseTemp.showcase.Mode.Mode.FLOORPLAN) {
                            this.setActionPathNavbarPlayButtonType("Play");
                            this.pathFinderLine.update(this.prevSweep.id, targetSID, name, target);
                            return [
                                2
                            ];
                        }
                        if (target.autoNavigation) {
                            ;
                            if (target.navigationAutoPlay && ((ref4 = this.pathFinderLine.targetObjectData) === null || ref4 === void 0 ? void 0 : ref4.id) !== target.id) {
                                if (this.currentSweep.id === "") {
                                    intervalID = setInterval(function() {
                                        if (_this.currentSweep.id !== "") {
                                            _this.setActionPathNavbarPlayButtonType("Pause");
                                            _this.pathFinderLine.update(_this.currentSweep.id, targetSID, name, target).then(function() {
                                                _this.pathFinderLine.autoNavigateCurrentPath(null, // eslint-disable-next-line @typescript-eslint/no-empty-function
                                                function() {}, function() {
                                                    _this.pathFinderLine.inAutoNavigate = false;
                                                    _this.setActionPathNavbarPlayButtonType("Play");
                                                }).catch(function(e) {
                                                    return console.error(e);
                                                });
                                            });
                                            clearInterval(intervalID);
                                        }
                                    }, 250);
                                } else {
                                    this.setActionPathNavbarPlayButtonType("Pause");
                                    this.pathFinderLine.update(currentSID, targetSID, name, target).then(function() {
                                        _this.pathFinderLine.autoNavigateCurrentPath(null, // eslint-disable-next-line @typescript-eslint/no-empty-function
                                        function() {}, function() {
                                            _this.pathFinderLine.inAutoNavigate = false;
                                            _this.setActionPathNavbarPlayButtonType("Play");
                                        }).catch(function(e) {
                                            return console.error(e);
                                        });
                                    });
                                }
                            } else {
                                this.setActionPathNavbarPlayButtonType("Play");
                                this.pathFinderLine.update(currentSID, targetSID, name, target).then(function() {
                                    _this.pathFinderLine.rotateCameraToPathDirection();
                                });
                            }
                            return [
                                2
                            ];
                        }
                        if (((ref2 = this.pathFinderLine.targetObjectData) === null || ref2 === void 0 ? void 0 : ref2.id) !== target.id) {
                            this.setActionPathNavbarPlayButtonType("Play");
                            this.pathFinderLine.update(currentSID, targetSID, name, target).then(function() {
                                _this.pathFinderLine.rotateCameraToPathDirection();
                            });
                        } else {
                            return [
                                2
                            ];
                        }
                    } else if (type === Menu/* MenuType.NavigationPath */.o.NavigationPath) {
                        ;
                        currentSID1 = this.state.currentSweep.sid || this.state.currentSweep.sweep || ((ref5 = this.defaultSweep) === null || ref5 === void 0 ? void 0 : ref5.sid);
                        targetSID1 = (0,extractSweepIdFromURL/* extractSweepIdFromURL */.D)(url);
                        if (!currentSID1) {
                            console.error("Current sweep not found");
                            return [
                                2
                            ];
                        }
                        if (!targetSID1) {
                            console.error("Target sweep not found");
                            return [
                                2
                            ];
                        }
                        if (this.pathFinderLine) {
                            if (this.pathFinderLine.targetSID !== targetSID1) this.pathFinderLine.update(currentSID1, targetSID1, name);
                            else {
                                this.pathFinderLine.reset();
                            }
                        }
                    } else if (type !== Menu/* MenuType.Category */.o.Category) {
                        this.setState({
                            isChangeIframe: this.state.iframeUrl.matterId !== (0,util_all/* getQueryVariable */.Dv)(url, "m")
                        }, function() {
                            var ref, ref1;
                            _this.moveModel("/mp-sdk/".concat("24.2.1", "/showcase.html?applicationKey=").concat((ref = _this.state.tour) === null || ref === void 0 ? void 0 : (ref1 = ref.user) === null || ref1 === void 0 ? void 0 : ref1.mpSDK).concat((0,util_all/* getAllQueryVariables */.i1)(url)), false, false);
                        });
                    }
                    _state.label = 9;
                case 9:
                    // DISabling GA for now
                    // if (name) {
                    //   sendToGA('event', {
                    //     eventCategory: 'Place',
                    //     eventAction: 'click',
                    //     eventLabel: name,
                    //   });
                    // }
                    if (name && this.state.chatToken && socket/* default */.Z && socket/* default.connected */.Z.connected && this.state.host) {
                        socket/* default.emit */.Z.emit("menu", {
                            menu: {
                                name: name,
                                url: url,
                                type: type
                            }
                        });
                    }
                    return [
                        2
                    ];
            }
        });
    });
    return _loadModel.apply(this, arguments);
}
function openedPanoHotspot(hotspot) {
    return _openedPanoHotspot.apply(this, arguments);
}
function _openedPanoHotspot() {
    _openedPanoHotspot = (0,_async_to_generator/* default */.Z)(function(hotspot) {
        var ref, ref1, ref2, ref3, windowSegments, segments, slug, hubRegex, gameOrVcommerceRegex, isHubUrl, isGameOrVCommerce, room, tourSlug, tour, changeMinimap, _this, tour1, ref4, noAudioMode;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (this.state.appState !== "playing") {
                        react_toastify_esm/* toast.info */.Am.info("Please wait for the tour to load");
                        return [
                            2
                        ];
                    }
                    if (hotspot.type === Tag/* TagType.Matterport */.Qy.Matterport && hotspot.url) {
                        ;
                        this.moveModel("/mp-sdk/".concat("24.2.1", "/showcase.html?applicationKey=").concat((ref = this.state.tour) === null || ref === void 0 ? void 0 : (ref1 = ref.user) === null || ref1 === void 0 ? void 0 : ref1.mpSDK).concat((0,util_all/* getAllQueryVariables */.i1)(hotspot.url)), false, true);
                        return [
                            2
                        ];
                    }
                    if (hotspot.type === Tag/* TagType.MatterportInstant */.Qy.MatterportInstant && hotspot.url) {
                        ;
                        this.moveModel("/mp-sdk/".concat("24.2.1", "/showcase.html?applicationKey=").concat((ref2 = this.state.tour) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.user) === null || ref3 === void 0 ? void 0 : ref3.mpSDK).concat((0,util_all/* getAllQueryVariables */.i1)(hotspot.url)), false, false);
                        return [
                            2
                        ];
                    }
                    if (!(hotspot.type === Tag/* TagType.Treedis */.Qy.Treedis && hotspot.url)) return [
                        3,
                        2
                    ];
                    windowSegments = window.location.href.split("/");
                    segments = hotspot.url.split("/");
                    slug = hotspot.url.includes("?") ? segments[segments.length - 1].split("?")[0] : segments[4];
                    hubRegex = /(^|[^a-z])(host|guest)([^a-z]|$)/i;
                    gameOrVcommerceRegex = /(^|[^a-z])(experience|e-commerce-tour)([^a-z]|$)/i;
                    isHubUrl = hubRegex.test(hotspot.url);
                    isGameOrVCommerce = gameOrVcommerceRegex.test(hotspot.url);
                    room = isHubUrl ? segments[segments.length - 1] : this.state.room || null;
                    if ((0,util_all/* getQueryVariable */.Dv)(hotspot.url, "m")) {
                        react_toastify_esm/* toast.error */.Am.error("Can't use this link, to copy location in treedis tour, use CTRL+Y");
                        return [
                            2
                        ];
                    }
                    if (isGameOrVCommerce) {
                        tourSlug = windowSegments.pop().split("?")[0];
                        if (tourSlug !== slug) {
                            window.location.assign(hotspot.url);
                            return [
                                2
                            ];
                        }
                    }
                    tour = this.state.tour;
                    changeMinimap = tour && !tour.customMinimap;
                    return [
                        4,
                        this.getTour({
                            slug: slug,
                            changeMenu: false,
                            changeMinimap: changeMinimap,
                            changePanorama: false,
                            url: hotspot.url
                        })
                    ];
                case 1:
                    _state.sent(); // false = dont change the menu/panorama
                    if (!socket/* default.connected */.Z.connected && isHubUrl) {
                        socket/* default.open */.Z.open();
                    }
                    _this = this;
                    this.setState({
                        panoramaOn: tour.slug !== slug,
                        activePano: null,
                        isVSReady: false,
                        room: room,
                        interacted: true
                    }, /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
                        return (0,tslib_es6.__generator)(this, function(_state) {
                            if (_this.state.room && socket/* default */.Z && socket/* default.connected */.Z.connected && _this.state.host) {
                                socket/* default.emit */.Z.emit("pano-hotspot-click", {
                                    id: slug,
                                    changeMenu: false,
                                    changeMinimap: changeMinimap,
                                    changePanorama: false,
                                    url: hotspot.url
                                });
                            }
                            return [
                                2
                            ];
                        });
                    }));
                    return [
                        2
                    ];
                case 2:
                    if (!(hotspot.type === Tag/* TagType.Music */.Qy.Music && hotspot.url)) return [
                        3,
                        4
                    ];
                    tour1 = this.state.tour;
                    if (tour1.noAudioMode && this.state.chatToken) return [
                        2
                    ];
                    return [
                        4,
                        audioHandler.playAudio({
                            type: AudioModule/* MusicObj.PANORAMAS */.nR.PANORAMAS,
                            id: hotspot.defaultId
                        })
                    ];
                case 3:
                    _state.sent();
                    return [
                        2
                    ];
                case 4:
                    if (hotspot.type === Tag/* TagType.Video */.Qy.Video && hotspot.url) {
                        ;
                        noAudioMode = ((ref4 = this.state) === null || ref4 === void 0 ? void 0 : ref4.tour).noAudioMode;
                        hotspot.url = (0,util_all/* getVideoLink */.rp)(hotspot.url, {
                            mute: noAudioMode && this.state.chatToken
                        });
                        audioHandler.pauseAllMusic();
                    }
                    this.setState({
                        panoPopOn: true,
                        openedPanoHotspot: hotspot
                    });
                    return [
                        2
                    ];
            }
        });
    });
    return _openedPanoHotspot.apply(this, arguments);
}
function openTagIframe(sid, options) {
    return _openTagIframe.apply(this, arguments);
}
function _openTagIframe() {
    _openTagIframe = (0,_async_to_generator/* default */.Z)(function(sid, options) {
        var _this, _state, allTags, tour, tourType, ref, _skipEmbedMediaCheck, skipEmbedMediaCheck, foundTag, tag, ref1, segmants, lastSeg, slug, changeMinimap, _this1, ref2, ref3, ref4, ref5, ref6, noAudioMode, ref7, ref8, noAudioMode1, vsVideos, ref9;
        return (0,tslib_es6.__generator)(this, function(_state1) {
            switch(_state1.label){
                case 0:
                    _this = this;
                    _state = this.state, allTags = _state.allTags, tour = _state.tour, tourType = _state.tourType;
                    ref = options || {}, _skipEmbedMediaCheck = ref.skipEmbedMediaCheck, skipEmbedMediaCheck = _skipEmbedMediaCheck === void 0 ? false : _skipEmbedMediaCheck;
                    foundTag = Array.from(allTags, function(param) {
                        var _param = (0,_sliced_to_array/* default */.Z)(param, 2), value = _param[1];
                        return value;
                    })// searching by temporary sid from Matterport
                    .find(function(item) {
                        return item.sid === sid || item.defaultSid === sid;
                    });
                    if (!foundTag) return [
                        3,
                        3
                    ];
                    if (!foundTag.enabled || !foundTag.type) return [
                        2,
                        null
                    ];
                    tag = (0,_object_spread/* default */.Z)({}, foundTag);
                    // Allow tag.type with NONE who participate in game actions like chapter, lock
                    if ((tour === null || tour === void 0 ? void 0 : tour.gameId) && tourType === Tour/* TourType.Game */.v.Game) {
                        this.unlockChapter(tag, GameBook/* ChapterType.Tag */._U.Tag);
                        if (this.handleTagLock(tag)) return [
                            2,
                            null
                        ];
                    } else if (tour === null || tour === void 0 ? void 0 : tour.gameId) {
                        this.setState({
                            clickedElement: {
                                id: tag.id,
                                sid: tag.sid,
                                defaultSid: tag.defaultSid,
                                type: Game/* EntityType.Tag */.py.Tag
                            }
                        });
                    }
                    if ((tag === null || tag === void 0 ? void 0 : tag.type) === Tag/* TagType.None */.Qy.None) {
                        return [
                            2,
                            null
                        ];
                    }
                    if ((tag === null || tag === void 0 ? void 0 : tag.type) === Tag/* TagType.Navigation */.Qy.Navigation) {
                        ;
                        if ((ref1 = this.state.tour) === null || ref1 === void 0 ? void 0 : ref1.showNavTools) {
                            processNavigationPath({
                                tagNavigationLink: tag.navigationLink,
                                sweeps: this.state.sweeps,
                                startSweep: this.pose.sweep,
                                cb: function(param) {
                                    var sweepsPath = param.sweepsPath, rotation = param.rotation;
                                    var _tour = _this.state.tour, rotationAngle = _tour.rotationAngle, rotationSpeed = _tour.rotationSpeed, transitionSpeed = _tour.transitionSpeed, stopAfterSweep = _tour.stopAfterSweep;
                                    moveToSweeps({
                                        sweepsPath: sweepsPath,
                                        targetRotation: rotation,
                                        rotationAngle: rotationAngle,
                                        rotationSpeed: rotationSpeed,
                                        transitionSpeed: transitionSpeed,
                                        stopAfterSweep: stopAfterSweep,
                                        poseRotation: _this.pose.rotation,
                                        showcaseSweep: _this.showcase.Sweep
                                    }).then(function() {
                                        _this.setState({
                                            showPathFinderPopup: true
                                        });
                                    });
                                }
                            });
                        }
                        return [
                            2,
                            null
                        ];
                    }
                    if (!skipEmbedMediaCheck && tag.embedMedia && [
                        Tag/* TagType.Image */.Qy.Image,
                        Tag/* TagType.Video */.Qy.Video,
                        Tag/* TagType.Iframe */.Qy.Iframe,
                        Tag/* TagType.Text */.Qy.Text
                    ].includes(tag.type)) {
                        return [
                            2,
                            null
                        ];
                    }
                    if (tag.type === Tag/* TagType.Panorama */.Qy.Panorama) {
                        this.setState({
                            activePano: tag.panoramaId,
                            panoramaOn: true
                        });
                        return [
                            2,
                            null
                        ];
                    }
                    if (tag.type === Tag/* TagType.Treedis */.Qy.Treedis && tag.url) {
                        segmants = tag.url.split("/");
                        lastSeg = segmants[segmants.length - 1].split("?");
                        slug = lastSeg[0];
                        if (tour.slug === slug && lastSeg.length === 1) return [
                            2,
                            null
                        ]; // same tour, no query params, we shouldn't get it again
                        if ((0,util_all/* getQueryVariable */.Dv)(tag.url, "m")) {
                            react_toastify_esm/* toast.error */.Am.error("Cannot use this link. To copy location in the tour, please use 'CTRL+Y'");
                            return [
                                2,
                                null
                            ];
                        }
                        changeMinimap = tour && !tour.customMinimap;
                        _this1 = this;
                        // isVSReady - the VS should be initialized again
                        this.setState({
                            panoramaOn: false,
                            activePano: null,
                            isVSReady: false
                        }, /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
                            return (0,tslib_es6.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        return [
                                            4,
                                            _this1.stopVS()
                                        ];
                                    case 1:
                                        _state.sent();
                                        _this1.modelNodes = [];
                                        _this1.vsObjects = [];
                                        _this1.getTour({
                                            slug: slug,
                                            changeMenu: false,
                                            changeMinimap: changeMinimap,
                                            changePanorama: false,
                                            url: tag.url,
                                            hideIntroScreen: true
                                        }); // false = dont change the menu/panorama
                                        return [
                                            2
                                        ];
                                }
                            });
                        }));
                        return [
                            2,
                            null
                        ];
                    }
                    if (tag.type === Tag/* TagType.MatterportInstant */.Qy.MatterportInstant && tag.url) {
                        ;
                        this.moveModel("/mp-sdk/".concat("24.2.1", "/showcase.html?applicationKey=").concat((ref2 = this.state.tour) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.user) === null || ref3 === void 0 ? void 0 : ref3.mpSDK).concat((0,util_all/* getAllQueryVariables */.i1)(tag.url)), false, true);
                        return [
                            2,
                            null
                        ];
                    }
                    if (tag.type === Tag/* TagType.Matterport */.Qy.Matterport && tag.url) {
                        ;
                        this.moveModel("/mp-sdk/".concat("24.2.1", "/showcase.html?applicationKey=").concat((ref4 = this.state.tour) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.user) === null || ref5 === void 0 ? void 0 : ref5.mpSDK).concat((0,util_all/* getAllQueryVariables */.i1)(tag.url)), false, false);
                        return [
                            2,
                            null
                        ];
                    }
                    if (tag.type === Tag/* TagType.Menu */.Qy.Menu) {
                        this.setState({
                            menuOpen: false,
                            activeMenu: null
                        }, function() {
                            _this.setState({
                                menuOpen: true,
                                menuOpened: true,
                                activeMenu: {
                                    id: tag.menuId,
                                    subMenu: tag.subMenuId,
                                    subSubMenu: tag.subSubMenuId
                                }
                            });
                        });
                        return [
                            2,
                            null
                        ];
                    }
                    if (tag.type === Tag/* TagType.Video */.Qy.Video && tag.url) {
                        ;
                        noAudioMode = ((ref6 = this.state) === null || ref6 === void 0 ? void 0 : ref6.tour).noAudioMode;
                        tag.url = (0,util_all/* getVideoLink */.rp)(tag.url, {
                            mute: noAudioMode && this.state.chatToken,
                            autoplay: tag.autoPlay
                        });
                        audioHandler.pauseAllMusic();
                    }
                    if (tag.type === Tag/* TagType.Tab */.Qy.Tab && tag.url) {
                        window.open(tag.url);
                        return [
                            2,
                            null
                        ];
                    }
                    if (!(tag.type === Tag/* TagType.Music */.Qy.Music && tag.url)) return [
                        3,
                        2
                    ];
                    noAudioMode1 = ((ref7 = this.state) === null || ref7 === void 0 ? void 0 : ref7.tour).noAudioMode;
                    if (noAudioMode1 && this.state.chatToken) return [
                        2,
                        null
                    ];
                    vsVideos = (ref8 = this.vsObjects) === null || ref8 === void 0 ? void 0 : ref8.filter(function(obj) {
                        var ref;
                        return ((ref = obj.node) === null || ref === void 0 ? void 0 : ref.componentType) === VideoRenderer_component/* videoRendererType */.Im;
                    });
                    vsVideos === null || vsVideos === void 0 ? void 0 : vsVideos.forEach(function(obj) {
                        var _node = obj.node, vsVideo = _node.video, muteBtn = _node.muteBtn;
                        if (muteBtn && !muteBtn.active) {
                            vsVideo.muted = true;
                            muteBtn.active = true;
                            muteBtn.makeBtn(muteBtn.inputs.src);
                        }
                    });
                    return [
                        4,
                        audioHandler.playAudio({
                            type: AudioModule/* MusicObj.TAGS */.nR.TAGS,
                            id: tag.id
                        })
                    ];
                case 1:
                    _state1.sent();
                    return [
                        2,
                        null
                    ];
                case 2:
                    if (tag.type === Tag/* TagType.VideoChat */.Qy.VideoChat) {
                        this.setState({
                            videoChatTagPopOn: true,
                            openedTag: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, tag), {
                                sid: tag.sid
                            })
                        });
                        audioHandler.pauseAllMusic();
                        return [
                            2,
                            null
                        ];
                    }
                    if (tag.type === Tag/* TagType.ExperiencePopUp */.Qy.ExperiencePopUp) {
                        ;
                        this.setState({
                            tourMusicWasPaused: true,
                            sweepMusicWasPaused: true,
                            experiencePopUpIsOpen: true,
                            closedElementPopup: false,
                            experiencePopUpData: {
                                title: tag === null || tag === void 0 ? void 0 : tag.popupTitle,
                                url: tag === null || tag === void 0 ? void 0 : tag.actionURL,
                                description: tag === null || tag === void 0 ? void 0 : tag.text,
                                defaultImageUrl: "",
                                prefixImageUrl: "/tours/".concat((ref9 = this.state.tour) === null || ref9 === void 0 ? void 0 : ref9.id, "/tags/"),
                                rotation: tag === null || tag === void 0 ? void 0 : tag.rotation,
                                backgroundColor: tag === null || tag === void 0 ? void 0 : tag.backgroundColor,
                                backgroundOpacity: tag === null || tag === void 0 ? void 0 : tag.backgroundOpacity,
                                textColor: tag === null || tag === void 0 ? void 0 : tag.textColor,
                                buttonColor: tag === null || tag === void 0 ? void 0 : tag.buttonColor
                            }
                        });
                        return [
                            2,
                            null
                        ];
                    }
                    this.setState({
                        tagPopOn: true,
                        openedTag: tag,
                        closedElementPopup: false
                    });
                    return [
                        2,
                        tag
                    ];
                case 3:
                    return [
                        2,
                        null
                    ];
            }
        });
    });
    return _openTagIframe.apply(this, arguments);
}
function moveToMPLabels(menu) {
    return _moveToMPLabels.apply(this, arguments);
}
function _moveToMPLabels() {
    _moveToMPLabels = (0,_async_to_generator/* default */.Z)(function(menu) {
        var type, labelId, floorId, _state, mpLabels, sweeps, mpFloors, THREE, floorIndex, label, sweepsOnFloor, startPoint, distances, sweepsWithMinDistance, e;
        return (0,tslib_es6.__generator)(this, function(_state1) {
            switch(_state1.label){
                case 0:
                    type = menu.type, labelId = menu.labelId, floorId = menu.floorId;
                    _state = this.state, mpLabels = _state.mpLabels, sweeps = _state.sweeps, mpFloors = _state.mpFloors;
                    return [
                        4,
                        (0,dist/* iTHREE */.Sc)()
                    ];
                case 1:
                    THREE = _state1.sent();
                    _state1.label = 2;
                case 2:
                    _state1.trys.push([
                        2,
                        10,
                        ,
                        11
                    ]);
                    switch(type){
                        case Menu/* MenuType.MatterportFloor */.o.MatterportFloor:
                            return [
                                3,
                                3
                            ];
                        case Menu/* MenuType.MatterportLabel */.o.MatterportLabel:
                            return [
                                3,
                                6
                            ];
                    }
                    return [
                        3,
                        8
                    ];
                case 3:
                    floorIndex = mpFloors.findIndex(function(l) {
                        return String(l.id) === String(floorId);
                    });
                    return [
                        4,
                        this.changeViewMode(Tour/* TourMode.FLOORPLAN */.zz.FLOORPLAN)
                    ];
                case 4:
                    _state1.sent();
                    return [
                        4,
                        this.changeFloor(floorIndex)
                    ];
                case 5:
                    _state1.sent();
                    return [
                        3,
                        9
                    ];
                case 6:
                    label = mpLabels.find(function(l) {
                        return l.sid === labelId;
                    });
                    if (!label) console.error("Label not found");
                    sweepsOnFloor = sweeps.filter(function(x) {
                        return x.floorInfo.id === label.floorInfo.id && x.enabled;
                    });
                    if (sweepsOnFloor.length === 0) console.error("Sweeps not found");
                    startPoint = new THREE.Vector3(label.position.x, label.position.y, label.position.z);
                    distances = sweepsOnFloor.map(function(sweep) {
                        var endPoint = new THREE.Vector3(sweep.position.x, sweep.position.y, sweep.position.z);
                        var distance = Math.abs(startPoint.distanceTo(endPoint));
                        return (0,_object_spread/* default */.Z)({
                            distance: distance
                        }, sweep);
                    });
                    sweepsWithMinDistance = distances.reduce(function(a, b) {
                        return (a === null || a === void 0 ? void 0 : a.distance) <= (b === null || b === void 0 ? void 0 : b.distance) ? a : b;
                    });
                    // eslint-disable-next-line dot-notation
                    return [
                        4,
                        this.showcase.Sweep.moveTo(sweepsWithMinDistance["id"], {
                            // eslint-disable-next-line dot-notation
                            rotation: sweepsWithMinDistance["rotation"],
                            transition: this.showcase.Mode.TransitionType.FLY
                        })
                    ];
                case 7:
                    _state1.sent();
                    return [
                        3,
                        9
                    ];
                case 8:
                    console.error("moveToMPLabels: Menu type unknown");
                    return [
                        3,
                        9
                    ];
                case 9:
                    return [
                        3,
                        11
                    ];
                case 10:
                    e = _state1.sent();
                    console.error(e);
                    return [
                        3,
                        11
                    ];
                case 11:
                    return [
                        2
                    ];
            }
        });
    });
    return _moveToMPLabels.apply(this, arguments);
}
function openVsObjectIframe(vsObject) {
    return _openVsObjectIframe.apply(this, arguments);
}
function _openVsObjectIframe() {
    _openVsObjectIframe = (0,_async_to_generator/* default */.Z)(function(vsObject) {
        var tour;
        return (0,tslib_es6.__generator)(this, function(_state) {
            tour = this.state.tour;
            if (tour === null || tour === void 0 ? void 0 : tour.gameId) {
                this.unlockChapter(vsObject, GameBook/* ChapterType.VSItem */._U.VSItem);
                if (this.handleVsObjectLock(vsObject, Game/* LockLocationType.vsItem */.A.vsItem)) return [
                    2,
                    null
                ];
            }
            return [
                2,
                null
            ];
        });
    });
    return _openVsObjectIframe.apply(this, arguments);
}
function openVsImageIframe(vsImage) {
    return _openVsImageIframe.apply(this, arguments);
}
function _openVsImageIframe() {
    _openVsImageIframe = (0,_async_to_generator/* default */.Z)(function(vsImage) {
        var tour;
        return (0,tslib_es6.__generator)(this, function(_state) {
            tour = this.state.tour;
            if (tour === null || tour === void 0 ? void 0 : tour.gameId) {
                this.unlockChapter(vsImage, GameBook/* ChapterType.VSImage */._U.VSImage);
                if (this.handleVsObjectLock(vsImage, Game/* LockLocationType.vsImage */.A.vsImage)) return [
                    2,
                    null
                ];
            }
            return [
                2,
                null
            ];
        });
    });
    return _openVsImageIframe.apply(this, arguments);
}
function openVsVideoIframe(vsVideo) {
    return _openVsVideoIframe.apply(this, arguments);
}
function _openVsVideoIframe() {
    _openVsVideoIframe = (0,_async_to_generator/* default */.Z)(function(vsVideo) {
        var tour;
        return (0,tslib_es6.__generator)(this, function(_state) {
            tour = this.state.tour;
            if (tour === null || tour === void 0 ? void 0 : tour.gameId) {
                this.unlockChapter(vsVideo, GameBook/* ChapterType.VSVideo */._U.VSVideo);
                if (this.handleVsObjectLock(vsVideo, Game/* LockLocationType.vsVideo */.A.vsVideo)) return [
                    2,
                    null
                ];
            }
            return [
                2,
                null
            ];
        });
    });
    return _openVsVideoIframe.apply(this, arguments);
}


/***/ }),

/***/ 13607:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// eslint-disable-next-line @typescript-eslint/no-var-requires
var io = (__webpack_require__(57046).io);
var socketsURI = "https://sockets.treedis.com" || 0;
var socket = io(socketsURI, {
    transports: [
        "websocket"
    ],
    autoConnect: false
});
socket.on("connect_error", function(err) {
    // eslint-disable-next-line no-console
    console.error(err);
});
/* harmony default export */ __webpack_exports__["Z"] = (socket);


/***/ }),

/***/ 24069:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U_": function() { return /* binding */ calculateMobileHeight; }
/* harmony export */ });
/* unused harmony exports customSelectStyles, newEcommerceStyles, ecommerceDefaultColorBlackSelect */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(69396);


var customSelectStyles = {
    control: function(provided) {
        return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, provided), {
            minHeight: 38,
            borderRadius: 0,
            maxHeight: "40px",
            height: "40px",
            borderColor: "#D9EAEC",
            color: "red"
        });
    },
    input: function(provided) {
        return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, provided), {
            height: "100%",
            margin: 0,
            padding: 0,
            color: "green"
        });
    },
    indicatorSeparator: function() {
        return {
            display: "none",
            color: "blue"
        };
    },
    indicatorsContainer: function(provided) {
        return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, provided), {
            height: "40px"
        });
    },
    singleValue: function(provided) {
        return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, provided), {
            fontWeight: "normal",
            cursor: "pointer",
            transform: "none",
            border: "none",
            top: "0",
            height: "40px",
            lineHeight: "40px"
        });
    },
    valueContainer: function(provided) {
        return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, provided), {
            height: "40px",
            color: "red"
        });
    },
    placeholder: function(base) {
        return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, base), {
            display: "none",
            color: "red"
        });
    }
};
var newEcommerceStyles = {
    control: function(provided, props) {
        var styles = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, provided), {
            minHeight: 38,
            borderRadius: 0,
            maxHeight: "40px",
            height: "40px"
        });
        if (props === null || props === void 0 ? void 0 : props.isDisabled) {
            styles.backgroundColor = "rgba(239, 239, 239, 0.3)";
            styles.borderColor = "rgba(239, 239, 239, 0.3)";
        }
        return styles;
    },
    input: function(provided) {
        return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, provided), {
            height: "100%",
            margin: 0,
            padding: 0,
            color: "black"
        });
    },
    indicatorSeparator: function() {
        return {
            display: "none"
        };
    },
    indicatorsContainer: function(provided) {
        return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, provided), {
            height: "40px"
        });
    },
    singleValue: function(provided) {
        return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, provided), {
            fontWeight: "normal",
            cursor: "pointer",
            transform: "none",
            border: "none",
            top: "0",
            height: "40px",
            lineHeight: "40px",
            color: "black"
        });
    },
    valueContainer: function(provided) {
        return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, provided), {
            height: "40px"
        });
    },
    placeholder: function(base) {
        return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, base);
    },
    option: function(provided) {
        return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, provided), {
            color: "black"
        });
    }
};
var ecommerceDefaultColorBlackSelect = {
    input: function(provided) {
        return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, provided), {
            color: "black"
        });
    },
    indicatorSeparator: function() {
        return {
            display: "none"
        };
    },
    indicatorsContainer: function(provided) {
        return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, provided), {
            height: "40px"
        });
    },
    singleValue: function(provided) {
        return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, provided), {
            color: "black"
        });
    },
    valueContainer: function(provided) {
        return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, provided), {
            height: "40px"
        });
    },
    placeholder: function(base) {
        return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, base);
    },
    option: function(provided) {
        return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, provided), {
            color: "black"
        });
    }
};
var calculateMobileHeight = function() {
    var vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty("--vh", "".concat(vh, "px"));
};


/***/ }),

/***/ 40897:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "u": function() { return /* binding */ emitter; }
/* harmony export */ });
/* harmony import */ var mitt__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59391);

var emitter = (0,mitt__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)();


/***/ }),

/***/ 33797:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ extractSweepIdFromURL; }
/* harmony export */ });
var extractSweepIdFromURL = function(urlString) {
    var startIndex = urlString.indexOf("s=") + 2;
    var endIndex = urlString.indexOf("&", startIndex);
    if (startIndex >= 2 && endIndex !== -1) {
        return urlString.substring(startIndex, endIndex);
    }
    return null;
};


/***/ }),

/***/ 7926:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ getDistance; }
/* harmony export */ });
var getDistance = function(pos1, pos2) {
    var dx = pos1.x - pos2.x;
    var dy = pos1.y - pos2.y;
    var dz = pos1.z - pos2.z;
    return Math.sqrt(dx * dx + dy * dy + dz * dz);
};


/***/ })

}]);